{
  "LAST_EDITED": "Last edited",
  "VAT": "VAT",
  "CUSTOM": "Custom",
  "LINE": "Line",
  "ADD_REFERENCE_LINE": "Add another invoice reference",
  "UNKNOWN": "Unknown",
  "DISCARD_CHANGES": "Discard changes",
  "ON_BEHALF_OF": "on behalf of",
  "MORE_ALTERNATIVES": "More alternatives",
  "CREATE": "Create",
  "NO_PREFERENCE": "No preference",
  "FILTER": "Filter",
  "NO_FILTERS_AVAILABLE": "No filters available",
  "NO_VALUE": "No value",
  "HAS_VALUE": "Has value",
  "I_AM_DONE": "I'm done",
  "VARIOUS": "Various",
  "NONE": "None",
  "THE_DATE_OR_TIME": "The date or time",
  "TO": "To",
  "SERVICE_FEE": "Service fee",
  "FREE_FOR_LIMITED_TIME": "Free for a limited time",
  "RESET": "Reset",
  "UPLOAD_FILE": "Upload file",
  "TABLE": {
    "COLUMN_PICKER": {
      "TITLE": "Column settings",
      "SHOW_ALL": "Show all",
      "HIDE_ALL": "Hide all"
    }
  },
  "IS": "is",
  "WILL_BE": "will be",
  "WAS": "was",
  "TRANSLATE": "Translate",
  "EXPAND_PARAGRAPH": "Read more",
  "COLLAPSE_PARAGRAPH": "Collapse text",
  "THE_BUILDING": "The building",
  "SORTING_ORDER": "Order",
  "CHRONOLOGICAL": "Chronological",
  "NEWEST": "Newest",
  "OLDEST": "Oldest",
  "CALENDAR": {
    "VIEW": {
      "MONTH": "Month",
      "WEEK": "Week",
      "DAY": "Day"
    }
  },
  "ENABLED": "Enabled",
  "DISABLED": "Disabled",
  "COMING_SOON": "Coming soon",
  "PRICE": "Price",
  "STEP": "Step",
  "NEXT_STEP": "Next step",
  "PREVIOUS_STEP": "Previous step",
  "CLOSED": "Closed",
  "CLOSE": "Close",
  "ALL": "All",
  "SCHEDULER_FOLLOW_TIME": "Follow current time",
  "EXCLUDING_VAT": "exc. VAT",
  "INCLUDING_VAT": "incl. VAT",
  "NEW": "New",
  "NEW_ALT": "New",
  "CHOOSE": "Choose",
  "ALL_DAYS": "All days",
  "DAYS_one": "Day",
  "DAYS_other": "Days",
  "DAYS": "Days",
  "GENERAL": "General",
  "COMBINED": "Combined",
  "GENERAL_SETTINGS": "General settings",
  "DETAILS": "Details",
  "OTHER": "Other",
  "USER_one": "User",
  "USER_other": "Users",
  "FILE": "File",
  "FLOOR": "Floor",
  "PEOPLE_one": "Person",
  "PEOPLE_other": "People",
  "HOURS_one": "Hour",
  "HOURS_other": "Hours",
  "RESULTS_one": "{{count}} result",
  "RESULTS_other": "{{count}} results",
  "ORDER": "Order",
  "PREVIOUS": "Previous",
  "BACK": "Back",
  "NEXT": "Next",
  "DEFAULT_SELECT": {
    "PLACEHOLDER": "Select...",
    "START_SEARCH": "Start typing to search",
    "NO_RESULTS": "No results",
    "SEARCHING": "Searching..."
  },
  "REDIRECT": {
    "HEADER": "We have changed url!",
    "SUB_HEADER": "Please go to"
  },
  "TOTAL": "total",
  "LOGIN_TAGLINE": "Welcome Workdays is used at {{buildingName}} to simplify your workday.",
  "EDIT": "Edit",
  "DELETE": "Delete",
  "ADD": "Add",
  "UPDATE": "Update",
  "USE_DEFAULT": "Use default",
  "LANG_NO": "Norwegian",
  "LANG_EN": "English",
  "YOUR_MAIN_ADMIN": "Your main company administrator is <mailto>{{ companyContact }}</mailto>.",
  "SEARCH": "Search",
  "VISIBLE": "Visible",
  "HIDDEN": "Hidden",
  "HAS_NOT_LOGGED_IN": "Has not logged in",
  "ROWS_PER_PAGE": "Rows per page",
  "OF": "of",
  "OR": "or",
  "MISSING_COUNTRY_CODE": "A country code is required (e.g. +47)",
  "REVERT_CHANGES": "Revert changes",
  "SAVE_CHANGES": "Save changes",
  "CANCEL": "Cancel",
  "CONTINUE": "Continue",
  "SUBMIT": "Submit",
  "EXIT": "Exit",
  "NUMBERS": "digits",
  "CHARACTERS": "characters",
  "THE_TEXT": "Text",
  "YES": "Yes",
  "NO": "No",
  "FROM": "from",
  "NOW": "Now",
  "JUST_NOW": "Just now",
  "MINUTES_one": "Minute",
  "MINUTES_other": "Minutes",
  "MINUTES_AGO_one": "{{count}} minute ago",
  "MINUTES_AGO_other": "{{count}} minutes ago",
  "TODAY": "Today",
  "TOMORROW": "Tomorrow",
  "AT": "at",
  "ARRIVED_one": "Arrived",
  "ARRIVED_other": "Arrived",
  "ANSWER": "Answer",
  "LET_IN": "Let in",
  "VISIBILITY_TOGGLE_DESCRIPTION": "Toggle your visibility in the visitor registration kiosk.",
  "ADMIN_VISIBILITY_TOGGLE_DESCRIPTION": "Toggle the users visibility in the visitor registration kiosk.",
  "YOU": "You",
  "COMPANY": "The company",
  "PORTAL_VERSION": "Portal version: ",
  "SEND": "Send",
  "SMS_SEND": "SMS sendt",
  "OPTIONAL": " (optional)",
  "NOT_INTEGRATED": "User is not integrated with access control system",
  "UNSAVED_CHANGES": {
    "TITLE": "You have unsaved changes!",
    "BODY": "By continuing you will discard the changes you have made. Do you wish to cancel to stay on this page and keep your changes?"
  },
  "ANSWER_VISITOR": {
    "ACCORDION_HEADER": "Send a message",
    "QUICKLY": "Reply with one click",
    "BE_THERE": "I'll be there in",
    "PREDEFINED_MESSAGE_X_MIN": "I will be there in {{minutes}} minutes",
    "CUSTOM_MESSAGE": "Or write a custom message",
    "NO_REPLY_INFO": "The visitor cannot respond",
    "PREFERS_ENGLISH": "The visitor prefers english and cannot respond",
    "DISABLED_DESCRIPTION": "It is outside the buildings opening hours, you can still pick up your visitor yourself.",
    "LABEL": "Custom message",
    "PLACEHOLDER": "Wait for me by",
    "REPLY": "{{ name }} replied",
    "ANOTHER_MESSAGE": "Send another message",
    "SEND_MESSAGE_TOO": "Send a message as well",
    "TIMED_OUT": "This visit is more than one hour old",
    "NO_REPLY": "You didn't reply",
    "NO_REPLY_COMPANY": "No one replied",
    "WAS_LET_IN": "You let in the visitor at",
    "WAS_LET_IN_COMPANY": "The visitor was let in at",
    "LET_IN_VISITOR": "Let in visitor",
    "SEND_ACCESS_CODE": "Send access code that opens the gates",
    "CODE_ALREADY_SENT": "You already sent an access code at",
    "LET_IN": "Let in",
    "LET_IN_SUCCESS": "An access code was sent to the visitor",
    "LET_IN_ERROR": "Failed to send access code to the visitor. Try again later!",
    "ERROR_SENDING_MESSAGE": "We were not able to send an access code to this visitor. Please contact the visitor directly.",
    "ERROR_HEADER": "Something went wrong",
    "CODE_GENERATION_FAILED": "We couldn't generate an access code for this visitor. You can try again once.",
    "SMS_SEND_FAILED": "We couldn't send the access code to the visitor by SMS. Check the phone number and contact the visitor directly.",
    "TRY_AGAIN": "Try again",
    "ALREADY_LET_IN": "This visitor has already been let in.",
    "ALREADY_CHECKED_IN": "This attendee has already been checked in.",
    "LET_IN_IN_PROGRESS": "An access code is already being sent to this visitor. Please wait a moment.",
    "LET_IN_RESULT_NOT_SAVED": "We couldn't confirm that the access code was sent. Please contact the visitor directly.",
    "LET_IN_PROGRESS": {
      "GENERATING": "Generating the access code…",
      "ACTIVATING": "Activating the access code…",
      "SENDING": "Sending the code to the visitor…",
      "TAKING_LONGER": "This is taking a little longer than usual, hang on…"
    }
  },
  "MESSAGE_BODY": "Message from {{hostName}}: {{message}}",
  "IMAGE": {
    "LABEL": "Image",
    "THUMBNAIL": "Thumbnail",
    "NUMBERED": "Image {{number}}",
    "UPLOAD_FAILED_CONFIRM": {
      "TITLE_one": "1 image could not be uploaded",
      "TITLE_other": "{{count}} images could not be uploaded",
      "BODY": "You can save without them, or go back and replace them.",
      "DISCARD": "Save without these images",
      "GO_BACK": "Go back"
    },
    "PLACEHOLDER": {
      "LOGO": "No logo has been uploaded",
      "TEAM": "No team photo has been uploaded",
      "BANNER": "No banner image has been uploaded",
      "PROFILE": "Profile image missing",
      "OWNER_LOGO": "Building owner's logo missing",
      "GENERIC": "Add image(s)"
    },
    "UPLOAD": "Upload image",
    "REPLACE": {
      "ARIA_LABEL": "Replace current image",
      "TEXT": "Upload different image"
    },
    "BACKGROUND_TOGGLE_TEXT": "Background",
    "UNDO": "Undo change",
    "DONE": "Done",
    "CANCEL": "Cancel",
    "FILE_TOO_LARGE": "The file is too large",
    "DROP_ZONE_TEXT": "Drop image to upload",
    "ROTATE_CW": "Rotate clockwise",
    "ROTATE_CCW": "Rotate counter-clockwise",
    "PROFILE_TIPS": "Please make sure the image...<ul><li>Fits the 4:3 aspect ratio</li><li>Has a white/bright background</li><li>Shows your entire face clearly, facing forwards, eyes open, no sunglasses</li></ul>",
    "PROFILE_TIPS_EXTRA": "<ul><li>Please position your face inside the oval</li><li>Face forward with eyes open</li><li>Make sure your entire face is visible (no sunglasses)</li></ul>",
    "GENERATE_WITH_AI": "Generate image with AI",
    "GENERATE_MORE": "Generate more images"
  },
  "PAGES": {
    "BUILDING_CONTACT": {
      "EYEBROW": "Contact info",
      "CLOSE": "Close and go to the home page",
      "NO_ACCESS_TITLE": "No access",
      "NO_ACCESS_BODY": "You do not have access to this building. Sign in with an account that belongs to the building, or contact the property manager.",
      "CONTACTS_ERROR": "We couldn't load the contacts. Please try again in a moment.",
      "PAGE_ERROR": "We couldn't load this page. Please try again in a moment.",
      "TO_DASHBOARD": "Go to the home page"
    },
    "NEWS": {
      "HEADER": "News",
      "SUBHEADER": "Here, you'll find an overview of all news in {{buildingName}}. This includes anything from critical operational messages to special offers for you as an employee in this building.",
      "PLACEHOLDER": "No news here yet!",
      "NEW": {
        "HEADER": "New article",
        "SUBHEADER": "Here, you can create a new article. To accommodate all of the users in the building that may not be well versed in norwegian, we require english translations for all content."
      },
      "EDIT_UNPUBLISHED": {
        "HEADER": "Edit article draft",
        "SUBHEADER": "Since this article has not yet been published, you may edit any of it's details. Note that once the article is published, the editing possibilities may deminish."
      },
      "EDIT_PUBLISHED": {
        "HEADER": "Edit published article",
        "SUBHEADER": "Since this article has already been published, some details cannot be edited."
      }
    },
    "WELCOME": {
      "HEADER": "Welcome to <highlight>{{ buildingName }}</highlight>",
      "GREETING": "<paragraph>Hi <bold>{{ userName }}</bold>,</paragraph><paragraph>{{buildingName}} is owned and managed by {{ownerName}}. We use Welcome Workdays to make your workday a little easier – and hopefully a little better.</paragraph><paragraph>With Welcome Workdays, we provide visitors with a smoother check-in experience, and you can communicate with them via SMS. You can also stay updated on building information and check out the weekly menu in the restaurant. Welcome Workdays will continue to develop more features over time.</paragraph><paragraph>To keep you informed, we need your consent to send you relevant updates. You can manage your preferences anytime via \"My profile\".</paragraph><paragraph>Wishing you a great day at work!</paragraph><regards><paragraph>Best regards,<linebreak /><bold>{{ buildingAdminName }}</bold><linebreak />{{ jobTitle }} at {{ companyName }}</paragraph><signature>{{ signature }}</signature></regards>",
      "CONSENTS": {
        "HEADER": "Consents",
        "GENERAL": "Communication <bold>Receive news and information about the building.</bold><paragraph> We want to keep you up to date about your workplace. By consenting you allow us to send you information, updates and offers via email, SMS and other channels from us, the building owner as well as suppliers such as the restaurant in the building. You can manage your consent in «Profile settings».</paragraph>",
        "DISCLAIMER": "By continuing you accept our <terms>terms of use</terms> and confirm that you have read our <policy>privacy policy</policy>."
      },
      "DECLINE": "Decline",
      "ACCEPT": "Accept",
      "YOUR_CHOICE": "You can revoke your consents at any time",
      "YOU_LOSE": "but be aware that it can limit the offers and information you receive from and about the building. Both Welcome Workdays and the building owner put great care into handling your privacy and data, and always use leading industry standards to your benefit.",
      "MODAL": {
        "HEADER": "Are you sure?",
        "BODY": "You are free to decline consent",
        "DECLINE": "Decline anyway"
      },
      "ACTIVATION_SUCCESS": "Your account was activated. Welcome!",
      "ACTIVATION_ERROR": "Failed to activate your account. Refresh the page and try again!"
    },
    "LUNCH": {
      "TOPUP": {
        "ERROR_CREATING_PAYMENT": "Failed to generate payment. Please try again later!",
        "QUICK_LUNCHES": "Some quick lunches",
        "RECOMMENDED": "Recommended!",
        "AUTOPILOT": "Lunch on autopilot",
        "GOOD_FLOW": "Good lunch flow",
        "CUSTOM_AMOUNT": "Custom amount",
        "AMOUNT": "Amount",
        "MIN_AMOUNT": "Minimum amount is 50 kr",
        "TOP_UP": "Top up",
        "REDIRECTING": "You will soon be redirected to the checkout page..."
      },
      "SUBHEADER": "Here you can view and manage your balance and transactions in the building's restaurant.",
      "NO_DEAL_HEADER": "We could not find your lunch deal!",
      "NO_DEAL_BODY": "Ask your administrator to give you a new lunch deal.",
      "LUNCH_CARD": "Lunch pass",
      "BALANCE": "Balance",
      "TOP_UP": "Top up",
      "BALANCE_TOOLTIP": "It may take a few seconds for the balance to update after top-up!",
      "CREDIT": {
        "LABEL": "Credit",
        "TOOLTIP": "Your employer covers a monthly amount you can use in the employee restaurant. It is automatically renewed at the start of each month. Once you have spent all your credit, you must pay for lunch from your own balance.",
        "REMAINING": "Remaining credit",
        "RENEWAL_TOMORROW": "Renews tomorrow",
        "RENEWAL_IN_X_DAYS": "Renews in {{count}} days"
      },
      "PRICE_PER_LUNCH": "Your price per lunch",
      "WITH_DEAL": "With deal",
      "WITH_SUBSIDY": "* Your employer subsidizes <bold>{{subsidyPercentage}}%</bold> of the actual lunch price",
      "SUBSIDY_MESSAGE": "Your employer <bold>subsidized {{subsidyPercentage}}%</bold> of the lunch price.",
      "COST_DISTRIBUTION": "Cost distribution",
      "DEDUCTED_FROM": "deducted from {{source}}",
      "TRANSACTIONS": "Transactions",
      "NO_TRANSACTIONS": "You have no transactions yet",
      "DOWNLOAD_RECEIPT": "Download receipt",
      "TOPUP_MODAL_HEADER": "Top up balance",
      "QR_MODAL_HEADER": "Personal lunch pass",
      "QR_MODAL_BODY_1": "When you want to eat lunch,",
      "QR_MODAL_BODY_2": "scan the QR code on your way into the building's restaurant",
      "QR_MODAL_BODY_3": ". We automatically deduct the price from your balance.",
      "QR_MODAL_WARNING": "Do not share your QR code with others. It is personal, and is linked to your balance.",
      "QR_MODAL_WARNING_FREE_DEAL": "Do not share your QR code with others. It is personal, and is linked to your user.",
      "ADD_TO_WALLET": "Add to wallet",
      "CLICK_TO_EXPAND": "Click to view full size",
      "WALLET_MODAL": {
        "HEADER": "Add the lunch pass to your digital wallet",
        "BODY": "Scan the QR code below with your phone's camera to add the lunch pass to your digital wallet. We support both Apple Wallet and Google Wallet.",
        "QR_ERROR": "Something went wrong. Try again later!"
      },
      "ONBOARDING": {
        "HEADER": "You are almost ready to eat lunch!",
        "SUBHEADER": "Here is a short introduction to how it works...",
        "STEP_1_TITLE": "Balance",
        "STEP_1_BODY_BOLD": "When needed, you top up your balance here",
        "STEP_1_BODY": ", in Welcome Workdays. How often and how much you top up is entirely up to you - the higher amount you top up, the less you need to think about it!",
        "STEP_1_CREDIT_BOLD": "Your employer also provides a monthly credit of {{amount}}.",
        "STEP_1_CREDIT": "Your lunch costs are deducted from the credit first - you only spend your own balance if you run out of credit for the month.",
        "STEP_2_TITLE": "Lunch pass",
        "STEP_2_BODY_BOLD": "You now have a personal lunch pass",
        "STEP_2_BODY": " linked to your account. We recommend that you add the pass to the digital wallet on your phone for easier access at lunchtime.",
        "STEP_3_TITLE": "Eat lunch",
        "STEP_3_BODY_1": "When you want to eat lunch,",
        "STEP_3_BODY_BOLD": " scan the QR code on your pass",
        "STEP_3_BODY_2": " at the screen in the restaurant. We deduct the price from your balance - no app, payment or hassle!",
        "STEP_3_BODY_2_FREE_DEAL": ". That's it - no app, payment or hassle!",
        "STEP_3_BODY_MULTI_VARIANT": "The restaurant has 2 options at lunch; \"{{variant1}}\" and \"{{variant2}}\". ",
        "STEP_3_BODY_MULTI_VARIANT_BOLD": "select the option you want, then ",
        "STEP_3_PS_BOLD": "Note!",
        "STEP_3_PS": "Each lunch costs you {{price}}",
        "STEP_3_PS_TWO_VARIANTS": "Each lunch costs you {{price}} for \"{{variant1}}\" and {{price2}} for \"{{variant2}}\"",
        "STEP_3_PS_FREE_DEAL": "Your lunch is completely subsidized and therefore costs you nothing.",
        "STEP_4_TITLE": "Get started!",
        "STEP_4_HEADER": "It's that simple!",
        "STEP_4_BODY": "Get started by topping up your balance.",
        "STEP_4_BODY_FREE_DEAL": "Hope you're ready for lunch! Bon appétit.",
        "DISMISS_BUTTON": "Top up later",
        "DISMISS_BUTTON_FREE_DEAL": "I'm ready"
      },
      "TRANSACTION_TYPES": {
        "LUNCH_EATEN": "Lunch in building's restaurant",
        "GUEST_LUNCH_EATEN": "{{guestCount}}x guest lunch in building's restaurant",
        "TOPUP": "Balance top-up",
        "REFUND": "Balance refund",
        "WAITING_CONFIRMATION": "(waiting for confirmation of approved payment",
        "LINK_EXPIRED": "payment link expired",
        "CANCELLED": "payment cancelled",
        "FAILED": "payment failed"
      }
    },
    "DASHBOARD": {
      "GREETING": {
        "MORNING": "Good morning, {{name}}",
        "DAY": "Good day, {{name}}",
        "EVENING": "Good evening, {{name}}"
      },
      "FOOD_WIDGET": {
        "MODAL": {
          "HEADER": "Lunch menu this week",
          "SUBHEADER": "Week {{weekNumber}}",
          "EARLIER": "Earlier in the week"
        }
      },
      "MEET_THE_TEAM": "Meet the team at <nowrap>{{buildingName}}</nowrap>",
      "TODAY": {
        "LUNCH": "Lunch today",
        "NEXT_BOOKING": "Next booking",
        "VISITORS": "Visitors today",
        "UNREAD_NEWS": "Unread news",
        "EXPECTED": "{{count}} expected",
        "NEXT_ARRIVAL": "Next arrival {{time}}",
        "NEW_COUNT": "{{count}} new",
        "MORE_DISHES": "and {{count}} more",
        "HEADER": "For you today",
        "SCAN_TO_PAY": "Scan your QR code on the way in",
        "OPEN_UNTIL": "The canteen is open until {{time}}",
        "VISITOR_NOW": "Visitor now",
        "VISITOR_ARRIVED": "{{name}} has arrived",
        "VISITORS_WAITING": "{{count}} visitors are waiting for you",
        "ARRIVED_AT": "Arrived {{time}}. Let them in or reply in Welcome Visit."
      },
      "EVERYTHING_IN": "Everything in {{buildingName}}",
      "MODULES": {
        "VISITORS": "Preregister and track your guests",
        "ACCESS": "Your access card and PIN",
        "INFO": "Practical information about {{buildingName}}",
        "BOOKINGS": "Meeting rooms and resources",
        "LUNCH": "Menu, balance and lunch card",
        "MY_ORDERS": "Meeting food orders",
        "CUSTOM": "Opens in a new tab"
      },
      "UNREAD": "Unread",
      "NEWS_FROM_BUILDING": "News from {{buildingName}}",
      "ALL_NEWS": "See all news",
      "HELP": {
        "HEADER": "Need help?",
        "IN_BUILDING": "Contacts for {{buildingName}}",
        "YOUR_ACCOUNT": "Contact for {{companyName}}",
        "SCOPE_BUILDING": "For anything about the building and the services in it.",
        "SCOPE_ACCOUNT": "Start here for your account, access card, or access to an area.",
        "ROLE_COMPANY_CONTACT": "Company contact, {{companyName}}",
        "SHOW_ALL_TEAM": "Show the whole team",
        "NO_CONTACT": "No contact registered yet"
      },
      "HELP_CENTRE": {
        "HEADER": "Help centre",
        "BLURB": "Guides and answers for everything in Welcome Workdays.",
        "OPEN": "Open the help centre",
        "NEW_TAB": "Opens in a new tab"
      },
      "TABS": {
        "LABEL": "Main navigation",
        "HOME": "Home",
        "VISITORS": "Visitors",
        "MORE": "More"
      },
      "SHORTCUTS": {
        "TOP_UP_LUNCH": "Top up lunch card",
        "NEW_BOOKING": "New booking",
        "ORDER_FOOD": "Order meeting food"
      },
      "NEWS_DATE": {
        "TODAY": "Today {{time}}",
        "YESTERDAY": "Yesterday"
      }
    },
    "VISITORS": {
      "HEADER": "Visitors",
      "SUBHEADER": "Here, you'll find a list of all your visitors for today. You'll also receive a notification via SMS or email when your visitor arrives. Learn more about <1>Welcome Visit</1>.",
      "PLACEHOLDER": "{{ entity }} have no visitors so far today!",
      "PREREGISTRATION": "Preregistration",
      "PREREGISTRATION_DESCRIPTION": "Here you'll find your upcoming visitors. You can also preregister new visitors.",
      "VIEW_FUTURE_PREREGISTRATIONS": "Future preregistrations",
      "CREATE_PREREGISTRATION": "Create preregistration"
    },
    "BOOKING": {
      "HEADER": "Bookings",
      "SUBHEADER": "Manage your bookings and explore available rooms in {{buildingName}}. Learn more about <1>Welcome Booking here</1>.",
      "PLACEHOLDER": "You have no upcoming bookings!",
      "BOOK": "Book a room",
      "SUB_ROUTES": {
        "ALL_ROOMS": "All rooms",
        "SEARCH": "Search for rooms"
      },
      "HISTORY": {
        "HEADER": "Booking history",
        "SUBHEADER": "Here, you'll find an overview of all your previous bookings, including cancelled ones."
      }
    },
    "MY_ORDERS": {
      "LIFECYCLE_DATA_UNAVAILABLE": "Some order details are unavailable. Contact the supplier.",
      "ORDER_UNAVAILABLE": "This order is not available to your account.",
      "HEADER": "My orders",
      "SUBHEADER": "Here is a list of all your food orders in {{buildingName}}.",
      "TABLE": {
        "ORDER_NUMBER": "Order number",
        "TIME": "Delivery/Pickup time",
        "LOCATION": {
          "HEADER": "Location",
          "PICKUP": "Pickup at <bold>{{supplierName}}</bold>",
          "DELIVERY": "Delivery to <bold>your location</bold>",
          "SOON": "soon"
        },
        "TOTAL": "Total",
        "NO_DATA": "No orders to show"
      },
      "ORDER_DETAILS": {
        "HEADER": "Order #{{orderNumber}}",
        "CANCEL": "Cancel order",
        "PAID_BY_INVOICE": "Paid by invoice",
        "WILL_NOT_BE_INVOICED": "Order will not be invoiced"
      },
      "STATUS": {
        "PENDING": "Pending",
        "ORDERED": "Ordered",
        "CONFIRMED": "Confirmed",
        "PREPARING": "Preparing",
        "DELIVERED": "Delivered",
        "CLOSED": "Closed",
        "CANCELLED": "Cancelled",
        "DENIED": "Denied",
        "COMPLETED": "Completed"
      },
      "STATUS_TEXT": {
        "ORDERED": "Kitchen staff has received your order and will confirm it at their earliest convenience",
        "CONFIRMED": "Your order has been confirmed by the kitchen and will be fulfilled at the chosen time and place",
        "PREPARING": "The kitchen is preparing your order",
        "DELIVERED": "Your order is marked as delivered or picked up",
        "CANCELLED": "You have chosen to cancel this order - it will not be invoiced",
        "DENIED": "The kitchen has denied your order for the following reason:"
      }
    },
    "ORDER_FOOD": {
      "SUBHEADER": "Here, you can order food and drinks to enjoy in {{buildingName}}.",
      "CONTACT": "Have a question or need help? Contact the restaurant at <firstMethod>{{firstMethod}}</firstMethod><secondMethod> or <phone>{{phone}}</phone></secondMethod>.",
      "STEPS": {
        "DELIVERY": "Choose delivery",
        "PRODUCTS": "Choose products",
        "CHECKOUT": "Review & checkout"
      },
      "DELIVERY_METHOD": {
        "PICKUP": {
          "LABEL": "Pickup",
          "BUTTON": "Choose pickup",
          "UNAVAILABLE": "Pickup is not available",
          "TITLE": "When do you want to pick up your order?",
          "NO_CUTOFF": "Your order can be scheduled for pickup at the earliest 1 hour from now.",
          "CUTOFF": "Orders made after {{orderCutoffTime}} cannot be scheduled for pickup until {{pickupOpensAt}} tomorrow. It's currently not possible to order less than 1 hour ahead of time.",
          "CUTOFF_PLUS_DAYS": "Orders made after {{orderCutoffTime}} cannot be scheduled for pickup until {{pickupOpensAt}}, {{daysToWait}} days from now. It's currently not possible to order less than 1 hour ahead of time.",
          "CUTOFF_24H": "Your order can be scheduled for pickup at the earliest 24 hours from now.",
          "LOCATION": "You need to pick up your order at <bold>{{location}}</bold>",
          "INSTRUCTIONS": {
            "LABEL": "Comment",
            "PLACEHOLDER": "Anything the kitchen should know about the pickup?"
          }
        },
        "DELIVERY": {
          "LABEL": "Delivery",
          "BUTTON": "Choose delivery",
          "UNAVAILABLE": "Delivery is not available",
          "TITLE": "When do you want your order to be delivered?",
          "NO_CUTOFF": "Your order can be scheduled for delivery at the earliest 1 hour from now.",
          "CUTOFF": "Orders made after {{orderCutoffTime}} cannot be scheduled for delivery until {{deliveryOpensAt}} tomorrow. It's currently not possible to order less than 1 hour ahead of time.",
          "CUTOFF_PLUS_DAYS": "Orders made after {{orderCutoffTime}} cannot be scheduled for delivery until {{deliveryOpensAt}}, {{daysToWait}} days from now. It's currently not possible to order less than 1 hour ahead of time.",
          "CUTOFF_24H": "Your order can be scheduled for delivery at the earliest 24 hours from now.",
          "LOCATION": {
            "TITLE": "Where do you want it delivered?",
            "DESCRIPTION": "Your order can be delivered to any common area in {{buildingName}}."
          },
          "INSTRUCTIONS": {
            "LABEL": "Delivery instructions",
            "PLACEHOLDER": "Describe where the order should be delivered..."
          },
          "ERROR": "Instructions must be at least 3 characters when delivering"
        },
        "PICKUP_WITH_SERVICE": {
          "LABEL": "Pickup with service"
        },
        "PICKUP_WITHOUT_SERVICE": {
          "LABEL": "Pickup without service"
        },
        "DELIVERY_WITH_SERVICE": {
          "LABEL": "Delivery with service"
        },
        "DELIVERY_WITHOUT_SERVICE": {
          "LABEL": "Delivery without service"
        },
        "WITH_SERVICE_DESCRIPTION": "E.g. regular tableware, cleanup, dishwashing. Exact services may vary.",
        "WITHOUT_SERVICE_DESCRIPTION": "E.g. single-use tableware, no cleanup or service.",
        "AVAILABLE": "Available",
        "BACK": "Back to delivery methods",
        "CHOSEN": "Chosen"
      },
      "MENU": {
        "SEARCH": "Search for products",
        "NO_ITEMS": {
          "SEARCH": "No menu items match your search",
          "DEFAULT": "No menu items to show"
        },
        "CREATE_WITH_AI_DESCRIPTION": "Try creating the menu item with artificial intelligence (AI)",
        "CREATE_WITH_AI": "Create with AI",
        "AI_MODAL": {
          "HEADER": "Create the menu item with AI",
          "DESCRIPTION": "Here you can create the menu item using artificial intelligence (AI). You only need to provide a short description of the menu item, then AI will generate all the text in both languages as well as an appetizing image!",
          "PROMPT": {
            "LABEL": "What do you want to add to the menu?",
            "PLACEHOLDER": "Briefly describe the menu item"
          },
          "TOOLTIP": {
            "GENERATING_TEXT": "Generating text...",
            "GENERATING_IMAGE": "Generating image...",
            "FINISHED_SOON": "Finishing up..."
          }
        },
        "ALLERGENS": "Allergens",
        "IMAGE_IS_ILLUSTRATIVE": "Image is for illustration purposes only"
      },
      "CART": {
        "HEADER": "Shopping cart",
        "IN_CART": "in cart",
        "ADD": "Add to cart",
        "ADD_SHORT": "Add to cart",
        "REMOVE": "Remove from cart",
        "MIN_QTY_REACHED": "Minimum {{minQuantity}} per order",
        "MAX_QTY_REACHED": "Maximum {{maxQuantity}} per order",
        "BOTH_QTY_LIMIT": "Minimum {{minQuantity}}, maximum {{maxQuantity}} per order",
        "DONE": "Confirm",
        "ADD_ITEM_COMMENT": "Add comment",
        "ITEM_COMMENT": {
          "LABEL": "Comment",
          "PLACEHOLDER": "Anything the kitchen should be aware of?"
        },
        "QUANTITY": "Quantity",
        "QUANTITY_SHORT": "Qty.",
        "EMPTY": "Your cart is empty!"
      },
      "CHECKOUT": {
        "COMMENT": {
          "LABEL": "Special instructions",
          "PLACEHOLDER": "Any special instructions for the kitchen?"
        },
        "PARTICIPANTS_COUNT": {
          "LABEL": "How many people are eating?",
          "INFO_TEXT": "Indicates how much tableware is needed.",
          "LABEL_ALT": "Number of people eating"
        },
        "CONFIRM_COST": "I confirm that I am authorized to incur a cost of {{cost}} (exc. VAT) for this order on behalf of {{companyName}}",
        "PAY_WITH_INVOICE": "Pay with invoice",
        "INVALID_FORM_TOOLTIP": "One or more steps are invalid!"
      },
      "AVAILABILITY": {
        "HELP": "Some products have their own ordering deadlines. We'll show what can be ordered for the time you choose.",
        "HELP_CLOSED_ON_WEEKENDS": "The restaurant is closed on weekends, so deadlines given in days skip Saturday and Sunday. Some products have their own ordering deadlines. We'll show what can be ordered for the time you choose.",
        "TIME_PROBLEMS": {
          "DELIVERY_TIME_IN_PAST": "The selected time has already passed.",
          "OUTSIDE_OPERATING_HOURS": "The restaurant isn't open at the selected time.",
          "DELIVERY_TYPE_UNSUPPORTED": "The restaurant no longer offers this delivery method.",
          "SUPPLIER_CLOSED": "The restaurant is closed on weekends. Choose a weekday."
        },
        "ITEM_PROBLEMS": {
          "CUTOFF_PASSED": "Item cannot be ordered for the chosen time. The deadline was {{orderBy}}.",
          "CUTOFF_PASSED_NO_TIME": "Item cannot be ordered for the chosen time.",
          "ITEM_UNAVAILABLE": "Not available right now.",
          "ITEM_NOT_FOUND": "No longer on the menu."
        },
        "ORDER_BY": "Must be ordered by {{time}}",
        "ORDER_BY_WEEKDAY": "Must be ordered by {{weekday}} {{time}}",
        "UNKNOWN_ITEM": "Unknown product",
        "NO_ITEMS": "No products can be ordered for the selected time. Try another time.",
        "CHECK_FAILED": "We couldn't check which products can be ordered for the selected time. Your cart hasn't changed.",
        "REFRESH_FAILED": "We couldn't check the products again, so what you see may be out of date. Your cart hasn't changed.",
        "MENU_FAILED": "The menu couldn't be loaded. Your cart hasn't changed.",
        "SETUP_FAILED": "We couldn't check which products can be ordered because of a problem with the restaurant's ordering setup. Contact your administrator. Your cart hasn't changed.",
        "CHECKOUT_WARNING": "Some of your cart items can't be ordered for the selected time. <remove>Remove the marked products</remove> or <changeTime>change the time</changeTime>, then try again.",
        "CHECKOUT_WARNING_REMOVE_ONLY": "Some of your cart items can't be ordered. <remove>Remove the marked products</remove>, then try again.",
        "COUNTDOWN": "Complete your order within {{time}}. After that, some of the products in your cart can no longer be ordered for your desired time.",
        "COUNTDOWN_ANNOUNCEMENT_one": "{{count}} minute left to complete your order before some products can no longer be ordered.",
        "COUNTDOWN_ANNOUNCEMENT_other": "{{count}} minutes left to complete your order before some products can no longer be ordered."
      },
      "NOTIFICATIONS": {
        "ORDER_NOT_ORDERABLE": "Your order wasn't placed. Some of your cart items can't be ordered for the selected time.",
        "ORDERING_MODE_CHANGED": "The ordering rules have changed. Check your order and try again.",
        "QUANTITY_EXCEEDS_LIMIT": "You've added more of a product than the restaurant allows. Adjust the quantity and try again.",
        "ORDERING_UNAVAILABLE": "Ordering is temporarily unavailable. Please try again in a moment.",
        "TIME_NOT_ORDERABLE": "Your order wasn't placed. {{reason}} Change the time or delivery method and try again.",
        "TIME_REJECTED": "Your order wasn't placed. The selected time or delivery method can no longer be used, for example because the ordering deadline has passed. Change it and try again.",
        "ITEM_NO_LONGER_AVAILABLE": "Your order wasn't placed. A product in your cart is no longer available. Check your cart and try again.",
        "INVALID_CART": "Your order wasn't placed. Something in your cart isn't valid. Check the products and quantities, then try again.",
        "ORDERING_MISCONFIGURED": "Your order wasn't placed because of a problem with the restaurant's ordering setup. Contact your administrator.",
        "CART_ITEM_NOT_FOUND": "An item in your cart could no longer be found in the menu. It has been removed from your cart.",
        "CART_UPDATED": "Your cart was updated",
        "DELIVERY_TIME_UPDATED": "The delivery time was updated",
        "ORDER_CREATED": "Order successful! Awaiting confirmation from the kitchen.",
        "ORDER_FAILED": "Failed to create order. Please try again later!",
        "CANCELLED": "The order has been cancelled. It will not be invoiced.",
        "DENIED": "The order has been denied. The customer will be notified.",
        "DENIAL_FAILED": "Failed to deny order. Please try again later!",
        "STATUS_UPDATED": "Order status updated successfully!",
        "STATUS_UPDATE_FAILED": "Failed to update order status. Please try again later!",
        "ORDER_LIFECYCLE_CONFLICT": "The order changed since this page was loaded, so the action was not applied. The order has been refreshed.",
        "ORDER_CLOSED_ON_SAVE": "The order's closing time had passed, so saving also closed it. It is now ready for invoicing and can no longer be edited.",
        "CANCELLATION_FAILED": "Failed to cancel order. Please try again later!"
      }
    },
    "SNACK_ADMIN": {
      "HEADER": "Orders overview",
      "SUBHEADER": "Here, you can see and administrate all food orders in {{buildingName}}."
    },
    "COMPANY_BOOKING": {
      "HEADER": "Company Bookings",
      "SUBHEADER": "Here, you'll find an overview of all bookings made internally in {{companyName}}. Learn more about <1>Welcome Booking here</1>."
    },
    "BUILDING_BOOKING": {
      "HEADER": "All Bookings",
      "SUBHEADER": "Here, you'll find an overview of all bookings made in {{buildingName}}. Learn more about <1>Welcome Booking here</1>.",
      "PLACEHOLDER": "No bookings to show!",
      "VIEWS": {
        "CALENDAR": "Calendar View",
        "LIST": "List View"
      },
      "FILTERS": {
        "ROOM": {
          "LABEL": "Filter on resource",
          "PLACEHOLDER": "Any resource"
        },
        "DATE": {
          "LABEL": "Filter on time",
          "PLACEHOLDER": "Upcoming bookings",
          "CURR_MONTH": "This month",
          "LAST_MONTH": "Last month",
          "PAST_90_DAYS": "Past 90 days"
        },
        "STATUS": {
          "LABEL": "Filter on status",
          "PLACEHOLDER": "Any status"
        },
        "EXPORT": "Export {{count}} bookings"
      },
      "BOOKING_DETAILS_ERROR": "Failed to load booking details. Please report this error using the chat in the bottom right corner.",
      "CLOSED_WITH_BOOKINGS_one": "Closed, {{count}} booking",
      "CLOSED_WITH_BOOKINGS_other": "Closed, {{count}} bookings",
      "BOOKINGS_ON_DAY_one": "<bold>{{count}} booking</bold> on this day",
      "BOOKINGS_ON_DAY_other": "<bold>{{count}} bookings</bold> on this day",
      "NEW": {
        "HEADER": "New booking",
        "SUBHEADER": "Here, you can book a room on behalf of a user in {{buildingName}}.",
        "ON_BEHALF_OF": {
          "LABEL": "Book on behalf of",
          "INFO": "Please input the user's entire email to fetch results",
          "NO_RESULTS": "Double-check that the email is correct"
        },
        "NO_USER_SELECTED": {
          "HEADER": "Select a user to begin",
          "BODY": "You must select a user before booking a room on their behalf."
        }
      }
    },
    "ACCESS": {
      "HEADER": "Access",
      "SUBHEADER": "Below are your access cards and access groups in {{building}}. Here you can also report your cards as stolen or lost. Learn more about <1>Welcome Access here</1>. If you are missing a badge or an access group please contact your company administrator.",
      "PLACEHOLDER": {
        "HEADER": "You have no access cards yet!",
        "DIGITAL_BODY": "Download the Welcome Access app and generate your own digital access card. Log in with your email <bold>{{email}}</bold>.",
        "APP_STORE": "Download from the App Store",
        "GOOGLE_PLAY": "Download from Google Play",
        "LEARN_MORE": "Learn more about digital access cards",
        "PHYSICAL_BODY": "You don't have an access card for {{building}} yet. Contact your company administrator to request one.",
        "PHYSICAL_CARD_HINT": "Need a physical access card? Contact your company administrator."
      },
      "PIN_MANAGEMENT": "PIN management",
      "PIN_MANAGEMENT_DESCRIPTION": "Your PIN code is used for all your access cards in the building, both physical and digital. Keep it secure and don't share it with anyone. We don’t store your PIN, so make sure to remember or save it.",
      "CHANGE_PIN": "Change PIN"
    },
    "USERS": {
      "HEADER": "Users",
      "SUBHEADER": "View and administrate users in your company. You can change profile settings, toggle visibility and moderate access levels. Read more about <1>user administration</1>. Download <3>xlsx</3> or <5>csv</5> user bulk upload template file.",
      "SUB_ROUTES": {
        "SETTINGS": "User settings",
        "ACCESS": "Access",
        "FOOD": "Food"
      }
    },
    "SETTINGS": {
      "HEADER": "My Profile",
      "SUBHEADER": "View and update your profile settings here. Additionally, if you wish to delete your profile data you must contact your company administrator.",
      "MANAGE_CONSENTS": "Manage consents",
      "DISCLAIMER": "By using the service you have accepted our <terms>terms of use</terms> and confirmed that you have read our <policy>privacy policy</policy>.",
      "VISIT_SETTINGS": "Welcome Visit settings",
      "VISIT_SETTINGS_DESCRIPTION": "Welcome Visit is the visitor registration solution, here you can manage your related settings. Learn more about Welcome Visit <1>here</1>.",
      "NOTIFICATION_PREFERENCE": "Notification preference",
      "NOTIFICATION_SETTINGS": "Notification settings",
      "NOTIFICATION_PREFERENCE_DESCRIPTION": "Choose your notification preferences, which will apply to the visitor registration and booking systems (when enabled). Please note that some notifications are sent by email only, regardless of your selected preferences.",
      "SMS": "SMS"
    },
    "COMPANY_SETTINGS": {
      "HEADER": "Company Settings",
      "SUBHEADER": "Manage your company information here. You can also view your SSO domain and SSO provider. To make changes to SSO settings, please contact your administrator. For more details, visit our <1>Help Pages</1>.",
      "GOOGLE_SSO_HELP_TEXT": "Domain added. Please note that it might take up to 24 hours for the new domain to take effect."
    },
    "COMPANY_VISITORS": {
      "HEADER": "Company Visitors Today",
      "SUBHEADER": "Here, you'll find a list of all the company visitors for today. Every company administrator will receive a notification via SMS or email when a visitor with no host arrives. Learn more about <1>Welcome Visit</1>."
    },
    "FUTURE_COMPANY_VISITORS": {
      "HEADER": "Future Company Visitors",
      "SUBHEADER": "Here, you'll find an overview of all the preregistered company visitors for future dates. Learn more about <1>Welcome Visit</1>."
    },
    "BUILDING_SETTINGS": {
      "HEADER": "Building Settings",
      "SUBHEADER": "Manage the building information here. For more details, visit our <1>Help Pages</1>.",
      "MODULE_DESCRIPTIONS": {
        "VISIT": "Visitor registration",
        "BOOKING": "Meeting room booking",
        "ACCESS": "Access control",
        "COMMUNICATION": "Communication to tenants",
        "FOOD": "Catering and restaurant",
        "COMPLIANCE": "Compliance management"
      }
    },
    "FOOD_SETTINGS": {
      "LINK_COMPANY_TO": "Link company to",
      "AVAILABLE_DEALIDS": "Available Deal Ids",
      "NOT_CONNECTED": "This user is not yet connected to the restaurant system.",
      "CONNECT_USER": "Connect user to restaurant system",
      "NO_ACCESS_CARD": "User needs an access card before they can be integrated with the restaurant system.",
      "WILL_BE_CONNECTED_WITH": "User will be connected with",
      "IS_CONNECTED_WITH": "User is connected with",
      "ACCESS_CARD_NUMBER": "Access card number",
      "CONNECT_BUTTON_TEXT": "Connect user",
      "UPDATE_TEXT": "It looks like the user data is out of sync with the restaurant system.",
      "UPDATE_BUTTON_TEXT": "Sync data",
      "MUNU_USER_DETAILS": "User details from <emphasize>restaurant system</emphasize>",
      "WELCOME_USER_DETAILS": "User details from <emphasize>Welcome Workdays</emphasize>",
      "USER_CONNECTED": "This user is connected to the restaurant system",
      "USER_DISABLED": "This user has been deactivated",
      "USER_DISABLED_INFO": "User has been deactivated in the restaurant system.",
      "PLEASE_LINK_FIRST": "Company is not yet linked to the restaurant system. Please ask a building administrator to link it.",
      "USER_HAS_NO_PHONE_NUMBER": "User needs a valid phone number before they can be integrated with the restaurant system.",
      "AVAILABLE_DEALS": "Available deals",
      "SELECT_DEAL": "Select a deal",
      "ACCOUNT_TYPE": "Account type",
      "DEAL_ID": "Deal ID",
      "BENEFIT_NAME": "Deal name",
      "DISABLE_USER": "Disable user",
      "REACTIVATE_USER": "Reactivate user",
      "TIMESTAMP": "Timestamp",
      "DESCRIPTION": "Description",
      "AMOUNT": "Amount",
      "USER_HAS_DEAL": "User has lunch deal:",
      "CHANGE": "Change",
      "LUNCHES_EATEN": "Lunches eaten so far",
      "PRICE_PER_LUNCH": "Price per lunch",
      "LUNCH_HISTORY": "Lunch history",
      "NO_TRANSACTIONS": "The user has no transactions yet",
      "USER_HAS_NO_DEAL": "The user has no lunch deal",
      "USER_IS_DEACTIVATED": "The user is deactivated",
      "DEACTIVATED_USER_INFO": "This user has been deactivated and therefore no longer has access to any Welcome Workdays services.",
      "COMPANY_HAS_NOD_DEALS": "{{companyName}} has no lunch deals",
      "ASSIGN_DEAL_INFO": "You must assign a lunch deal to the user before they can use the employee restaurant.",
      "LUNCH_DEAL": "Lunch deal",
      "SELECT_LUNCH_DEAL": "Select lunch deal",
      "SELECTED_LUNCH_PRICE": "Price per lunch: {{price}}",
      "ASSIGN_LUNCH_DEAL": "Assign lunch deal",
      "ASSIGN": "Assign",
      "NEW_LOWER": "new",
      "CHANGE_DEAL_INFO": "By changing the user's lunch deal, you immediately change the price the user pays for lunch in the employee restaurant.",
      "ASSIGN_DEAL_INFO_MODAL": "By assigning a lunch deal, the users will immediately get access to the employee restaurant. Any users who already have a lunch deal will be moved to the selected lunch deal. The lunch deal can be changed or revoked at any time.",
      "DEAL_UPDATED": "The user's lunch deal was updated.",
      "USERS_ASSIGNED_DEAL": "{{successful}} of {{total}} users were assigned lunch deal \"{{dealName}}\".",
      "USERS_ASSIGNED_MULTI_DEALS": "{{successful}} of {{total}} users were assigned lunch deals.",
      "USERS_UPDATE_FAILED": "{{failed}} users could not be updated. Please try again later.",
      "THE_USER": "the user",
      "USERS_LOWER": "users",
      "DEACTIVATE_USER": "Deactivate users lunch deal",
      "DEACTIVATE_USER_MESSAGE": "The user will immediately lose access to the building's restaurant. However, their history and any remaining balance will be preserved and will be restored if the user is reactivated.",
      "USER_DEACTIVATION_SUCCESS": "The users lunch deal was deactivated and they no longer have access to the building's restaurant.",
      "REFUND": {
        "REFUND_BALANCE": "Refund balance",
        "REMAINING_BALANCE": "Remaining balance",
        "PANEL_TITLE": "Remaining balance: {{amount}}",
        "PANEL_INFO": "This is the user's own topped-up balance. Refunding returns it to their original payment method. Reactivating the user instead keeps the balance on their wallet.",
        "SUMMARY": "You are about to refund {{amount}} to the user's original payment method. This cannot be undone.",
        "INFO": "The refund is processed by the payment provider and may take a few days to settle. Your customer will usually receive their refund within 3 working days after it is issued. The user's wallet must remain deactivated till the refund is settled.",
        "AMOUNT": "Refund amount",
        "MAX_REFUNDABLE": "You can refund up to {{amount}}",
        "EXCEEDS_BALANCE": "The amount cannot exceed the available balance of {{amount}}",
        "DESCRIPTION": "Description",
        "DESCRIPTION_PLACEHOLDER": "Reason for the refund",
        "CONFIRM": "Process refund",
        "PROCESSING": "Initiating a refund. This may take a moment…",
        "PROCESSING_TRACK": "Refund initiated. Track its progress on the audit users page.",
        "SUCCESS": "Successfully refunded {{amount}} to the user.",
        "FAILED": "The refund could not be processed. Please try again later or contact support.",
        "PENDING_BLOCKS_REACTIVATION": "A refund is still being processed for this user. You can reactivate them once the refund has settled."
      },
      "USER_WAS_ACTIVE": "This user has previously had a lunch deal. By reactivating them you will restore their previous transaction history and balance.",
      "SELECTED_USERS": "selected users",
      "HAVE_NO_DEAL": "have no deal",
      "FROM_BEFORE": "right now",
      "WILL_GET_ACCESS": "will get access",
      "TO_EMPLOYEE_RESTAURANT": "to the employee restaurant",
      "ALREADY_HAVE_LUNCH_DEAL": "already have a lunch deal",
      "WILL_BE_MOVED_TO_SELECTED_DEAL": "and will be reassigned the selected deal",
      "ALREADY_HAVE_SELECTED_DEALS": "already have the selected deal(s)",
      "WILL_BE_IGNORED_ON_SUBMIT": "and will therefore be ignored",
      "HAS_REACHED_LIMIT": "<bold>{{dealName}} has a limit of {{maxUsers}} users</bold>",
      "HAS_LIMIT_OF": "has a limit of",
      "ACTIVE_USERS": "active users",
      "USING_THIS_DEAL": "using this deal",
      "WITH_DEAL": "with deal \"{{dealName}}\"",
      "BUT_YOU_HAVE_SELECTED": ", but you have selected {{count}} users",
      "AND_ALREADY_HAS": "and already has",
      "WITH_DEAL_AND_HAS_REACHED": "with deal \"{{dealName}}\" and has already reached this limit.",
      "YOU_MUST_DESELECT": "You must therefore deselect",
      "USERS_TO_CONTINUE": "users to continue.",
      "CANNOT_ASSIGN_MORE_DEALS": "You can therefore not assign this lunch deal to any more users.",
      "DEAL_AT_LIMIT": "This deal has reached its user limit. You cannot assign more users to this deal.",
      "COMPANY_NOT_INTEGRATED": "The company has no assigned lunch deals.",
      "ASSIGN_AT_LEAST_ONE_DEAL": "Assign it at least one lunch deal to integrate it.",
      "LINK_MODE": "Link mode",
      "LINK_PARENT_COMPANY": "Link parent company",
      "LINK_BY_SUBDIVISIONS": "Link by subdivisions",
      "SUBDIVISION_LINKS": "Subdivision links",
      "SUBDIVISION_LINKED": "{{subdivisionName}} is linked to restaurant system with ID: {{munuId}}",
      "LIMIT_APPLIES_TO_ALL_SUBDIVISIONS": "The limit you set below applies to all subdivisions of the company.",
      "USER_MUST_HAVE_SUBDIVISION": "User must be assigned to a subdivision before connecting to restaurant system.",
      "SUBDIVISION_NOT_LINKED": "The subdivision '{{subdivisionName}}' has not been linked to the restaurant system. Please ask a building administrator to configure it."
    },
    "COMPANIES": {
      "HEADER": "Companies",
      "SUBHEADER": "Here, you'll find a list of all the companies connected to the building. This includes all entities from tenants to service providers.",
      "SEARCH": "Search by company name",
      "ADD": "Invite company to building",
      "NOT_COMPANY_ADMIN": "As a building administrator, you have access to view the company's information. To edit general company details, please make youself an administrator of this company."
    },
    "BUILDING_VISITORS": {
      "HEADER": "Building Visitors Today",
      "SUBHEADER": "Here, you'll find a list of all visitors in the building for today, including preregistrations. Learn more about <1>Welcome Visit</1>."
    },
    "FUTURE_BUILDING_VISITORS": {
      "HEADER": "Future Building Visitors",
      "SUBHEADER": "Here, you'll find an overview of all the preregistered building visitors for future dates. Learn more about <1>Welcome Visit</1>."
    },
    "BUILDING_ACCESS": {
      "HEADER": "Access Cards",
      "SUBHEADER": "Here, you'll find a list of access card processing requests in need of attention. This includes card orders and deactivation requests. Further down the page you will also find all currently active and deactivated cards.",
      "REQUESTS_PLACEHOLDER": "No active requests",
      "ALL_PLACEHOLDER": "No access cards to show"
    },
    "BUILDING_ACCESS_ROLE_MANAGEMENT": {
      "SUBHEADER": "Here you can view and manage access groups that are retrieved from the building's access control system."
    }
  },
  "ACCESS_ROLE_MANAGEMENT": {
    "TABLE": {
      "NAME": "Access group name",
      "ASSIGNED_TO": "Can be assigned to users in",
      "ASSIGNED_BY": "Can be managed by",
      "NO_DATA": "No access groups to show",
      "VISITORS": "visitors",
      "ALL_INTEGRATED_COMPANIES": "All integrated companies",
      "PLUS_MORE": "more",
      "SEARCH_PLACEHOLDER": "Search by access group or company name..."
    },
    "ADD_ROLE": "Add new access group",
    "DEFAULT_ROLE": "Default access groups are automatically assigned to all new users in the company.",
    "ADD_VISITOR_ROLE": "Add visitor access group",
    "EDIT_ROLE_HEADER": "Edit access group",
    "SET_AS_DEFAULT": "Set as default access group",
    "SET_AS_DEFAULT_INFO": "Will be automatically assigned to all new users in the company.",
    "CREATE_SUCCESS": "Access group created successfully",
    "UPDATE_SUCCESS": "Access group updated successfully",
    "SAME_AS_TARGETED": "Only selected 'can be assigned to users in'",
    "AT_LEAST_ONE_ASSIGNMENT_TYPE": "At least one assignment type must be selected",
    "SEPARATE_ROLES_INFO": "Two separate access groups will be created — one for company employees and one for visitors.",
    "DELETE_ROLE_HEADER": "Delete access group",
    "DELETE_ROLE_MESSAGE": "Are you sure you want to delete this access group? The group will be removed from all users it is currently assigned to. This action cannot be undone.",
    "DELETE_SUCCESS": "Access group deleted successfully",
    "CANNOT_DELETE_ROLE_HEADER": "Cannot delete access group",
    "CANNOT_DELETE_ROLE_MESSAGE": "The access group '{{roleName}}' is currently assigned to user(s). Please remove the group from all users before deleting it. The following users have this group:",
    "STARWATCH_GROUP_REMOVED": "Removed in Starwatch",
    "STARWATCH_GROUP_REMOVED_INFO": "This group no longer exists in Starwatch. The access group is kept, but isn't given to anyone until the group is back.",
    "ALL_COMPANIES_INCLUDING_FUTURE": "All integrated companies, including future ones",
    "ENTITY": "access group",
    "CANNOT_DELETE_ROLE_MORE_USERS": "…and {{count}} more"
  },
  "PHONE_VALIDATION": {
    "HEADER": "Verify your phone number",
    "SUBHEADER": "Welcome Workdays uses your phone number for many essential functions, such as notifying you when someone is visiting you. That's why we need a phone number to reach you on!",
    "OTP_LABEL": "Verification code from SMS",
    "OTP_LABEL_EMAIL": "Verification code from Email",
    "OTP_ERROR": "Invalid code or something went wrong",
    "OTP_INFO": "It may take up to a few minutes to receive the SMS. If you still haven't received it<remaining> in <highlight>{{remainingTime}} seconds</highlight></remaining> you may <button>request a new code</button>.",
    "OTP_LIMIT_REACHED": "You have reached the limit of allowed verification attempts. If you still have not received the SMS, please check that the phone number is correct, try again later or get in touch.",
    "SMS_SENT_TO": "The SMS was sent to <highlight>{{ phone }}</highlight>. <button>Wrong number?</button>",
    "MAX_ATTEMPTS_REACHED": "You have reached the maximum number of attempts to verify your phone number for today. Please try again tomorrow or contact your company administrator.",
    "SEND_OTP": "Send code",
    "VALIDATED_TOOLTIP": "The phone number has been verified"
  },
  "FOOD_ADMIN": {
    "RESTAURANT": "Employee restaurant",
    "DEALS": {
      "SUBHEADER": "Here, you can see and administrate all available restaurant deals per company in {{buildingName}}.",
      "SEARCH": "Search by company or deal...",
      "DEAL": "Deal",
      "DEALS": "Deals",
      "NEW": "New deal",
      "NO_DEALS": "The building has no deals yet",
      "NO_DEALS_INFO": "You need to create at least 1 deal before integrating the company",
      "NOT_INTEGRATED": "Company has no assigned lunch deals",
      "DEAL_NAME": "Deal name",
      "DEAL_PRICE": "Deal price",
      "COMPANIES_USING": "Used by companies",
      "PICK_COMPANIES": "Select companies",
      "ASSIGN_TO_COMPANIES": "Make available to companies",
      "ASSIGN_LATER": "You can also create the deal now, and assign it to companies later.",
      "EDIT_DEAL": "Edit deal \"{{dealName}}\"",
      "CREATE": "Create deal",
      "MODAL_WARNING": "It is currently not possible to edit or delete deals once they are created. You may, however, assign the deal to companies freely after creation.",
      "COMPANY_DEALS": "Company deals",
      "WARNING_BANNER_TITLE": "Make sure everything looks correct!",
      "WARNING_BANNER_TEXT": "Once you save changes you will not be able to remove the deals again.",
      "NO_DEALS_ADDED": "No deals added yet",
      "MAKE_DEFAULT": "Make default",
      "USERS_USING": "{{value}} / {{total}} ({{percentage}}%) deal licenses in use",
      "USERS_USING_SIMPLE": "{{value}} / {{total}} deal licenses in use",
      "USERS_USING_NO_LIMIT": "{{value}} / unlimited deal licenses in use",
      "SET_LIMIT": "Set limit",
      "CHANGE_LIMIT": "Change limit",
      "OTHER_DEALS": "Other deals in the building",
      "NO_MORE_DEALS": "No more deals available",
      "GUEST_DEAL": "Guest deal",
      "GUEST_DEAL_INFO": "Guest deals are not subject to user limits. Companies can assign unlimited guest deals.",
      "GUEST": "Guest",
      "TYPE": "Type",
      "MAX_USERS": "Deal license limit",
      "UNLIMITED": "Unlimited",
      "LUNCH_CREDIT": {
        "HEADER": "Monthly lunch credit per user",
        "DESCRIPTION": "The lunch credit applies to all users in the company who have a lunch deal (except those with a guest deal). The credit amount is renewed in the user's wallet monthly. Unused credit does not roll over to the next month - it is lost. If the user spends all their credit, they pay for lunch from their personal balance.",
        "LABEL": "Credit amount (monthly, per user)",
        "NO_CREDIT": "No credit",
        "EDIT": "Edit credit amount",
        "WARNING_BOLD": "Double-check that the amount is correct. ",
        "WARNING_TEXT": "It is currently not possible to edit the amount after it is saved for the first time.",
        "COLUMN_HEADER": "Credit amount"
      },
      "NO_MATCHING_DEALS": "No deals match your search",
      "CHOOSE_VARIANT": "Choose the lunch product the deal applies to",
      "CHOOSE_OTHER_VARIANT": "Back to products",
      "PRICE_PER_LUNCH": "Price per lunch",
      "PRICE_INFO": "This is the full price for one lunch, excluding subsidies.",
      "CUSTOMER_PAYS": "<blue>Customer</blue> pays (%)",
      "EMPLOYER_SUBSIDIZES": "<green>Employer</green> subsidizes (%)",
      "COST_DISTRIBUTION": "Cost distribution",
      "DEDUCTED_FROM_WALLET": "Deducted from the user's wallet",
      "INVOICED_TO_EMPLOYER": "Invoiced to the employer",
      "IS_GUEST_DEAL": "This is a lunch deal for guests",
      "IS_GUEST_DEAL_INFO": "Lunch deals for guests cannot be restricted per company. This means that companies with this deal can assign it to as many users as they wish.",
      "NOT_CONFIGURED_TITLE": "Lunch is not fully configured",
      "NOT_CONFIGURED_INFO": "Before you can create a lunch deal, you must configure the lunch products for the restaurant. This is done in ",
      "RESTAURANT_SETTINGS_LINK": "the restaurant settings",
      "SUBSIDY": "Subsidy"
    },
    "SETTINGS": {
      "ADMINS": {
        "HEADER": "Food admins",
        "DESCRIPTION": "These users can manage the restaurant's Welcome Food settings and lunch deals. Add or remove people from the supplier company below.",
        "ADD": "Add food admin",
        "NO_DATA": "No food admins yet",
        "ADD_MODAL": {
          "HEADER": "Add food admin",
          "BODY": "Search for a person from the supplier company to give them food admin access.",
          "NO_RESULTS": "No users found",
          "ALREADY_ADMIN": "{{userName}} is already a food admin",
          "SUCCESS": "{{userName}} was added as a food admin",
          "ERROR": "Could not add {{userName}} as a food admin"
        },
        "REMOVE_SUCCESS": "Food admin removed",
        "REMOVE_ERROR": "Could not remove food admin"
      },
      "LUNCH_HOURS": "Lunch hours",
      "LUNCH_HOURS_DESCRIPTION": "These hours are displayed on the screen in the employee restaurant and outline the times in which customers are welcome to have lunch.",
      "COMPLETE_SETUP_HEADER": "You need to complete the restaurant setup",
      "COMPLETE_SETUP_BODY": "To finish setting up the restaurant and start using Welcome Food, you need to set up and connect your Mollie payment account to Welcome Workdays. This setup only has to be completed once and takes just a few minutes.",
      "CONNECT_MOLLIE": "Connect your Mollie payment account",
      "MOLLIE_ALREADY_CONNECTED": "Your Mollie account is already connected. Welcome Workdays is now set up as your partner.",
      "MOLLIE_CONNECT_SUCCESS": "Your Mollie account is connected. Welcome Workdays will now act as your partner.",
      "CONNECTING_MOLLIE": "Connecting your Mollie account…",
      "MOLLIE_CONNECTION_FAILED": "Failed to connect your Mollie account. Please try again or contact Welcome Workdays Support.",
      "LUNCH_HOURS_INVALID_OPENING": "Opening time must be before closing time",
      "LUNCH_HOURS_INVALID_CLOSING": "Closing time must be after opening time",
      "GUEST_LUNCH": "Guest lunch",
      "GUEST_LUNCH_DESCRIPTION": "If you enable guest lunch, all guests, regardless of lunch deal or user account, will be able to buy a one-time lunch.",
      "GUEST_LUNCH_TOGGLE": "Enable guest lunch?",
      "GUEST_LUNCH_PRICE": "Total price (incl. VAT)",
      "GUEST_LUNCH_QR_HEADER": "Guest lunch QR code",
      "GUEST_LUNCH_QR_DESCRIPTION": "Print this poster and place it in the restaurant. Guests scan the QR code to buy lunch in this building.",
      "GUEST_LUNCH_QR_COPY": "Copy link",
      "GUEST_LUNCH_QR_COPIED": "Link copied",
      "GUEST_LUNCH_QR_PRINT": "Print poster",
      "GUEST_LUNCH_QR_POSTER_HEADLINE": "Visiting? Buy lunch right from your phone.",
      "GUEST_LUNCH_QR_POSTER_STEP_1": "Scan the QR code",
      "GUEST_LUNCH_QR_POSTER_STEP_2": "Choose number of guests",
      "GUEST_LUNCH_QR_POSTER_STEP_3": "Pay",
      "GUEST_LUNCH_QR_POSTER_STEP_4": "Download your receipt, or get it by email",
      "GUEST_LUNCH_QR_POSTER_NOTE": "No app or account needed.",
      "GUEST_LUNCH_QR_POSTER_CANT_SCAN": "Can’t scan? Go to",
      "LUNCH_PRODUCTS": "Lunch products",
      "LUNCH_PRODUCTS_DESCRIPTION": "The lunch products are displayed on the screen in the employee restaurant so that customers can choose which product they want to buy.",
      "LUNCH_PRODUCTS_INFO": "These currently cannot be edited from the portal. If changes are required, please contact Welcome Workdays support.",
      "EXTERNAL_LOCATION_ID": "External location ID",
      "EXTERNAL_LOCATION_ID_DESCRIPTION": "Your own identifier for this location, used in reports and ERP exports."
    },
    "OVERVIEW": {
      "SUBSIDY_MESSAGE": "The company <bold>subsidized {{subsidyPercentage}}%</bold> of the lunch price.",
      "SUBHEADER": "Here you can view and export data and numbers related to the employee restaurant.",
      "TRANSACTION_ID": "Transaction ID",
      "TIMESTAMP": "Timestamp",
      "DESCRIPTION": "Description",
      "AMOUNT": "Amount",
      "SEE_DETAILS": "See details",
      "BACK_TO_CURRENT_MONTH": "Back to current month",
      "EXPORT_TO_ACCOUNTING": "Export to accounting",
      "SALES_IN_PERIOD": "Sales in period",
      "AVERAGE_LUNCH_PRICE": "Average lunch price",
      "TOTAL_UNUSED_BALANCE": "Total unused balance",
      "SEARCH_IN_TRANSACTIONS": "Search in transactions",
      "SEARCH_IN_COMPANIES": "Search in companies",
      "NO_TRANSACTIONS": "No transactions to show",
      "NO_COMPANIES": "No companies to show",
      "COMPANIES_TABLE_INFO": "Only companies with at least one transaction for the period are visible in this table.",
      "TRANSACTION_DETAILS": "Transaction details",
      "TRANSACTION_PERFORMED_BY_USER": "Transaction performed by user",
      "INSPECT_USER": "Audit user",
      "COMPANIES": {
        "COMPANY_NAME": "Company",
        "TOTAL_SALES": "Total sales",
        "SPENT_BALANCE": "Spent balance",
        "SPENT_CREDIT": "Spent credit",
        "AMOUNT_SUBSIDIZED": "Amount subsidized",
        "TOTAL_INVOICEABLE": "Total invoiceable",
        "TOTAL_INVOICEABLE_INFO": "The sum of spent credit and amount subsidized"
      }
    },
    "USERS": {
      "SEARCH_PLACEHOLDER": "Search users...",
      "SUBHEADER": "Here you can audit and manage lunch deals, transactions and balances for all users in the building.",
      "FILTER_COMPANY_LABEL": "Filter by company",
      "FILTER_COMPANY_PLACEHOLDER": "Filter by company",
      "EXPORT": "Export unused balances",
      "EXPORT_MODAL_TITLE": "Export user balances",
      "EXPORT_DATE_LABEL": "Balance as of end of",
      "EXPORT_DATE_HELPER": "Exports every user holding a balance on the selected date. Users without a balance will not be included in the export.",
      "EXPORT_DATE_TODAY_HELPER": "Exporting the current date can yield misleading results because more transactions may occur after exporting",
      "DISABLED_WALLETS": {
        "BANNER": "These users have deactivated lunch wallets with a remaining balance or a refund in progress. Refunds can be initiated here and are settled within a few working days. Once a refund has settled, the user is removed from this list automatically.",
        "TITLE": "Deactivated wallets",
        "NO_WALLETS": "No deactivated wallets with a balance or pending refund",
        "CURRENT_BALANCE": "Current balance",
        "REFUNDABLE_AMOUNT": "Refundable amount",
        "STATUS_NONE": "Not started",
        "PENDING_TOOLTIP": "Pending with PSP",
        "REQUIRES_SUPPORT": "Contact support",
        "VIEW_USER": "View user",
        "DELETED_LABEL": "Deleted",
        "DELETED_TOOLTIP": "This user has been deleted from the system but still has a wallet with a remaining balance."
      }
    },
    "INSIGHTS": {
      "ADD_TILE": "Add tile",
      "EDIT_TILE": "Edit tile",
      "REMOVE_TILE": "Remove tile",
      "NO_TILES": "No tiles yet — add one to get started.",
      "NO_DATA": "No data for this period",
      "TILE_TYPE": "Tile type",
      "STAT_COUNTER": "Stat counter",
      "CHART": "Chart",
      "LABEL": "Label",
      "LABEL_PLACEHOLDER": "e.g. Total lunches",
      "METRIC": "Metric",
      "METRIC_PLACEHOLDER": "Choose a metric",
      "FORMAT": "Format",
      "NUMBER": "Number",
      "CURRENCY_NOK": "Currency (NOK)",
      "CHART_TITLE": "Chart title",
      "CHART_TITLE_PLACEHOLDER": "e.g. Lunches per day",
      "CHART_TYPE": "Chart type",
      "BAR": "Bar",
      "LINE": "Line",
      "AREA": "Area",
      "PIE": "Pie",
      "GROUP_BY": "Group by (X-axis)",
      "GROUP_BY_PLACEHOLDER": "Choose grouping",
      "BREAK_DOWN_BY": "Break down by (optional)",
      "BREAK_DOWN_BY_PLACEHOLDER": "None",
      "VALUE": "Value (Y-axis)",
      "VALUE_PLACEHOLDER": "Choose value",
      "DATA_SCOPE": "Data",
      "DATA_SCOPE_ALL": "All lunch",
      "DATA_SCOPE_LUNCH": "Employee lunch",
      "DATA_SCOPE_GUEST": "Guest lunch",
      "SUMMARY_KEYS": {
        "LUNCH_COUNT": "Lunch count",
        "AVERAGE_DEAL_PRICE": "Average deal price",
        "TOTAL_SALES": "Total sales",
        "TOTAL_COMPANY_SUBSIDY": "Company subsidy",
        "TOTAL_PAID_FROM_CREDIT": "Paid from credit",
        "TOTAL_PAID_FROM_BALANCE": "Paid from balance",
        "TOTAL_COMPANY_SHARE": "Company share",
        "TOTAL_EMPLOYEE_SHARE": "Employee share",
        "TOPUP_COUNT": "Top-up count",
        "TOTAL_AMOUNT_TOPUP": "Total topped up",
        "TOTAL_UNUSED_BALANCE": "Unused balance",
        "GUEST_LUNCH_PAYMENT_COUNT": "Guest lunch payments",
        "GUEST_LUNCH_GUEST_COUNT": "Guest lunch covers",
        "TOTAL_GUEST_LUNCH_REVENUE": "Guest lunch revenue"
      },
      "GROUP_BY_OPTIONS": {
        "DATE": "Date",
        "COMPANY": "Company",
        "VARIANT": "Lunch variant",
        "PAYMENT_TYPE": "Payment type"
      },
      "VALUE_KEYS": {
        "COUNT": "Count",
        "TOTAL_AMOUNT": "Total amount (NOK)",
        "SUBSIDY": "Subsidy amount (NOK)"
      },
      "PAYMENT_TYPE": {
        "CREDIT": "Credit",
        "BALANCE": "Balance",
        "SUBSIDY": "Subsidy"
      }
    }
  },
  "SNACK_ADMIN": {
    "LIFECYCLE": {
      "HEADER": "Closure",
      "DEADLINE": "Automatic closing time: {{deadline}} (Oslo).",
      "MANUAL": "Manual delivery and closure. No automatic editing deadline.",
      "CLOSED": "Closed for ordinary editing; ready for invoicing.",
      "AWAITING_CLOSURE": "The editing deadline has passed. This order is awaiting closure.",
      "INVALID_SCHEDULE": "The delivery time is missing or invalid. Lifecycle actions are unavailable. Contact your administrator.",
      "SHORT": {
        "CLOSES_AT": "Closes {{deadline}}",
        "MANUAL": "Manual closure",
        "AWAITING_CLOSURE": "Awaiting closure",
        "INVALID_SCHEDULE": "Invalid delivery time"
      },
      "READ_FAILED": "Unable to load orders. Try again.",
      "REFRESH_FAILED": "Unable to refresh. Showing the last loaded data; unsaved changes are kept.",
      "REFRESH_FAILED_NO_DRAFT": "Unable to refresh. Showing the last loaded data.",
      "RETRY": "Retry"
    },
    "ORDER": "Order",
    "TIMEFRAME_FILTER": {
      "LABEL": "Timeframe",
      "ALL": "All",
      "TODAY": "Today",
      "TOMORROW": "Tomorrow",
      "THIS_WEEK": "This Week",
      "CURR_MONTH": "Current Month",
      "LAST_MONTH": "Previous Month",
      "PAST": "Past",
      "LAST_30_DAYS": "Last 30 Days",
      "LAST_90_DAYS": "Last 90 Days",
      "NEXT_30_DAYS": "Next 30 Days",
      "FUTURE": "Future"
    },
    "STATUS_FILTER_ALL": "Any status",
    "TABLE": {
      "SEARCH": "Search for customer or company...",
      "CUSTOMER": "Customer",
      "COMPANY": "Company",
      "PRODUCTS": "Products",
      "PARTICIPANTS_COUNT": "Guests"
    },
    "EXPORT_ORDERS": "Export {{count}} orders",
    "NEW_ORDER": {
      "HEADER": "New order",
      "SUBHEADER": "Here, you can create a new order on behalf of another user in {{buildingName}}.",
      "ADMIN_PRIVILEGES": "As an administrator you are free from regular order limitations, and are also able to add hidden menu items to the order.",
      "ON_BEHALF_OF": {
        "LABEL": "Order on behalf of",
        "INFO": "Type in the user's email to fetch results",
        "NO_RESULTS": "Double-check that the email is correct"
      },
      "NO_USER_SELECTED": {
        "HEADER": "Select a user to begin",
        "BODY": "You must select a user before creating an order on their behalf."
      }
    },
    "ORDER_DETAILS": {
      "ACTIONS": {
        "EDIT": "Edit order",
        "CONFIRM": "Accept order",
        "DENY": "Deny order",
        "PREPARING": "Preparing order",
        "CANCEL": "Cancel order",
        "DELIVERED": "Order was delivered",
        "PICKED_UP": "Order was picked up",
        "CLOSE": "Close order",
        "PRINT": "Print order"
      },
      "RESET_MODAL": {
        "HEADER": "Are you sure?",
        "BODY": "You are about to reset all your changes."
      },
      "DELIVERY_INFO": {
        "PICKUP": "The order will be <bold>picked up {{time}}</bold>",
        "DELIVERY": "The order will be <bold>delivered {{time}}</bold>",
        "PICKUP_WITH_SERVICE": "The order will be <bold>picked up {{time}}</bold>",
        "PICKUP_WITHOUT_SERVICE": "The order will be <bold>picked up {{time}}</bold>",
        "DELIVERY_WITH_SERVICE": "The order will be <bold>delivered {{time}}</bold>",
        "DELIVERY_WITHOUT_SERVICE": "The order will be <bold>delivered {{time}}</bold>"
      },
      "PARTICIPANTS_COUNT": "Number of guests",
      "DENY_MODAL": {
        "TITLE": "Are you sure?",
        "BODY": "The order will be cancelled and cannot be reopened. Please provide a reason for denying the order - so we can inform the customer.",
        "REASON_LABEL": "Reason",
        "REASON_PLACEHOLDER": "We ran out of...",
        "CUSTOMER_PREFERRED_LANGUAGE": "The customer prefers {{language}}"
      },
      "CANCELLED_BY_USER": "Order was cancelled by user",
      "DENIED_BY_ADMIN": "Order was denied by kitchen",
      "WITH_REASON": "with reason: <itallic>\"{{reason}}\"</itallic>",
      "SAVE_MODAL": {
        "TITLE": "Confirm changes",
        "INFO": "We will notify the customer of the changes once you confirm them.",
        "DELIVERED_MAY_CLOSE": "This order has already been delivered. If the automatic closing time for the saved delivery time has passed, saving will also close the order. If the order is closed in the meantime, your changes will not be saved. Closed orders can no longer be edited."
      },
      "MARK_DELIVERED_MODAL": {
        "TITLE": "This will also close the order",
        "BODY": "This order's automatic closing time has already passed. Marking it as delivered or picked up will also close it, and closed orders can no longer be edited. Make any corrections to the order first."
      },
      "CLOSE_MODAL": {
        "TITLE": "Close this order?",
        "BODY": "Closing the order marks it as ready for invoicing. Once closed, it can no longer be edited.",
        "CORRECT_FIRST": "Make any corrections to the order first."
      }
    },
    "ORDER_HISTORY": {
      "HEADER": "Changelog",
      "CREATED_ORDER": "created the order",
      "MADE_CHANGES": "made changes to the order",
      "ACTIONS": {
        "ITEMS_UPDATED": "Cart items",
        "DELIVERY_TYPE_UPDATED": "Service",
        "DELIVERY_TIME_UPDATED": "Delivery time",
        "PARTICIPANTS_COUNT_UPDATED": "Number of guests",
        "INVOICE_REFERENCE_UPDATED": "Invoice reference"
      }
    },
    "SETTINGS": {
      "ADMINS": {
        "HEADER": "Snack admins",
        "DESCRIPTION": "These users can manage the restaurant's Welcome Snack settings and orders. Add or remove people from the supplier company below.",
        "ADD": "Add snack admin",
        "NO_DATA": "No snack admins yet",
        "ADD_MODAL": {
          "HEADER": "Add snack admin",
          "BODY": "Search for a person from the supplier company to give them snack admin access.",
          "NO_RESULTS": "No users found",
          "ALREADY_ADMIN": "{{userName}} is already a snack admin",
          "SUCCESS": "{{userName}} was added as a snack admin",
          "ERROR": "Could not add {{userName}} as a snack admin"
        },
        "REMOVE_SUCCESS": "Snack admin removed",
        "REMOVE_ERROR": "Could not remove snack admin"
      },
      "HEADER": "Restaurant Settings",
      "SUBHEADER": "Here, you can see and edit the settings for the restaurant connected to {{companyName}}.",
      "DELIVERY_METHODS": "Delivery methods",
      "DELIVERY_METHODS_DESCRIPTION": "Choose whether to offer pickup/delivery, when it should be available and how much it should cost. Changes will not affect existing orders.",
      "CLOSED_ON_WEEKENDS": {
        "LABEL": "Closed on weekends",
        "DESCRIPTION": "Customers can't place orders for Saturdays or Sundays, and fixed deadlines count weekdays only. Changing this moves existing deadlines, including those set on items. Existing orders are kept."
      },
      "VAT_UPDATE_BANNER": {
        "TITLE": "We've made some changes!",
        "TEXT": "Snacks now has built-in VAT functionality. To start using it, you need to decide which types of service you want to offer. Until you save the new settings, the module will continue to work exactly as before, without any VAT."
      },
      "OFFER_PICKUP": "Offer pickup?",
      "OFFER_DELIVERY": "Offer delivery?",
      "PICKUP_WITH_SERVICE": "Pickup with service (25% VAT)",
      "PICKUP_WITHOUT_SERVICE": "Pickup without service (15% VAT)",
      "DELIVERY_WITH_SERVICE": "Delivery with service (25% VAT)",
      "DELIVERY_WITHOUT_SERVICE": "Delivery without service (15% VAT)",
      "DURING": "During",
      "FEE": "Fee",
      "PICKUP_LOCATION": "Pickup location",
      "CUTOFF_ORDER_TIME": "Limit when orders can be placed",
      "CUTOFF_ORDER_TIME_DESCRIPTION": "Here, you can set an optional cutoff time for when orders can be placed. You may also choose to have no restriction at all, or always require orders to be placed at least 24 hours in advance.",
      "WITH_CUTOFF": "With cutoff",
      "CUTOFF_24H": "24 hours before",
      "NO_CUTOFF": "No cutoff",
      "CUTOFF_TIME": "Cutoff time",
      "CUTOFF_OPTIONS": {
        "SAME_DAY": "... can be delivered the same day",
        "NEXT_DAY": "... can be delivered tomorrow or later",
        "EVERY_DAY_LABEL": "Order cutoff time every day",
        "DROPDOWN_LABEL": "Before the cutoff time, orders..."
      },
      "CONTACT_DETAILS": {
        "LABEL": "Contact details",
        "DESCRIPTION": "The contact details will be visible to your customers if they have questions or issues with their orders. You can add up to 5 emails. All of them will receive notifications for new orders, but only the first email in the list will be shown to customers.",
        "CHOSEN_PERSON": "Chosen contact person",
        "FIND_USER": "Find user",
        "ADD_EMAIL_LABEL": "Add an email",
        "PROMOTE_HINT": "Click an email to make it the primary contact. Only the first one is shown to customers.",
        "MAX_REACHED": "Maximum number of emails added",
        "NO_EMAILS": "No emails added yet",
        "MODAL": {
          "HEADER": "Add emails",
          "SUBHEADER": "Search for users to add their email as a recipient. All added recipients will receive notifications for new orders.",
          "EMAILS_HEADER": "Added emails"
        }
      },
      "AUTOMATION": {
        "HEADER": "Automation",
        "AUTO_ACCEPT_ORDERS": {
          "LABEL": "Automatically accept orders",
          "DESCRIPTION": "When enabled, all new orders will be automatically accepted without manual intervention."
        },
        "AUTO_PREPARE_ORDERS": {
          "LABEL": "Automatically set status to \"Preparing\"",
          "DESCRIPTION": "When enabled, orders will automatically be set to \"Preparing\" the morning of the scheduled delivery/pickup."
        },
        "AUTO_COMPLETE_ORDERS": {
          "LABEL": "Automatically complete orders",
          "DESCRIPTION": "When enabled, orders will automatically be marked as completed at the time they are scheduled for delivery/pickup."
        },
        "AUTO_DELIVER_AND_CLOSE_ORDERS": {
          "LABEL": "Automatically mark delivery and close orders",
          "DESCRIPTION": "Marks Preparing orders as Delivered at the scheduled delivery/pickup time and closes Delivered orders at the end of the next working day (Monday–Friday, Oslo time). Changes apply to open orders. Enabling this can close overdue Delivered orders on the next run. Turning it off leaves delivery and closure manual and never reopens a Closed order."
        }
      }
    },
    "MENU": {
      "HEADER": "See/Edit Menu",
      "SUBHEADER": "Here, you can see and edit the menu for {{supplierName}}.",
      "ADD_ITEM": "New menu item",
      "ADD_CATEGORY": "New category",
      "TABLE": {
        "NAME": "Product name",
        "CATEGORY": "Category",
        "PRICE": "Price",
        "IMAGE": "Image",
        "CUTOFF": "Order cutoff",
        "CUTOFF_OVERRIDE": "Custom",
        "CUTOFF_DEFAULT": "Default",
        "CUTOFF_OVERRIDE_INFO": "The item's own cutoff applies",
        "CUTOFF_DEFAULT_INFO": "The restaurant's default cutoff applies",
        "CUTOFF_MIXED": "Mixed",
        "CUTOFF_MIXED_COUNT_one": "{{count}} item",
        "CUTOFF_MIXED_COUNT_other": "{{count}} items",
        "ALLERGENS": "Allergens"
      },
      "ITEM": {
        "VARIOUS": "Various settings",
        "SHOULD_BE_AVAILABLE": "Is the item available?",
        "IS_AVAILABLE": "The item is available and <bold>visible</bold> in the menu",
        "IS_NOT_AVAILABLE": "The item is not available and is therefore <bold>hidden</bold> in the menu",
        "ALLERGENS": "Allergens",
        "NO_ALLERGENS": "No allergens",
        "LIMITATIONS": "Limitations",
        "LIMITATIONS_DESCRIPTION": "Set a minimum- and maximum limit on how much of the product can be added to the cart per order.",
        "MIN_ORDER_QTY": "Min. order quantity",
        "MIN_ORDER_QTY_PLACEHOLDER": "No minimum",
        "MAX_ORDER_QTY": "Max. order quantity",
        "MAX_ORDER_QTY_PLACEHOLDER": "No maximum",
        "CREATE": "Create menu item"
      },
      "CATEGORY": {
        "NAME": "Category name",
        "SORT_ORDER": "Placement",
        "CANNOT_DELETE": "You can't delete a category that contains items.",
        "MAKE_VISIBLE": {
          "TOOLTIP": "Make category visible for all users",
          "MODAL_CONTENT": "By making the category visible, all items within the category will become visible to users and available for ordering."
        },
        "MAKE_HIDDEN": {
          "TOOLTIP": "Hide category for regular users",
          "MODAL_CONTENT": "By hiding the category, all items within the category will become hidden from regular users and only visible and available for ordering by admins."
        },
        "VISIBILITY_SUCCESS": "All products in \"{{categoryName}}\" are now {{isHidden}}",
        "BUMP_VAT_LABEL": "Automatically bump VAT to 25% if any item from this category is in the order (e.g. alcohol)",
        "FORCED_VAT": "Forced VAT"
      }
    },
    "PRINT": {
      "GENERATED": "Generated",
      "HEADER": "Order <grey>#{{orderNumber}}</grey>",
      "PRODUCTS": "Ordered products",
      "PRICE_VAT_DISCLAIMER": "* all prices are excl. VAT",
      "PRICE_PER_ITEM": "Price pc.",
      "NUMBER_OF_ORDERS": "Number of orders",
      "SERVICE": "Service",
      "LOCATION": {
        "PICKUP": "<grey>Pickup at</grey> {{location}}",
        "DELIVERY": "<grey>Deliver to</grey> \"{{location}}\""
      },
      "TIME": {
        "PICKUP": "Pickup time",
        "DELIVERY": "Delivery time",
        "PICKUP_WITH_SERVICE": "Pickup time",
        "PICKUP_WITHOUT_SERVICE": "Pickup time",
        "DELIVERY_WITH_SERVICE": "Delivery time",
        "DELIVERY_WITHOUT_SERVICE": "Delivery time"
      },
      "COMPLETED": {
        "PICKUP": "Order has been picked up",
        "DELIVERY": "Order has been delivered",
        "PICKUP_WITH_SERVICE": "Order has been picked up",
        "PICKUP_WITHOUT_SERVICE": "Order has been picked up",
        "DELIVERY_WITH_SERVICE": "Order has been delivered",
        "DELIVERY_WITHOUT_SERVICE": "Order has been delivered"
      }
    }
  },
  "ALLERGENS": {
    "CEREALS_CONTAINING_GLUTEN": {
      "LABEL": "Gluten",
      "DESCRIPTION": "Cereals containing gluten (e.g. wheat, rye, barley, oats)"
    },
    "WHEAT": {
      "LABEL": "Wheat",
      "DESCRIPTION": "Wheat and products made from wheat"
    },
    "RYE": {
      "LABEL": "Rye",
      "DESCRIPTION": "Rye and products made from rye"
    },
    "BARLEY": {
      "LABEL": "Barley",
      "DESCRIPTION": "Barley and products made from barley"
    },
    "OATS": {
      "LABEL": "Oats",
      "DESCRIPTION": "Oats and products made from oats"
    },
    "CORN": {
      "LABEL": "Corn",
      "DESCRIPTION": "Corn (maize) and products made from corn"
    },
    "CRUSTACEANS": {
      "LABEL": "Crustaceans",
      "DESCRIPTION": "Crustaceans (e.g. crab, lobster, shrimp)"
    },
    "CRAB": {
      "LABEL": "Crab",
      "DESCRIPTION": "Crab and crab-derived products"
    },
    "LOBSTER": {
      "LABEL": "Lobster",
      "DESCRIPTION": "Lobster and lobster-derived products"
    },
    "SHRIMP": {
      "LABEL": "Shrimp",
      "DESCRIPTION": "Shrimp and prawn products"
    },
    "EGGS": {
      "LABEL": "Eggs",
      "DESCRIPTION": "Eggs and egg-based products"
    },
    "FISH": {
      "LABEL": "Fish",
      "DESCRIPTION": "Fish and fish-based products"
    },
    "SALMON": {
      "LABEL": "Salmon",
      "DESCRIPTION": "Salmon and salmon-derived products"
    },
    "TUNA": {
      "LABEL": "Tuna",
      "DESCRIPTION": "Tuna and tuna-derived products"
    },
    "PEANUTS": {
      "LABEL": "Peanuts",
      "DESCRIPTION": "Peanuts and peanut-derived products"
    },
    "SOYBEANS": {
      "LABEL": "Soy",
      "DESCRIPTION": "Soybeans and soy-derived products"
    },
    "MILK": {
      "LABEL": "Milk",
      "DESCRIPTION": "Milk and milk-based products"
    },
    "TREE_NUTS": {
      "LABEL": "Tree nuts",
      "DESCRIPTION": "Nuts (e.g. almonds, hazelnuts, walnuts, cashews, pecans, Brazil nuts, pistachios, macadamias)"
    },
    "ALMONDS": {
      "LABEL": "Almonds",
      "DESCRIPTION": "Almonds and almond-based products"
    },
    "HAZELNUTS": {
      "LABEL": "Hazelnuts",
      "DESCRIPTION": "Hazelnuts and hazelnut-based products"
    },
    "WALNUTS": {
      "LABEL": "Walnuts",
      "DESCRIPTION": "Walnuts and walnut-based products"
    },
    "CASHEWS": {
      "LABEL": "Cashews",
      "DESCRIPTION": "Cashews and cashew-based products"
    },
    "PECANS": {
      "LABEL": "Pecans",
      "DESCRIPTION": "Pecans and pecan-based products"
    },
    "BRAZIL_NUTS": {
      "LABEL": "Brazil nuts",
      "DESCRIPTION": "Brazil nuts and Brazil nut-based products"
    },
    "PISTACHIOS": {
      "LABEL": "Pistachios",
      "DESCRIPTION": "Pistachios and pistachio-based products"
    },
    "MACADAMIA_NUTS": {
      "LABEL": "Macadamias",
      "DESCRIPTION": "Macadamia nuts and macadamia-based products"
    },
    "CELERY": {
      "LABEL": "Celery",
      "DESCRIPTION": "Celery and celery-derived products"
    },
    "MUSTARD": {
      "LABEL": "Mustard",
      "DESCRIPTION": "Mustard and mustard-based products"
    },
    "SESAME_SEEDS": {
      "LABEL": "Sesame",
      "DESCRIPTION": "Sesame seeds and sesame-derived products"
    },
    "SULPHUR_DIOXIDE_AND_SULPHITES": {
      "LABEL": "Sulphites",
      "DESCRIPTION": "Sulphur dioxide and sulphites"
    },
    "LUPIN": {
      "LABEL": "Lupin",
      "DESCRIPTION": "Lupin and lupin-derived products"
    },
    "MOLLUSCS": {
      "LABEL": "Molluscs",
      "DESCRIPTION": "Molluscs (e.g. mussels, clams, oysters, squid)"
    },
    "MUSSELS": {
      "LABEL": "Mussels",
      "DESCRIPTION": "Mussels and mussel-based products"
    },
    "CLAMS": {
      "LABEL": "Clams",
      "DESCRIPTION": "Clams and clam-based products"
    },
    "OYSTERS": {
      "LABEL": "Oysters",
      "DESCRIPTION": "Oysters and oyster-based products"
    },
    "SQUID": {
      "LABEL": "Squid",
      "DESCRIPTION": "Squid and squid-based products"
    },
    "KIWI": {
      "LABEL": "Kiwi",
      "DESCRIPTION": "Kiwi fruit and kiwi-based products"
    },
    "STRAWBERRIES": {
      "LABEL": "Strawberries",
      "DESCRIPTION": "Strawberries and strawberry-based products"
    }
  },
  "NEWS": {
    "CATEGORIES": {
      "DEFAULT": "News",
      "OPERATIONAL": "Operational"
    },
    "MARK_ALL_AS_READ": "Mark all as read"
  },
  "BUILDING_ADMIN": {
    "COLUMNS": {
      "ACCESS_ADMIN": "Access administrator"
    },
    "ACCESS_ADMIN": {
      "TOOLTIP": "Access administrators can manage access related modules in this building."
    }
  },
  "COMPANY_ADMIN": {
    "COLUMNS": {
      "ACCESS_ADMIN": "Access administrator"
    },
    "ACCESS_ADMIN": {
      "TOOLTIP": "Access administrators can manage access related functionality for company employees."
    }
  },
  "ACCESS_ADMIN": {
    "INVITE": {
      "DESCRIPTION": "Can manage access related functionality",
      "TOOLTIP_DISABLED": "Only access administrators can grant access administrator rights.",
      "ASSIGN_WARNING": "The administrator was added, but access administrator rights could not be assigned."
    }
  },
  "BOOKINGS": {
    "THIS_IS_A_COMBINATION": "This is a combination of",
    "EVENT_FROM_COMBINED": "Booking from a linked room",
    "YOUR_EVENT_FROM_COMBINED": "Your booking from a linked room",
    "EVENTS_FROM_COMBINED": "{{count}} bookings from linked rooms",
    "YOUR_EVENTS_FROM_COMBINED": "Your {{count}} bookings from linked rooms",
    "BUFFER_TIME": "{{buffer}} buffer time between bookings",
    "HISTORY_TABLE": {
      "STATUS": {
        "CONFIRMED": "Completed",
        "CANCELLED": "Cancelled"
      }
    },
    "BUILDING_TABLE": {
      "CREATED_TIME": "Booked at",
      "UPDATED_TIME": "Updated at",
      "NO_BOOKINGS": "No bookings to show",
      "STATUS": {
        "CONFIRMED": "Confirmed",
        "CANCELLED": "Cancelled"
      },
      "TOTAL_COST": "Total cost"
    },
    "COST_BREAKDOWN": {
      "LABEL": "Cost breakdown:",
      "FIXED_FEE": "Fixed fee: {{fixedFee}}.",
      "RATE_AND_DURATION": "Hourly rate: {{hourlyRate}} for {{duration}}.",
      "SUBTOTAL": "Subtotal: {{subtotal}}.",
      "SUBTOTAL_CAPPED": "Subtotal: {{subtotal}}, reduced to the price cap of {{maxPrice}}.",
      "DISCOUNT": "Discount: {{percentage}}, {{amount}}.",
      "TOTAL": "Total: {{total}} exc. VAT."
    },
    "BOOKING": "Booking",
    "BOOKING_DETAILS": "Booking details",
    "TOGGLE_SHOW_ALL": {
      "SHOW": "Show {{count}} more bookings",
      "HIDE": "Hide {{count}} bookings"
    },
    "NO_ROOMS": {
      "HEADER": "No rooms yet",
      "BODY": "Once common rooms are available, you will see them here!",
      "ADMIN_BODY": "Once created, you will be able to see and edit them here!"
    },
    "FILTERS": {
      "DATE": "Date",
      "START_TIME": "Start Time",
      "DURATION": "Duration",
      "CAPACITY": {
        "LABEL": "Capacity",
        "PLACEHOLDER": "Any capacity"
      },
      "FEATURES": {
        "LABEL": "Amenities",
        "PLACEHOLDER": "Any amenities"
      }
    },
    "RESULTS": "Available rooms matching your search",
    "NO_RESULTS": {
      "HEADER": "No rooms available",
      "BODY": "Try changing your search criteria such as a different time or date."
    },
    "INVALID_FILTERS": "Invalid filters",
    "ROOM_FEATURES": {
      "SPEAKER": "Speakers",
      "TV": "TV",
      "WHITEBOARD": "Whiteboard",
      "WEBCAM": "Webcam",
      "DUAL_MONITORS": "Dual Monitors",
      "WIRELESS_SCREENSHARE": "Wireless Screensharing",
      "PROJECTOR": "Projector",
      "MIC": "Microphone",
      "COFFEE": "Coffee",
      "HEARING_LOOP": "Hearing loop"
    },
    "MORE_DETAILS": "Learn more about the room",
    "CHECK_AVAILABILITY": "Check availability",
    "BOOK": "Book room",
    "CANCEL": "Cancel booking",
    "ADD_TO_CALENDAR": {
      "LABEL": "Add to calendar",
      "GOOGLE": "Google Calendar"
    },
    "DETAILS": "See details",
    "MODAL": {
      "HEADER": "Confirm your booking",
      "DEFAULT_MEETING_NAME": "New Booking",
      "LABELS": {
        "OPENING_HOURS": "Opening hours",
        "TIME": "Time",
        "BOOKED_BY": "Booked by",
        "COMPANY": "Company",
        "MEETING_TITLE": "Booking title",
        "MEETING_TITLE_PLACEHOLDER": "Use a short and descriptive title",
        "INVOICE_REFERENCE": "Invoice reference",
        "NOTES": "Comment",
        "NOTES_PLACEHOLDER": "Anything the staff should know about the booking?",
        "ROOM": "Room",
        "TOTAL_COST": "Total cost for booking",
        "DISCOUNT": "Discount",
        "PARTICIPANTS_COUNT": "Number of participants"
      },
      "PARTICIPANTS_INFO": "An accurate number helps the staff prepare the room.",
      "MEETING_TITLE_WARNING": "Do not input sensitive information. The title will be publicly visible.",
      "INVOICE_REFERENCE_INFO": "This reference will appear on the invoice for the room.",
      "EDIT_TIMES": "Edit start time and duration",
      "CONFIRM_COST": "I confirm that I am authorized to incur a cost of {{cost}} (exc. VAT) for this booking on behalf of {{companyName}}",
      "CONFIRM": "Confirm booking",
      "SNACK": {
        "HEADER": "Your booking is confirmed!",
        "WANT_FOOD": "Want to order food for your meeting?",
        "DESCRIPTION": "Choose from {{count}} products - <bold>delivered straight to your meeting room!</bold>",
        "AND_MORE_PRODUCTS": "and {{count}} more products",
        "DECLINE": "No thanks, maybe later",
        "SEE_MENU": "See the menu"
      }
    },
    "CANCEL_PROMPT": {
      "HEADER": "Are you sure?",
      "BODY": "Cancelling your booking is permanent, and the timeslot will immediately be available for others to book."
    },
    "DESCRIPTION": "Description",
    "MEETING_FOOD": "This meeting room has catering available, <url>click here to order <icon></icon></url>",
    "AVAILABILITY": {
      "HEADER": "Availability",
      "DESCRIPTION": "Here is an overview of booked timeslots for this room. <bold>Click or drag & hold an available timeslot to book it.</bold>",
      "BANNER": {
        "COMPANY_ADMIN": "This room can only be booked by company administrators. Please contact <mailto>{{companyContact}}</mailto> to book.",
        "BUILDING_ADMIN": "This room can only be booked by building administrators. Please contact the building operations team to book.",
        "NO_COMPANY_CONTACT": "your company administrator"
      }
    },
    "CALENDAR_BOOKED_SLOT": "Busy",
    "CALENDAR_BLOCKED_SLOT": "Blocked by building administrator",
    "VALIDATION": {
      "NO_MULTI_DAY": "Bookings cannot span multiple days",
      "NO_ALL_DAY": "All-day bookings are not supported",
      "OVER_MAX_DURATION": "Booking cannot exceed {{duration}} hours",
      "STARTING_IN_PAST": "Bookings cannot start more than 30 minutes in the past.",
      "OVERLAPPING": "Selected booking time overlaps with another booking",
      "OVERLAPPING_BUFFER": "Selected booking time overlaps with a buffer period between bookings",
      "BLOCKED_TIME": "Selected booking time overlaps with a blocked time span",
      "CLOSED_DAY": "Selected booking time is on a closed day",
      "START_BEFORE_MIN_TIME": "Booking cannot start before {{time}}",
      "END_AFTER_MAX_TIME": "Booking cannot end after {{time}}",
      "LIMIT_REACHED": "You have reached the limit of allowed simultaneous bookings (max {{count}} at a time)",
      "NOTIFICATION_FAILED": "{{entity}} was booked successfully, but we were unable to schedule a reminder. You will not receive a notification. Please report this error to your company administrator.",
      "EDIT_CUTOFF": "Cannot edit within 1 hour of start time",
      "CANCEL_CUTOFF": "Cannot cancel within 1 hour of start time"
    },
    "EDIT": "Edit",
    "ACTIONS": "Actions",
    "EDIT_MODAL": {
      "HEADER": "Edit booking",
      "ORIGINAL_COST": "Original cost",
      "NEW_COST": "New cost",
      "SAVE": "Save changes",
      "CONFIRM_COST": "I confirm the updated cost of {{cost}} (exc. VAT) will be invoiced to {{companyName}}",
      "FOOD_ORDER_WARNING_TITLE": "Confirm changes to booking",
      "FOOD_ORDER_WARNING": "Have you ordered food or drinks for your meeting? Please cancel it separately, or contact the restaurant for changes.",
      "FOOD_ORDER_WARNING_ADMIN": "If the owner of this booking has ordered food or drinks for this meeting, they will need to cancel it separately, or contact the restaurant for changes. Make sure the owner of the booking is aware of this."
    }
  },
  "USERS": {
    "LANGUAGE_PREFERENCE": "Language preference",
    "SEARCH_PLACEHOLDER": "Search for users",
    "CONFIRM": "Confirm",
    "BULK_UPLOAD": {
      "BULK_UPLOAD": "Bulk upload users",
      "HEADER": "Upload users",
      "DESCRIPTION": "Here you can import users to your company’s account. This is the data we expect:",
      "DESCRIPTION_SMALL": "(You will have a chance to rename or remove columns in next steps)",
      "OPTIONAL": "(Optional)",
      "DROPZONE_TITLE": "Upload .xlsx, .xls or .csv file",
      "DROPZONE_BUTTON": "Select file",
      "EMAIL_UNIQUE": "Email must be unique",
      "SELECT_HEADER_TITLE": "Select header row",
      "NEXT_BUTTON": "Next",
      "MATCH_COLUMNS_TITLE": "Match columns",
      "USER_TABLE_TITLE": "Your table",
      "TEMPLATE_TITLE": "Will become",
      "SELECT_PLACEHOLDER": "Select column...",
      "IGNORED_COLUMN_TEXT": "Column ignored",
      "DUPLICATE_COLUMN_WARNING_TITLE": "Another column unselected",
      "DUPLICATE_COLUMN_WARNING_DESCRIPTION": "Columns cannot duplicate",
      "UNMATCHED_REQUIRED_FIELDS_HEADER": "Not all columns matched",
      "UNMATCHED_REQUIRED_FIELDS_BODY": "There are required columns that are not matched or ignored. Do you want to continue?",
      "UNMATCHED_REQUIRED_FIELDS_LIST_TITLE": "Columns not matched: ",
      "VALIDATION_TITLE": "Validate data",
      "DISCARD_BUTTON": "Discard selected rows",
      "FILTER_SWITCH": "Show only rows with errors",
      "NO_ROWS_MESSAGE": "No data found",
      "NO_ROWS_MESSAGE_WHEN_FILTERED": "No data contains errors",
      "CONFIRM_CLOSE_HEADER": "Exit bulk import",
      "CONFIRM_CLOSE_BODY": "Are you sure you want to exit the bulk import? All changes will be lost.",
      "SUBMIT_INCOMPLETE_HEADER": "Errors detected",
      "SUBMIT_INCOMPLETE_BODY": "There are still some rows that contain errors. Rows with errors will be ignored when submitting.",
      "EMAIL_USED": "User with this email already exists. Please remove the row or change the email."
    },
    "ADD_USER": "Add single user",
    "NO_USERS": "No users to show",
    "DELETE_USERS": "Delete selected users",
    "CONFIRM_DELETION": "Are you sure you want to delete <bold>{{selectedUsersCount}} users</bold>?<br/>All their personal data will be permanently deleted, and any services such as access cards, bookings, or orders will be immediately canceled.",
    "MAKE_USERS_VISIBLE": "Make selected users visible",
    "MAKE_USERS_HIDDEN": "Make selected users hidden",
    "INTEGRATE_USERS": "Integrate users with access control system",
    "ASSIGN_FOOD_DEAL": "Assign lunch deal to selected users",
    "ASSIGN_SUBDIVISION": "Assign subdivision to selected users",
    "ASSIGN_SUBDIVISION_DESCRIPTION": "All selected users will become part of the selected subdivision, regardless of any existing subdivision assignments.",
    "ASSIGN_SUBDIVISION_BUTTON": "Assign {{count}} users to subdivision",
    "FOOD": {
      "INTEGRATED": "Active lunch deal",
      "NOT_INTEGRATED": "No lunch deal",
      "DEACTIVATED": "Lunch deal deactivated"
    },
    "TABLE_HEADERS": {
      "ATTRIBUTES": "Attributes",
      "COMPANY_CONTACT": "Company contact",
      "COMPANY_VISITS": "Notified on company visits",
      "NAME": "Name",
      "FIRST_NAME": "First name",
      "LAST_NAME": "Last name",
      "EMAIL": "Email",
      "PHONE": "Phone number",
      "LANGUAGE": "Language",
      "CUSTOM_EMPLOYEE_ID": "Employee ID",
      "ACCESS_CARDS": "Access cards",
      "VISIBLE": "Visitor registration",
      "FOOD": "Welcome Food",
      "SSO": "Login with SSO or with magic link",
      "LAST_LOGIN": "Last login",
      "CREATED_AT": "Created At",
      "COMPANY": "Company",
      "PROFILE_PIC": "Profile image",
      "BUILDING_ADMIN_NOTIFICATIONS": "Notify on access card changes",
      "PART_OF_OPERATIONS": "Is part of operations team",
      "COMPANY_ADMIN_ACCESS_NOTIFICATIONS": "Notify on access card deactivations",
      "COMPANY_ADMIN": "Company administrator",
      "ACCESS_ROLES": "Access groups",
      "STATUS": "User status"
    },
    "STATUS": {
      "ACTIVE": "Active"
    },
    "USER_DISABLED": "This user was disabled<hasDate> on their final working date on {{date}}</hasDate>, and has therefore lost access to all Welcome Workdays services.",
    "REACTIVATE_USER": "Reactivate User",
    "DELETION_WARNING": {
      "SHORT": "User will be deleted {{deletionDate}}",
      "TOOLTIP": "As part of our quarterly review, this user will be deleted on the specified date due to inactivity",
      "BANNER": "As part of our quarterly review, some users will be <bold>deleted {{deletionDate}} due to inactivity</bold>. <button>Click here</button> to see which users this applies to.",
      "BANNER_INACTIVE_ONLY": "As part of our quarterly review, these users will be <bold>deleted {{deletionDate}} due to inactivity</bold>.",
      "BANNER_CURR_USER": "<bold>This user has been inactive since {{lastActiveDate}}</bold>. As part of our quarterly review, this user will therefore be <bold>deleted {{deletionDate}}</bold>.",
      "DELAY_DELETION_BUTTON": "Postpone deletion until next quarter",
      "SHOW_ALL_BUTTON": "Show all users",
      "DELETION_EXTENDED": "Deletion of this user has been extended to {{newDeletionDate}}",
      "DELETION_EXTENSION_FAILED": "Could not postpone deletion of this user. Please try again later or ask the user to log in themselves!"
    },
    "ALSO_ADMIN": "This user is also an administrator for this company.",
    "PROVISIONED": {
      "LABEL": "SCIM",
      "DESCRIPTION": "Managed by your company's user provisioning (e.g. Entra ID). Changes made here may be overwritten on the next sync."
    },
    "ASSIGN_COMPANY_CONTACT": {
      "LABEL": "Assign company contact",
      "DISABLED": "Only users from this company can be assigned company contact",
      "DISABLED_NOT_ADMIN": "You must be an admin of this company to assign a company contact",
      "SUCCESS": "{{userName}} is now the company contact",
      "ERROR": "Failed to assign {{userName}} as company contact. Try again later!"
    },
    "NOTIFY_MODULE": {
      "TOGGLE_ON": "Turn ON {{moduleName}} notifications",
      "TOGGLE_OFF": "Turn OFF {{moduleName}} notifications",
      "SUCCESS_TOGGLED_ON": "{{userName}} will now be notified about each {{moduleName}}!",
      "SUCCESS_TOGGLED_OFF": "{{userName}} will no longer be notified on {{moduleName}}",
      "ERROR": "Failed to update notification settings for {{userName}}. Try again later!"
    },
    "CONFIRM_USER_UPLOD": "Confirm user upload",
    "SHOW_DISABLED_USERS": "Show disabled users",
    "CONFIRM_USER_UPLOAD_DESCRIPTION": "You are about to invite {{count}} users.",
    "SEND_EMAIL": "Send invitation email",
    "SEND_EMAIL_DESCRIPTION": "All users will receive an invitation email with a link to set up their account.",
    "SEND_NO_EMAIL_DESCRIPTION": "No invite email will be send sent to the uploaded users. You will have to notify them manually.",
    "SEND_EMAIL_OFF": "When off, no invite email is sent. Notify users manually",
    "MODULE_NAMES": {
      "COMPANY_VISITS": "company visitor arrival",
      "MEETING_ROOM_BOOKINGS": "meeting room booking",
      "ACCESS_CARD_ORDERS": "access card order",
      "ACCESS_CARD_DEACTIVATIONS": "access card deactivation",
      "BUILDING_ACCESS_CARDS": "access card orders and deactivations",
      "ACCESS_CARD_ORDER_OR_DEACTIVATION": "access card order and/or deactivation"
    }
  },
  "SIDEBAR": {
    "MORE": "More",
    "WORKSPACES": {
      "ARIA_LABEL": "Workspaces",
      "USER": "Me",
      "COMPANY": "Company",
      "BUILDING": "Building",
      "SNACK": "Snacks",
      "FOOD": "Lunch",
      "RESTAURANT": "Setup",
      "SUPER": "Super",
      "OVERVIEW": "Overview",
      "SETTINGS": "My Profile"
    },
    "HOME": "Dashboard",
    "ACCESS": "Access",
    "BUILDING_ACCESS": "Access",
    "BUILDING_ACCESS_ROLE_MANAGEMENT": "Access groups management",
    "COMPANY_ADMIN_HEADING": "Company",
    "BUILDING_ADMIN_HEADING": "Building",
    "VISITORS": "My Visitors",
    "LOG_OUT": "Log out",
    "BOOKINGS": "Bookings",
    "LUNCH": "Lunch",
    "MY_ORDERS": "My Orders",
    "ORDER": "Order Food",
    "BUILDING_BOOKINGS": "All Bookings",
    "INFO": "About the building",
    "HELP": "Help",
    "CHANGELOG": "What's new?",
    "SETTINGS": "Profile",
    "CONSENTS": "Consents",
    "USERS": "Users",
    "SUBDIVISIONS": "Subdivisions",
    "NEWS": "News",
    "COMPANY_BOOKINGS": "Bookings",
    "COMPANY_SETTINGS": "Company Settings",
    "COMPANY_VISITORS": "Visitors",
    "BUILDING_SETTINGS": "Building Settings",
    "BUILDING_COMPANIES": "Companies",
    "BUILDING_VISITORS": "Building Visitors",
    "BUILDING_COMMUNICATION": "Communication",
    "SNACK_ORDERS": "Orders overview",
    "SNACK_MENU": "See/Edit Menu",
    "SNACK_NEW_ITEM": "New Menu Item",
    "SNACK_CATEGORIES": "Categories",
    "LUNCH_OVERVIEW": "Lunch Overview",
    "INSPECT_LUNCH_USERS": "Audit users",
    "FOOD_DEALS": "Companies & Deals",
    "LUNCH_INSIGHTS": "Insights",
    "SNACK_SETTINGS": "Restaurant Settings",
    "SUPER_SETTINGS": "Super settings",
    "SWITCH_TO": "Bytt til {{language}}",
    "LOCKED": {
      "OPEN": "Sidebar is now locked in the open position",
      "CLOSED": "Sidebar is now collapsed when not in use"
    }
  },
  "ADD_USER": {
    "ADD_USER": "Add user",
    "ADD_USER_DESCRIPTION": "The user will receive an invitation email",
    "NAME": "Name",
    "FIRST_NAME": "First name",
    "LAST_NAME": "Last name",
    "EMAIL": "Email",
    "PHONE": "Phone",
    "JOB_TITLE": "Job title",
    "CUSTOM_EMPLOYEE_ID": "Employee ID",
    "CUSTOM_EMPLOYEE_ID_DESCRIPTION": "If you have your own id for users needed for your own systems, you can add it here. If not you can ignore this field",
    "SUBMIT": "Submit",
    "VISIBLE": "Visible in visitor registration",
    "HIDDEN": "Hidden in visitor registration",
    "ADMIN": "Add as company administrator for {{companyName}}",
    "SUCCESS": "User(s) added successfully",
    "FAILED": "User(s) could not be added",
    "ACS_INTEGRATED": "User(s) integrated with access control",
    "SKIPPED": "User(s) already existed and were skipped",
    "ERROR": "An error occurred while adding the user(s)",
    "MISSING_COUNTRY_CODE": "A country code is required (e.g. +47)",
    "CUSTOM_COUNTRY_CODE": "This country code might be unsupported, consider leaving the input blank",
    "EXISTING_USER_MATCHED": "A user with this email already exists in this company under a different building. We’ve matched this user to the existing account and pre-filled their information.",
    "AUTOPROVISIONING_DESCRIPTION": "User will be automatically provisioned in the access control system.",
    "DIGITAL_EMAIL_DESCRIPTION": "Email with digital access card will be sent."
  },
  "EDIT_USER": {
    "EDIT_USER": "Edit user",
    "DELETE": "Delete user permanently",
    "DELETE_MODAL": {
      "HEADER": "Confirm deletion",
      "BODY": "Are you sure you want to permanently delete the account belonging to <bold>{{userName}} ({{userEmail}})</bold>?<br/>All personal data will be permanently deleted, and any services such as access cards, bookings, or orders belonging to the user will be immediately canceled."
    },
    "DELETE_FROM_ACS": {
      "TITLE": "Delete user from access control",
      "MENU_LABEL": "Delete from access control",
      "WARNING_DESCRIPTION": "Are you sure? This will permanently delete the user's cards, PIN code, and all access groups from the access control system.",
      "WARNING_MULTI_BUILDING": "If the user has access to multiple buildings, this will remove them from ALL buildings.",
      "USER_LABEL": "User:",
      "EMAIL_LABEL": "Email:",
      "CONFIRM_BUTTON": "Delete from access control",
      "SUCCESS": "{{userName}} has been deleted from the access control system. The user can now be re-integrated.",
      "ERROR": "Could not delete {{userName}} from the access control system. Please try again."
    },
    "DELETE_FROM_ACS_OR_REMOVE_LOCATION": {
      "MENU_LABEL": "Remove location or delete from access control",
      "WARNING_DESCRIPTION": "Are you sure you want to remove this location from the user's access permissions? If the user only has access to this single location, they will be completely deleted from the access control system. If the user has access to multiple locations, only the current location will be removed from their access permissions."
    },
    "VIEW_IN_SHARRY": "View in Sharry",
    "DELETE_DISABLED_PM": "This user cannot be deleted because they are the current property manager",
    "SAVE": "Save",
    "DANGER": "Permanent actions (danger area)",
    "ADMIN": "Make administrator for {{company}}",
    "ADMIN_SUCCESS": "{{userName}} is now an administrator of {{companyName}}",
    "ADMIN_ERROR": "Could not make {{userName}} an administrator. Try again later!",
    "INTEGRATE": "Integrate user with access control system",
    "ACCESS_READ_ONLY_BANNER": "As a company administrator, you can view access information, however only administrators with access rights can manage access actions such as integrating users, assigning cards, and changing access roles.",
    "INTEGRATE_SUCCESS": "{{userName}} is now integrated with the access control system",
    "INTEGRATE_ERROR": "Could not integrate {{userName}} with the access control system. Try again later!",
    "NO_DEFAULT_ROLES_WARNING": {
      "TITLE": "No default access groups",
      "SUBTITLE": "This company has no default access groups for this building. Integration will be completed without any access groups, and access groups will need to be assigned manually after integration. Do you want to proceed?",
      "CONFIRM": "Proceed anyway",
      "CANCEL": "Cancel"
    },
    "RESIGNATION_DATE": {
      "SET": "Set final working day",
      "DESCRIPTION": "At the end of the given date, the user will lose access to the Welcome Workdays-platform, and any services such as access cards, bookings, or orders will be canceled.",
      "MODAL_DESCRIPTION": "The date will not be visible to the user, and the user will not be notified.",
      "MODAL_CONFIRMATION": "The user will be deactivated {{dateTime}}",
      "BANNER_DESCRIPTION": "The user has their final working day set to {{date}}.",
      "LABEL": "Final working day",
      "CANCEL": "Cancel deactivation",
      "EDIT": "Edit date"
    }
  },
  "ACCESS_CARD": {
    "SEARCH": "Search for access cards",
    "REQUESTS_HEADER": "Card requests",
    "ALL_HEADER": "Active and deactivated cards",
    "HEADER_COUNT_SEARCH": ", {{count}} matching search",
    "LAST_UPDATED": "Last updated",
    "EXPIRES_TODAY": "Expires at the end of the working day",
    "CARD_ORDER": "Plastic access card order",
    "ORDERED": "Ordered",
    "COMPLETED_ORDERS_HEADER": "Completed card orders",
    "ARIA_DESCRIPTION": {
      "PHYSICAL": "Plastic access card",
      "DIGITAL": "Digital access card",
      "PLASTIC": "Plastic access card",
      "VIRTUAL": "Digital access card",
      "TEMPORARY": "Temporary access card"
    },
    "TYPE": {
      "PLASTIC": "Physical Card",
      "VIRTUAL": "Digital Wallet",
      "TEMPORARY": "Temporary access code"
    },
    "SUBTYPE": {
      "DEFAULT": "Mobile Card"
    },
    "DEVICE_TYPE": {
      "MOBILE": "mobile",
      "WATCH": "watch"
    },
    "STATUS": {
      "ORDERED": {
        "LABEL": "Ordered",
        "DESCRIPTION": "The card has been ordered but not yet created."
      },
      "ACTIVE": {
        "LABEL": "Active",
        "DESCRIPTION": "The card is active and can be used to access the building."
      },
      "INACTIVE": {
        "LABEL": "Frozen",
        "DESCRIPTION": "The card is frozen and cannot be used to access the building."
      },
      "DEACTIVATED": {
        "LABEL": "Deactivated",
        "DESCRIPTION": "The card has been deactivated and should be returned to the issuer as soon as possible."
      },
      "CANCELLED": {
        "LABEL": "Cancelled",
        "DESCRIPTION": "The card order has been cancelled and it will not be acted upon."
      },
      "AVAILABLE": {
        "LABEL": "Available",
        "DESCRIPTION": "The card is available and can be assigned to a user."
      },
      "ACTIVATING": {
        "LABEL": "Activating",
        "DESCRIPTION": "The card is being activated and will be ready for use shortly."
      },
      "DEACTIVATING": {
        "LABEL": "Deactivating",
        "DESCRIPTION": "The card is being deactivated and will be unusable shortly."
      },
      "COMPLETED": {
        "LABEL": "Completed",
        "DESCRIPTION": "The card order has been completed and the card is ready for use."
      }
    },
    "NUMBER": "Card nr.",
    "PIN": {
      "LABEL": "PIN",
      "DESCRIPTION": "Reveal PIN",
      "YOUR_PIN": "Your PIN code is:",
      "TOO_LONG": "PIN code cannot be longer than 4 digits",
      "PIN_INFO": "The PIN code must be exactly 4 digits",
      "GENERATE_RANDOM": "Generate random PIN",
      "SUCCESS": "PIN code changed successfully",
      "FAIL": "Failed to change PIN code. Try again later!",
      "PIN_RULES": "PIN code rules",
      "RULES": {
        "INVALID_LENGTH": "PIN must be exactly 4 digits",
        "REPEATED_DIGITS": "The PIN cannot contain the same digit repeated four times (e.g., 1111)",
        "CONSECUTIVE_NUMBERS": "The PIN cannot be a sequence of consecutive numbers in either ascending (e.g., 1234) or descending (e.g., 4321) order",
        "KEYPAD_PATTERN": "The PIN cannot form a straight line pattern on the keypad (e.g., 2580 or 0852)"
      },
      "RESET_PIN_LABEL": "Reset PIN-code",
      "MANAGE_PIN_TITLE": "Manage PIN",
      "APPLIES_TO_ALL_CARDS": "The PIN code applies to all of the user's access cards in the building, both physical and digital.",
      "OVERWRITE_WARNING": "If the user has already set a PIN code, it will be overwritten. You cannot read the existing PIN code – you can only set a new one. Make sure you know what you are doing.",
      "NOTE_AND_SHARE_SECURELY": "We do not store the PIN code – note it down and share it securely with the user.",
      "RESET_SUCCESS_TITLE": "PIN code reset for {{userName}}",
      "NEW_PIN_IS": "New PIN code is:"
    },
    "STARWATCH_BUILDING": {
      "TOOLTIP": "{{functionality}} is not yet implemented at {{buildingName}}.",
      "CHANGE_PIN": "Changing of PIN code",
      "FORGOT_CARD": "Forgot card functionality"
    },
    "NO_CARD_NUMBER": "No card number",
    "NO_PIN": "No PIN has been set",
    "MESSAGE": "Pickup instructions",
    "NOTE": "Note",
    "REASON_FOR_DEACTIVATION": "Reason for deactivation",
    "ACTIONS": {
      "ADD_NOTE": "Add note",
      "ACTIVATE": "Activate card",
      "BLOCK": {
        "LABEL": "Freeze card",
        "TOOLTIP": "Freeze only if the card is lost/stolen or otherwise needs to be deactivated"
      },
      "DEACTIVATE": "Deactivate card",
      "BLOCK_IN_ACS": {
        "LABEL": "Block card",
        "TOOLTIP": "Permanently deactivate card in the access control system"
      },
      "CANCEL_ORDER": {
        "HEADER": "Are you sure?",
        "BODY": "Cancelling the card order is permanent and the card will not be created. The order will be removed from the system.",
        "CANCEL": "Cancel card order",
        "TOOLTIP": "The order will be removed from the system.",
        "ERROR": "Failed to cancel card order. Try again later!",
        "SUCCESS": "Card order cancelled successfully"
      },
      "RESEND_PICKUP_EMAIL": {
        "BUTTON": "Notify user",
        "HEADER": "Notify user again?",
        "BODY": "This will send the user an email letting them know the access card is ready for pick-up, using the same pickup instructions as before.",
        "SUCCESS": "Pickup notification sent successfully",
        "ERROR": "Failed to send pickup notification. Try again later!"
      }
    },
    "BLOCK_MODAL": {
      "HEADER": "Are you sure?",
      "BODY": "Freezing the card will immediately notify the building administrators that the card should be permanently deactivated. You will no longer be able to use the card."
    },
    "COMPANY_ADMIN_PLACEHOLDER": "The user doesn't have any access cards, would you like to order one?",
    "COMPANY_ADMIN_PLACEHOLDER_SHORT": "The user doesn't have any access cards",
    "ORDER_PHYSICAL": "Order physical access card",
    "ORDER_PHYSICAL_DISABLED": "This user already has a pending physical access card order.",
    "ORDER_MESSAGE": {
      "TEXT": "Order message",
      "LABEL": "Order message (optional)",
      "DESCRIPTION": "Attach a message for the person that will process the card order.",
      "APPLY_TO_ALL": "This message will be applied to all the cards in this order."
    },
    "TABLE_HEADERS": {
      "CARD_NUMBER": "Card number",
      "ORDERED_AT": "Ordered",
      "ACTIVATED_AT": "Activated",
      "INACTIVATED_AT": "Frozen",
      "DEACTIVATED_AT": "Deactivated",
      "COMPANY": "Company",
      "ORDERED_BY": "Ordered by",
      "RECIPIENT": "Recipient",
      "STATUS": "Status",
      "FROZEN_CARDS": "Frozen cards",
      "CARD_HOLDER": "Card holder",
      "FROZEN_AT": "Frozen at"
    },
    "DETAILS_MODAL": {
      "HEADER": "Access card details",
      "PHONE_MISSING": "No phone number",
      "HISTORY": "History",
      "NO_HISTORY": "No history to show",
      "ADD_A_COMMENT": "Add a comment",
      "CARD_ORDERED_BY": "Card was ordered by {{ name }} from {{ company }}",
      "WITH_ORDER_MESSAGE": "with order message: \"{{ message }}\"",
      "CARD_ACTIVATED": "Card was activated by {{ name }} from {{ company }} ",
      "WITH_MESSAGE": "with pickup message: \"{{ message }}\"",
      "CARD_INACTIVATED": "Card was frozen by {{ name }} from {{ company }} and a request for deactivation has been sent",
      "CARD_DEACTIVATED": "Card was deactivated by {{ name }} from {{ company }}",
      "ORDER_CANCELLED": "Card order was cancelled by {{ name }} from {{ company }}",
      "WITH_REASON": ", reason given: \"{{ reason }}\"",
      "USERS_PREFFERED_LANGUAGE": "The recipient prefers {{ language }}",
      "CUSTOM_MESSAGE": "or write a custom message",
      "CANCEL_CARD": "Cancel card order",
      "DOWNLOAD_PIC": "Download profile picture",
      "CARD_UPDATED": "Card updated",
      "CARD_CREATED": "Card created",
      "CARD_COMPLETED_BY": "Card order was completed by {{ name }} from {{ company }}",
      "UNKNOWN_USER": "unknown user",
      "UNKNOWN_COMPANY": "unknown company"
    },
    "BLOCK_IN_ACCESS_CONTROL": "Deactivating this card will temporarily block building access. An administrator can later reactivate it or delete it permanently.",
    "BLOCK_IN_ACCESS_CONTROL_MOBILE": "Deactivating the digital access card will permanently remove it from the access control system. This action cannot be undone.",
    "FORGOT_CARD": {
      "TITLE": "Forgot your card?",
      "DESCRIPTION": "You can generate an access code that will open the gates for you. The code will remain valid until the end of the working day.",
      "GENERATE_CODE": "Generate access code",
      "CODE_GENERATED": "Access code generated, we will also send it to your email.",
      "CODE_GENERATION_FAILED": "Failed to generate access code. Try again later!",
      "GENERATING": "We are generating your access code",
      "GENERATING_IN_PROCESS": "We are generating your access code. This may take a few seconds, please wait...",
      "CODE_READY": "Here is your temporary access code to access the building:",
      "CODE_EXPIRES": "Please note, the code will expire at the end of the working day.",
      "DISABLED_DESCRIPTION": "Access code generation is unavailable outside of building opening hours."
    },
    "NEW_ACCESS_CARD": {
      "CREATE": "New access card",
      "HEADER": "Issue new access card",
      "DESCRIPTION": "The card will be activated and ready to use right away.",
      "SEND_EMAIL": "Send email with instructions to the user",
      "SET_PIN_LABEL": "Set PIN code (optional)",
      "PIN_CODE_RECOMMENDATION": "We generally recommend that users set up their own PIN codes.",
      "CARD_FORMAT_LABEL": "Card format",
      "CARD_FORMAT_REQUIRED": "Please select a card format"
    },
    "ACTION_BUTTONS": {
      "ADD_CARD": "Add access card",
      "PRINT_CARD": "Print access card"
    },
    "TABS": {
      "REQUESTS": "Requests",
      "COMPLETED": "Completed"
    },
    "NO_FROZEN_CARDS": "No frozen cards to show",
    "FROZEN_CARD": {
      "REACTIVATE": "Reactivate card",
      "DELETE": "Delete card permanently",
      "DESCRIPTION": "This card is frozen and cannot be used to access the building. You can either reactivate the card or delete it permanently from the access control system.",
      "REACTIVATE_SUCCESS": "Successfully reactivated access card",
      "REACTIVATE_FAIL": "Card reactivation failed. Try again later!",
      "DELETE_SUCCESS": "Successfully deleted access card from access control system",
      "DELETE_FAIL": "Card deletion failed. Try again later!",
      "BLOCK_SUCCESS": "Card successfully frozen"
    },
    "ORDER": {
      "CREATE_BULK_ORDER_one": "Access card order will be created for {{count}} user",
      "CREATE_BULK_ORDER_other": "Access card order will be created for {{count}} users",
      "CREATE_BULK_ORDER_partial": "Access card order will be created for {{eligible}} out of {{total}} users",
      "SKIPPED_NOT_INTEGRATED_one": "{{count}} user is not integrated with the access control system",
      "SKIPPED_NOT_INTEGRATED_other": "{{count}} users are not integrated with the access control system",
      "SKIPPED_HAS_PENDING_ORDER_one": "{{count}} user already has a pending access card order",
      "SKIPPED_HAS_PENDING_ORDER_other": "{{count}} users already have a pending access card order",
      "DISABLED_one": "{{count}} user is disabled",
      "DISABLED_other": "{{count}} users are disabled",
      "BULK_CARD_ORDER_SUCCESS": "Successfully created access card order for {{count}} users",
      "BULK_CARD_ORDER_FAILURE": "Failed to create access card order for {{count}} users. Try again later!"
    }
  },
  "DIGITAL_ACCESS": {
    "SEND": "Send digital access email",
    "DESCRIPTION": "An email with instructions for how to generate a digital access card for {{building}} will be sent to the user",
    "SEND_SUCCESS": "Email with instructions has been sent to the user",
    "SEND_ERROR": "Failed to send email with instructions. Try again later!"
  },
  "ACCESS_GROUPS": {
    "HEADER": "Access groups",
    "DESCRIPTION": "These are the access groups you have been assigned by your company. If you think there's a mistake, please contact your company administrator.",
    "DEFAULT": "Default",
    "NO_GROUPS": "No access groups to show",
    "DESCRIPTION_ADMIN": "Here you can manage the access groups for the users in your company.",
    "UPDATE_SUCCESS": "Access groups updated successfully",
    "UPDATE_ERROR": "Failed to update access groups. Try again later!",
    "RESTRICTED_ROLE": "This access group can only be managed by Company administrators of: {{companies}}",
    "RESTRICTED_ROLE_OTHER_COMPANIES": "This access group can only be managed by Company administrators of other companies"
  },
  "PAGE_LOADING": {
    "LOADING": "Loading",
    "TAKING_TOO_LONG": "Taking too long? Log out and reload the page to try again."
  },
  "LOAD_ERROR": {
    "HEADER": "Something went wrong",
    "BODY": "We couldn't load the page. Get in touch if the problem persists.",
    "DETAILS": "Technical details",
    "COPY": "Copy error details",
    "COPIED": "Copied",
    "RETRY": "Try again"
  },
  "NO_WORKSPACE": {
    "HEADER": "No workspace assigned",
    "BODY": "Your account isn't connected to a building or a company yet. Contact your administrator to get access."
  },
  "AUTH_ERROR": {
    "TITLE": "Oops! An authentication error occurred.",
    "DESCRIPTION": "Log out and reload the page to try again. Make sure you are trying to authenticate using the correct user."
  },
  "LOGIN": {
    "BUTTON": "Login",
    "RE_LOGIN_BUTTON": "Log in again",
    "MAGIC_HELP": "<h2><b>Check your inbox</b></h2><linebreak />If you are registered, you will receive a sign-on link.<linebreak />If not, please contact your company admin.",
    "OTP_HELP": "We sent a code to you email, please enter it here.",
    "NO_ACCESS": "Could not access login service, system could be down. Please try again later.",
    "USER_NOT_FOUND": "Found no user with this email",
    "USER_DISABLED": "That account has been disabled. Please contact your administrator.",
    "SEND_VIA_EMAIL_INSTEAD": "Send code via email instead",
    "SEND_VIA_SMS_INSTEAD": "Send code via SMS instead",
    "OTP_SENT_VIA_EMAIL": "A new code was sent to your email",
    "OTP_SENT_VIA_SMS": "A new code was sent to your phone",
    "OTP_LOCKED": "Too many incorrect codes. Wait a few minutes, then request a new code.",
    "OTP_LOCKED_COUNTDOWN": "Too many incorrect codes. You can request a new code in {{time}}.",
    "OTP_THROTTLED": "Too many attempts. Please wait a moment before trying again.",
    "OTP_THROTTLED_COUNTDOWN": "Too many attempts. Try again in {{time}}.",
    "OTP_CAPTCHA_REQUIRED": "We could not verify that this request came from a person. Reload the page and try again.",
    "REQUEST_NEW_CODE": "Request a new code",
    "SEND_CODE": "Send code"
  },
  "VALIDATION": {
    "NUMBER": "{{field}} must me a number",
    "NUMBER_MIN": "{{field}} must be at least {{min}}",
    "NUMBER_MAX": "{{field}} can't be more than {{max}}",
    "EXACT_LENGTH": "{{field}} must be {{length}} {{type}}",
    "MIN_LENGTH": "{{field}} must be at least {{length}} {{type}}",
    "REQUIRED": "{{field}} is required",
    "INVALID": "{{field}} is invalid",
    "MAX_LENGTH": "{{field}} can't be longer that {{length}} {{type}}",
    "FORBIDDEN_CHARACTERS": "Forbidden characters. Only letters and certain characters are allowed",
    "FORBIDDEN_CHARACTERS_WITH_NUMBERS": "Forbidden characters. Only letters, numbers and certain characters are allowed",
    "INVALID_PHONE": "Phone number must contain country code (eg. +47) and be between 7 and 15 characters long",
    "EMAIL_USED": "User with this email already exists in this building",
    "EMAIL_DIFFERENT_COMPANY": "This user already exists and belongs to a different company in a different building.",
    "DOMAIN": "Email must be from the company domain(s): {{domain}}",
    "CONTRY_CODE_MISSING": "Country code is required (e.g. +47)",
    "SUBMIT_ERROR_TITLE": "Error",
    "SUBMIT_ERROR_DEFAULT_MESSAGE": "An error occurred while submitting the data. Please try again.",
    "SUS_PHONE": "This doesn't look like norwegian phone number, are you sure it's correct?",
    "VISITOR_COUNTRY_CODE_WARNING": "We cannot always reach foreign numbers. Consider contacting the visitor yourself.",
    "DUPLICATE_PHONE": "You've already added a attendee with this phone number",
    "DUPLICATE": "{{field}} already exists. Use a unique value.",
    "INVALID_PHONE_FORMAT": "Invalid phone number format",
    "INVALID_EMAIL_FORMAT": "Invalid email format",
    "CUSTOM_COUNTRY_CODE": "The country code you've entered is unsupported, so we might not be able to contact the attendee",
    "DATE_AFTER_X": "{{field}} must be after {{x}}",
    "DATE_BEFORE_X": "{{field}} must be before {{x}}",
    "DATE_FUTURE": "{{field}} must be in the future",
    "DATE_IN_RANGE": "{{field}} is not in the allowed date range",
    "DATE": "{{field}} must be a valid date",
    "EMOJIS_NOT_SUPPORTED": "Emojis are not supported in SMS messages"
  },
  "SYSTEM_MESSAGE_CONSENT": {
    "LABEL": "Consent to receive system messages",
    "DESCRIPTION": "You will receive system messages via SMS and email from Welcome Workdays AS. These messages are purely for operational purposes, not marketing. This consent is required for the app to function properly."
  },
  "COMPANY_SETTINGS": {
    "CHANGE_LOGO": "Click to upload a new logo",
    "COMPANY_NAME": "Company Name",
    "ORG_NUMBER": "Organization Number",
    "LARGE_FILE_UPLOAD": "Do you have more than 300 users to upload? Please upload your csv file here and we will process it for you.",
    "CUSTOM_LET_IN_MESSAGE": "Custom \"Let in\" message",
    "CUSTOM_LET_IN_MESSAGE_DESCRIPTION": "This message will be send to all visitor when they are let in. Only one language is supported.",
    "CUSTOM_LET_IN_MESSAGE_PLACEHOLDER": "Ex. Take the elevator to the 3rd floor",
    "ADMINS": {
      "HEADER": "Administrators",
      "DESCRIPTION": "Remember to invite the prospective administrator into {{company}} before granting them full access here.",
      "ADD": "Add administrator",
      "ADD_BODY": "Search by the target user's email. You must input the entire email to fetch results. Remember that the user must already have a profile in this building before they can be added as an administrator.",
      "NO_RESULTS": "Check that the email is input correctly and that the user is already part of this company.",
      "CONTACT_DESCRIPTION": "This user is especially responsible for handling user inquiries. Their name and email will be readily available to every user in the company.",
      "COMPANY_VISITS_DESCRIPTION": "These users will be notified when a company visitor (visitor without a specific host) arrives. If no users are selected, all users will be notified.",
      "ACTIONS": "Actions",
      "REMOVE_AS_ADMIN": "Revoke administrator rights",
      "REMOVE_NOT_ALLOWED": "You must assign a different company contact before revoking administrator rights to this user",
      "REMOVE_SUCCESS": "User was removed as administrator for this company",
      "REMOVE_ERROR": "Failed to remove user as administrator. Try again later!",
      "COMPANY_ACCESS_NOTIFICATIONS_DESCRIPTION": "These users will be notified when an access card is deactivated or deleted for a user in this company. If no users are selected, all users will be notified.",
      "ADD_TO_NOTIFICATION_LIST": "Add to notification list",
      "NONE_SELECTED_ALL_NOTIFIED": "Since no administrators are selected, all company administrators will be notified.",
      "NONE_SELECTED_NONE_NOTIFIED": "Since no administrators are selected, no company administrators will be notified."
    },
    "VARIOUS": {
      "NOTIFY_USERS_BEFORE_DELETION": "Notify inactive users by email before deletion",
      "NOTIFY_USERS_BEFORE_DELETION_DESCRIPTION": "Users who have been inactive for a long time will be deleted as part of our quarterly review. When enabled, inactive users will be notified twice, both one month and two weeks before deletion.",
      "SKIP_SAME_COMPANY_USER_DUPLICATION_CHECK": "Skip same company user duplication check",
      "SKIP_SAME_COMPANY_USER_DUPLICATION_CHECK_DESCRIPTION": "When enabled, we will only check if the user already exists in the same building when the new user is added, and skip the check for other companies in other buildings.",
      "SCIM_ENABLED": "Enable user provisioning API (SCIM)",
      "SCIM_ENABLED_DESCRIPTION": "Lets the company's administrators create API tokens so their identity provider or HR system can manage users automatically. Applies to the company in every building. Turning it off blocks existing tokens without deleting them."
    },
    "SCIM": {
      "HEADER": "User provisioning API (SCIM 2.0)",
      "DESCRIPTION": "Let your identity provider (e.g. Microsoft Entra ID) or HR system create, update, deactivate and delete users in {{company}} automatically. New users are added to every building the company is in.",
      "BASE_URL": "Tenant URL",
      "CREATE": "Create token",
      "NO_TOKENS": "No tokens have been created yet.",
      "NAME": "Name",
      "NAME_PLACEHOLDER": "E.g. Entra ID or HR system",
      "EXPIRES_AT": "Expires (optional)",
      "EXPIRES_AT_HELP": "Leave empty for a token that never expires. Integrations stop working when the token expires.",
      "CREATED": "Created {{date}}",
      "LAST_USED": "Last used {{date}}",
      "NEVER_USED": "Never used",
      "EXPIRES": "Expires {{date}}",
      "STATUS_ACTIVE": "Active",
      "STATUS_EXPIRED": "Expired",
      "STATUS_REVOKED": "Revoked",
      "ROTATE": "Rotate",
      "REVOKE": "Revoke",
      "COPY": "Copy",
      "COPIED": "Copied to clipboard",
      "TOKEN_TITLE": "Copy your token now",
      "TOKEN_WARNING": "This is the only time the token is shown. Store it somewhere safe, such as a password manager, and paste it into your identity provider's \"Secret token\" field.",
      "ROTATE_CONFIRM_TITLE": "Rotate \"{{name}}\"?",
      "ROTATE_CONFIRM_BODY": "A new token is created. The current token keeps working for 24 hours, so you have time to update your integration.",
      "REVOKE_CONFIRM_TITLE": "Revoke \"{{name}}\"?",
      "REVOKE_CONFIRM_BODY": "The token stops working immediately. Users it created are kept, and can be managed in the portal again.",
      "REVOKED": "Token revoked",
      "DISABLED": "User provisioning is turned off for {{company}}, so these tokens don't work. You can still revoke them. Contact Welcome Workdays to turn it back on.",
      "ERRORS": {
        "NAME_REQUIRED": "Enter a name",
        "NAME_TOO_LONG": "The name can be at most 100 characters",
        "EXPIRY_IN_PAST": "The expiry date must be today or later"
      }
    },
    "SSO_SETTINGS": "SSO Settings",
    "SSO_SETTINGS_DESCRIPTION": "New to SSO? Learn more about the different <ssoUrl>login methods</ssoUrl> we provide and <azureUrl>SSO with Microsoft Azure</azureUrl>.",
    "CONTACT_ADMIN": "Please contact <mailto>support@welcomeworkdays.com</mailto> to edit domains.",
    "SSO_DOMAIN": "SSO Domain",
    "SSO_PROVIDER": "SSO Provider",
    "VISIT_SETTINGS": "Welcome Visit Settings",
    "BOOKING_SETTINGS": "Welcome Booking Settings",
    "BOOKING_DESCRIPTION": "Welcome Booking is a module that enables reservations of common facilities in the building. Here, you can customize the company's Booking settings. Learn more about <url>Welcome Booking</url>.",
    "BULK_FILE_UPLOAD": "Bulk file upload",
    "VISIT_DESC": "Welcome Visit is a module that enables visitor registration in the building. Here, you can customize the company's Visit settings. Learn more about <url>Welcome Visit</url>.",
    "ACCESS_SETTINGS": "Welcome Access Settings",
    "ACCESS_DESCRIPTION": "Welcome Access is a module that enables access control in the building. Here, you can customize the company's Access settings. Learn more about <url>Welcome Access</url>.",
    "SNACK_SETTINGS": "Welcome Snack Settings",
    "SNACK_DESCRIPTION": "Welcome Snack is a module that enables simple food ordering from the building restaurant. Here, you can customize the company's Snack settings. Learn more about <url>Welcome Snack</url>.",
    "SNACK_ALLOW_INVOICING": "Allow all users to pay with invoicing",
    "SNACK_ALLOW_INVOICING_DESCRIPTION": "When enabled, all the company's users can pay using invoice when ordering food. If the setting is turned off, only company administrators will be able to utilize invoicing as payment method. Regular users may also experience degraded or missing functionality.",
    "FOOD_SETTINGS": "Welcome Food Settings",
    "FOOD_SETTINGS_COMPANY": "Welcome Food Overview",
    "FOOD_SETTINGS_TOTAL_USERS": {
      "TEXT": "{{companyName}} has a total of <strong>{{usersCount}}</strong> users in Welcome Workdays",
      "SUBDIVISION_TEXT": "{{subdivisionName}} has a total of <strong>{{usersCount}}</strong> users in this subdivision",
      "WARNING": "There are currently more users integrated with the restaurant system than are present in the company. This likely means that the data in the restaurant system is outdated and should be audited.",
      "NOT_BUILDING_ADMIN": "Please report this to your building administrator."
    },
    "FOOD_SETTINGS_ACTIVE_USERS": "Active users",
    "FOOD_SETTINGS_DISABLED_USERS": "Deactivated users",
    "FOOD_SETTINGS_NOT_INTEGRATED_USERS": "Not integrated users",
    "FOOD_MAX_USERS": {
      "STATS": {
        "LABEL": "{{companyName}} has a limit of <bold>{{total}}</bold> active lunch deals (guest deals not included), and has spent <colored>{{percentage}}%</colored> of this limit"
      },
      "NO_LIMIT": "{{companyName}} does not have a limit on the number of active lunch deals.",
      "EDIT_LIMIT": "Edit limit",
      "SUBDIVISION_NOTE": "This subdivision has {{activeCount}} active lunch deals. The company limit ({{companyLimit}} active lunch deals) applies to the whole company.",
      "SUBDIVISION_NOTE_NO_LIMIT": "This subdivision has {{activeCount}} active lunch deals. The company has no limit on active lunch deals."
    },
    "FOOD_DESCRIPTION": "Welcome Food is a module that enables seamless food experiences in the building. Here, you can customize the company's Food settings. Learn more about <url>Welcome Food</url>.",
    "FOOD_DESCRIPTION_COMPANY": "Welcome Food is a module that enables seamless food experiences in the building. Here, you can monitor the companies utilization rate and available deals. Learn more about <url>Welcome Food</url>.",
    "VISIT_MODE": {
      "LABEL": "Visitor registration",
      "ENABLED": {
        "LABEL": "Enabled",
        "DESCRIPTION": "When set to <bold>enabled</bold> both the company and it's employees are visible in the visitor registration kiosk."
      },
      "LIMITED": {
        "LABEL": "Limited",
        "DESCRIPTION": "When set to <bold>limited</bold> the company is visible in the visitor registration kiosk, and visitors will be given the instructions that you provide."
      },
      "DISABLED": {
        "LABEL": "Disabled",
        "DESCRIPTION": "When set to <bold>disabled</bold> the company is completely hidden in the visitor registration kiosk."
      }
    },
    "VISITOR_LABEL_PRINTING": {
      "LABEL": "Automatic visitor label printing",
      "DESCRIPTION": "When enabled, visitor labels are printed automatically at check-in when label printing is enabled for the building."
    },
    "FLOOR": "Floor for visitor arrivals",
    "VISITOR_INSTRUCTION": "Instruction for the visitor",
    "EXPORT_VISITORS": {
      "BUTTON": "Export all visitors",
      "DESCRIPTION": "Welcome Workdays only stores visitor data for 30 days. Therefore, this export will include all visitors (both walk-in and preregistered) for {{companyName}} from {{fromDate}} - {{toDate}}."
    },
    "ADD_DOMAINS": "Add domains",
    "ACCESS": {
      "COMPANY_INTEGRATED": "Company integrated with access control system",
      "READ_ONLY_BANNER": "You can view these access settings, but you do not have permission to change them. Only administrators with access rights can edit access control settings.",
      "INTEGRATE_COMPANY": "Integrate company with access control system",
      "INTEGRATE_SUCCESS": "Successfully integrated {{companyName}} with access control system",
      "INTEGRATE_ERROR": "Could not integrate {{userName}} with the access control system. Try again later!",
      "AUTOMATIC_PROVISIONING_MODE": "Automatic provisioning in the access control system",
      "AUTOMATIC_PROVISIONING_MODE_DESCRIPTION": "New users will be automatically created in the access control system upon invitation",
      "DIGITAL_BADGE_MODE": "Digital badge mode",
      "DIGITAL_BADGE_MODE_DESCRIPTION": "Enable users to generate digital badges in access control system",
      "ENABLE_ACCESS_CODE_GENERATION": "Enable access code generation",
      "ENABLE_ACCESS_CODE_GENERATION_DESCRIPTION": "Allow temporary access codes generation for users and visitors in this company",
      "COMPANY_ADMINS_CARD_CREATION": "Allow company administrators to manage access cards",
      "COMPANY_ADMINS_CARD_CREATION_DESCRIPTION": "When enabled, company administrators can create and activate physical access cards for users in their company",
      "COMPANY_ADMINS_PIN_MANAGEMENT": "Allow company administrators to set PIN codes",
      "COMPANY_ADMINS_PIN_MANAGEMENT_DESCRIPTION": "When enabled, company administrators can set or reset PIN codes for users in their company who have never signed in",
      "SEND_DIGITAL_ACCESS_EMAIL_ON_INTEGRATION": {
        "TOGGLE": "Send digital access email on integration",
        "DESCRIPTION": "When enabled, a digital access email will be sent to users upon integration",
        "TOOLTIP": "Can be enabled only if digital badge mode is enabled"
      },
      "ALLOW_CARD_PRINTING_BY_COMPANY_ADMINS": {
        "TOGGLE": "Allow card printing by company administrators",
        "DESCRIPTION": "When enabled, company administrators can print physical access cards for users in their company"
      }
    },
    "FOOD": {
      "COMPANY_INTEGRATED": "Company is linked to restaurant system with ID",
      "COMPANY_NOT_INTEGRATED": "Company is not yet linked to restaurant system",
      "LINK_COMPANY": "Link to restaurant system",
      "MAX_USERS": {
        "LABEL": "Maximum number of active users",
        "PLACEHOLDER": "No limit",
        "INFO": "This optional value limits the amount of active users that {{companyName}} can have in the restaurant system"
      }
    },
    "ACCESS_CONTROL_SYSTEM": {
      "LABEL": "Access control system",
      "INTEGRATED": "Integrated",
      "NOT_INTEGRATED": "Not integrated"
    },
    "ADMIN_NOTIFICATIONS": {
      "HEADER": "Administator notifications",
      "DESCRIPTION": "Choose which company administrators should be notified on {{moduleName}}."
    },
    "ACCESS_GROUPS": {
      "HEADER": "Access groups",
      "DESCRIPTION": "Access roles assigned to this company in the access control system.",
      "EMPTY_STATE": "No access groups assigned to this company yet.",
      "MANAGE_LINK": "Manage access groups",
      "ALLOWED_BY_OTHERS_HEADER": "Assignable by other companies",
      "ALLOWED_BY_OTHERS_DESCRIPTION": "These access groups are managed by another companies, but can still be assigned to this company's users.",
      "VISITOR_ROLES_HEADER": "Visitor access groups",
      "VISITOR_ROLES_DESCRIPTION": "Access groups assigned to this company's visitors.",
      "VISITOR_ROLES_EMPTY_STATE": "No visitor access groups assigned to this company yet."
    }
  },
  "COMPANIES_TABLE": {
    "ACTIVATED_USERS": "Activated users",
    "TOTAL_USERS": "Total users",
    "USERS": "Users (Activated/Total)",
    "FOOD_ACTIVE": "Restaurant users",
    "FOOD_LIMIT": "Restaurant limit",
    "FOOD_USERS": "Restaurant users (Active/Limit)",
    "EXPORT_USERS": "Export users",
    "EXPORT_ALL_USERS": "Export all users",
    "DELETE_COMPANY": "Delete company",
    "TOTAL_ACTIVE_USERS": "A total of <strong><green>{{value}}</green> / {{total}}</strong> <grey>({{percentage}}%)</grey> users have activated their account"
  },
  "COMPANY_DETAILS": {
    "DELETE": {
      "NOT_ALLOWED": "Only companies with no users can be deleted",
      "BUTTON": "Delete company permanently"
    },
    "BECOME_ADMIN": "Become company administrator",
    "NOTIFICATIONS": {
      "ADMIN_SUCCESS": "You are now an administrator of {{companyName}}",
      "ADMIN_ERROR": "Failed to add you as administrator. Try again later!"
    }
  },
  "SUBDIVISIONS": {
    "HEADER": "Subdivisions",
    "SUBHEADER": "Here, you can manage subdivisions within {{companyName}}. Subdivisions help organize users into different departments or teams, making it easier to manage invoicing for services such as meeting rooms and food.",
    "NO_SUBDIVISIONS": "No subdivisions to show",
    "SUBDIVISION": "Subdivision",
    "ADD": "Add subdivision",
    "CREATE": "Create subdivision",
    "EDIT_SUBDIVISION": "Edit subdivision \"{{name}}\"",
    "NAME": "Division name",
    "ASSIGNED_USERS_COUNT": "Users in division",
    "NO_ASSIGNED_USERS": "No users have been assigned to this subdivision yet.",
    "ORG_NUMBER_INFO": "If the subdivision has its own organization number, it will be used on invoices instead of the company's.",
    "INVOICE_REFERENCES": "Invoice references",
    "INVOICE_REFERENCES_INFO": "If the subdivision has specified invoice references, any invoice reference entered when paying for services must be selected from this list.",
    "NEW_INVOICE_REFERENCE": "New invoice reference",
    "NO_INVOICE_REFERENCES": "No invoice references added yet...",
    "CHOOSE": "Choose subdivision...",
    "NOTIFICATIONS": {
      "SUBDIVISION_ASSIGNED_SUCCESS": "{{count}} user(s) were assigned to subdivision \"{{name}}\""
    }
  },
  "ADD_COMPANY": {
    "HEADER": "Invite company to {{buildingName}}",
    "COMPANY_SEARCH_BUTTON": "Search for company",
    "COMPANY_MANUAL_BUTTON": "Input name manually",
    "COMPANY_SEARCH": {
      "LABEL": "Company",
      "PLACEHOLDER": "Search by name or org.number..."
    },
    "COMPANY_TYPE": {
      "LABEL": "Company Type",
      "TENANT": "Tenant",
      "OWNER": "Owner",
      "SERVICE_PROVIDER": "Service Provider",
      "EXTERNAL": "External",
      "SUPPLIER": "Food Supplier",
      "PLACEHOLDER": "Select company type"
    },
    "ORG_NUMBER_REQUIRED_FOR_SUPPLIER": "Organization number is required when company type is \"Food Supplier\"",
    "ENTRANCES": "Entrances",
    "LOGIN_METHOD": {
      "LABEL": "Choose login method",
      "DESCRIPTION": "<ul><li><blue>SSO (Single Sign-On):</blue> Only users with email addresses matching the domains you provide can log in. Default and recommended for security and easy management.</li><li><blue>Passwordless Email Sign-On:</blue> Users can log in with a magic link or a one-time code (OTP), regardless of email domain.</li></ul>",
      "LEARN_MORE": "Learn more about the login options.",
      "EMAIL": "Email/One-Time Code (OTP)"
    },
    "DOMAINS": {
      "HEADER": "Allowed domains for login with SSO",
      "NO_DOMAINS": "No domains have been added yet",
      "DOMAIN": "Domain",
      "PROVIDER": "Provider",
      "ADD": "Another domain",
      "ALREADY_EXISTS": "This domain was already added",
      "REQUIRED": "You must add at least one domain when login method is set to \"SSO\"",
      "INVALID": "One or more domains are invalid",
      "GENERIC_DOMAIN": "Must be a company email domain"
    },
    "ADMIN": {
      "HEADER": "Company administrator",
      "BODY": "This will be the companies first user and administrator."
    },
    "SUBMIT": "Invite company",
    "SUCCESS": "Company was added successfully",
    "SUCCESS_WITH_GOOGLE_SSO_HELP": "Company was added successfully, please note that it might take up to 24 hours for login with SSO to be functional.",
    "ADMIN_ERROR": "Failed to add you as administrator in new company",
    "ADMIN_NOT_INVITED": "Company was created but the administrator could not be invited.",
    "ORG_NUMBER_ALREADY_EXISTS_IN_BUILDING": "Company with this organization number already exists in the building.",
    "COMPANY_NAME_ALREADY_EXISTS_IN_BUILDING": "This company already exists in the building.",
    "STEPS": {
      "STEP_ONE": "General information",
      "STEP_TWO": "Company details",
      "STEP_THREE": "Company administrator"
    },
    "ORG_NUMBER_9_DIGITS": "Organization number must be 9 digits long.",
    "NO_MATCHES_FOUND": "No matches found, try searching with a different term or go to the Next step to create the company manually.",
    "NO_MATCHES_FOUND_QUESTION": "No matches found? Go to the Next step to create the company manually.",
    "LINK_TO_THIS_COMPANY": "Link to this company",
    "NAME_MATCHES_FOUND": "We found following companies in our database matching the search term. If the company you want to add is already listed, please link it to this building instead of creating a new entry.",
    "ORG_NUMBER_MATCH_FOUND": "The company with this organization number already exists in our database. To proceed, please link it to this building.",
    "GLOBAL_MATCH_OVERRIDE": "We found a company with this organization number in another building. Company details were updated to link the same company across buildings.",
    "BRONNOYSUND_ORG_NUMBER_MATCH_FOUND": "Found the match in the Brønnøysund Register Centre. To proceed, please link it to this building.",
    "BRONNOYSUND_NAME_MATCHES_FOUND": "We found following companies in the Brønnøysund Register Centre matching the search term. If the company you want to add is already listed, please link it to this building instead of creating a new entry.",
    "USE_THIS_COMPANY": "Use this company"
  },
  "BUILDING_SETTINGS": {
    "DISPLAY_NAME": "Display name",
    "DISPLAY_NAME_RECOMMENDATION": "Recommended length is 16 characters or less.",
    "LEGAL_NAME": "Legal name",
    "ADDRESS": "Address",
    "TEAM_PHOTO": {
      "HEADER": "Group photo of the operations team",
      "DESCRIPTION": "A team photo of all the building administrators involved in the building's day-to-day operations. The image will be used on the \"Dashboard\"-page to give names and faces to the people making sure the building runs smoothly!"
    },
    "OWNER": "Owner company",
    "OWNER_LOGO": "Owner company logo",
    "WELCOME_SETTINGS": "Welcome Screen",
    "WELCOME_DESCRIPTION": "These settings are applied to the welcome screen every user is greeted with the first time they log in.",
    "SEE_PREVIEW": "Preview",
    "BACK_TO_EDIT": "Edit",
    "BANNER": "Banner image",
    "BANNER_INFO": "The image should be at least 2000px wide and 300px tall. If the image is larger than this only the center section will be displayed.",
    "MANAGER": {
      "LABEL": "Property manager",
      "DESCRIPTION": "This person is responsible for the building and is the one who greets every new user.",
      "POSITION_NB": "Job title (Norwegian)",
      "POSITION_EN": "Job title (English)",
      "PROFILE_IMG": "Profile picture",
      "PROFILE_IMG_INFO": "Profile picture should be sqare and at least 150px X 150px in size."
    },
    "VISIT": {
      "PRINT_ISSUE_NOTIFICATIONS": {
        "HEADER": "Printer issue notifications",
        "DESCRIPTION": "Choose who should receive an email when a visitor reports they did not get a printed label.",
        "FALLBACK": "These users will be notified when a printer issue is reported. If this list is empty, all current building administrators will be notified.",
        "SUCCESS": "Printer issue notification recipients were updated.",
        "ERROR": "Failed to update printer issue notification recipients. Try again later."
      },
      "OPENING_HOURS": {
        "HEADER": "Opening hours",
        "DESCRIPTION": "Set the hours when temporary codes can be generated. Visitors and forgotten-card codes can only be created during these times.",
        "OPENS_AT": "Opens at",
        "CLOSES_AT": "Closes at",
        "SUBMIT_TEXT": "Update opening hours"
      }
    },
    "ADMIN_SETTINGS": "Building administrators",
    "ADMIN_NOTIFICATIONS": {
      "HEADER": "Building administrator notifications",
      "DESCRIPTION": "Choose which building administrators should be notified on {{moduleName}}."
    },
    "ADMIN_AND_RECEPTIONIST_NOTIFICATIONS": {
      "HEADER": "Building administrators and receptionists notifications",
      "DESCRIPTION": "Choose which building administrators and receptionists should be notified on {{moduleName}}."
    },
    "ADMIN_INFO": "Remember to invite the prospective administrator into a company before granting them full access here.",
    "ADD_ADMIN": "Add administrator",
    "ADD_ADMIN_MODAL": {
      "HEADER": "Add building administrator",
      "BODY": "Search by the target user's email. You must input the entire email to fetch results. Remember that the user must already be part of a company before they can be added as a building administrator.",
      "ADD": "Add",
      "NO_RESULTS": {
        "HEADER": "No users found",
        "BODY": "Check that the email is input correctly and that the user is already part of a company."
      },
      "SUCCESS": "{{userName}} was added as an administrator",
      "ALREADY_ADMIN": "{{userName}} is already an administrator",
      "ERROR": "Failed to add {{userName}} as an administrator. Try again later!"
    },
    "ADMINS": {
      "REMOVE_AS_ADMIN": "Revoke building administrator rights",
      "REMOVE_NOT_ALLOWED_WLCM": "You cannot remove Welcome Workdays employees as building administrators",
      "REMOVE_NOT_ALLOWED_PM": "You must assign a different property manager before revoking administrator rights to this user",
      "REMOVE_SUCCESS": "User was removed as building administrator",
      "REMOVE_ERROR": "Failed to remove user as building administrator. Try again later!"
    },
    "RECEPTIONISTS": {
      "HEADER": "Building receptionists",
      "DESCRIPTION": "As a building receptionist, the user will have access to Visit, Booking and Communication Modules as well as information about companies in the building.",
      "ADD": "Add receptionist",
      "ADD_BODY": "Search using the target user's email. Note that the user must already belong to a company before they can be assigned as a building receptionist. Building administrators cannot be assigned as receptionists.",
      "REMOVE_AS_RECEPTIONIST": "Remove as receptionist",
      "REMOVE_SUCCESS": "User was removed as receptionist",
      "REMOVE_ERROR": "Failed to remove user as receptionist. Try again later.",
      "NO_RECEPTIONISTS": "No receptionists to show",
      "ADMINS_NOT_ALLOWED_TO_BE_RECEPTIONISTS": "Building administrators cannot be receptionists. Remove the administrator role from the user first.",
      "SUCCESS": "{{userName}} was added as a receptionist",
      "ALREADY_RECEPTIONIST": "{{userName}} is already a receptionist",
      "ERROR": "Failed to add {{userName}} as a receptionist. Try again later!"
    },
    "CUSTOM_MENU_ITEMS": {
      "HEADER": "Custom menu items",
      "BODY": "Here, you can configure custom menu items that link to external services. You may add up to {{limit}} links.",
      "ENTITY": "Menu item",
      "ADD": "Add menu item",
      "EDIT": "Edit menu item ({{label}})",
      "CHECK_URL": "Check URL",
      "PUBLISH": "Publish",
      "PUBLISH_CHANGES": "Publish changes",
      "DELETE_MODAL": {
        "HEADER": "Are you sure?",
        "BODY": "You are about to delete the menu item linking to:<linebreak/><link/><linebreak/>This is a permanent change that will affect all users in the building."
      },
      "TABLE": {
        "NO_ITEMS": "No custom menu items have been added yet!",
        "LABEL": "Label",
        "VISIBILITY": {
          "HEADER": "Menu section",
          "USER": "Personal",
          "COMPANY_ADMIN": "Company admins"
        }
      }
    },
    "BOOKING": {
      "DISABLED": {
        "HEADER": "Welcome Booking is <bold>disabled</bold> in {{buildingName}}",
        "BODY": "Please contact <mailto>{{supportEmail}}</mailto> if you wish to enable this product. Learn more in the <help>Welcome Booking help pages</help>."
      },
      "HEADER": "Booking Settings",
      "DESCRIPTION": "These settings are applied to all bookings made in the building. Learn more in the <help>Welcome Booking help pages</help>.",
      "MAX_DAYS_AHEAD": {
        "LABEL": "Max booking date",
        "DESCRIPTION": "Determines how far ahead in time a booking can be made."
      },
      "MAX_DURATION": {
        "LABEL": "Booking duration",
        "DESCRIPTION": "Determines the maximum duration of a single booking."
      },
      "MAX_SIMULTANEOUS": {
        "LABEL": "Simultaneous bookings",
        "DESCRIPTION": "Determines how many future bookings a user can have at one time."
      },
      "NOTES": {
        "LABEL": "Allow comments on bookings",
        "DESCRIPTION": "Determines whether users can add comments to their bookings. We recommend keeping this disabled unless there is a specific need for it."
      },
      "ROOMS_SECTION": {
        "HEADER": "All bookable resources",
        "DESCRIPTION": "Here you can manage the bookable resources in the building. You can both add and edit rooms.",
        "CREATE_MEETING_ROOM": "Add new resource"
      },
      "EDIT_ROOM": {
        "COMBINED_ROOM": {
          "SELECT_ROOMS_TITLE": "Select rooms",
          "SELECT_ROOMS_HEADER": "Select which rooms should be linked together",
          "MIN_ROOMS_ERROR": "You must select at least 2 rooms to combine them",
          "INFO_TEXT_1": "It is currently not possible to link the same meeting room to multiple combined rooms. You cannot link already combined rooms together.",
          "INFO_TEXT_BOLD": "Below are all the rooms that are still available to be linked.",
          "ONLY_ONE_ROOM_WARNING": "There is only one room left that is available for linking. It is therefore not possible to create a new combined room.",
          "NO_ROOMS": "No meeting rooms to show",
          "NO_MORE_ROOMS": "There are no more rooms that can be linked together.",
          "FETCH_ERROR": "We could not fetch the meeting rooms. Try again later!",
          "CREATE_INFO": "Combined meeting rooms consist of two or more other rooms, but appear as a standalone room. When a user books a combined room, all sub-rooms are booked simultaneously."
        },
        "CHANGE_INFO": "Any changes made will only affect bookings made after the change is published",
        "THUMBNAIL": "Thumbnail",
        "MAKE_THUMBNAIL": "Make thumbnail",
        "REMOVE_IMG": "Remove image",
        "BOOKING_PERMISSION": "Who can book this room?",
        "BOOKING_PERMISSION_INFO": "Building administrators can always book on behalf of others regardless of this setting",
        "HIDE_EVENT_TITLES": "Hide event titles in the room calendar (recommended)",
        "HIDE_EVENT_TITLES_INFO": "If the box is checked, user's will only be able to see the event titles of their own bookings when viewing the calendar on the room info page. Other bookings will display the name of the company that the booking belongs to.",
        "FEATURES_PLACEHOLDER": "Select features...",
        "BUFFER": {
          "TITLE": "Buffer time after bookings",
          "INFO": "Automatically blocks timeslots following each booking. Building administrators can override the buffer time."
        },
        "PRICING": {
          "TOGGLE": {
            "LABEL": "Pricing",
            "FREE": "Free",
            "HOURLY": "Hourly"
          },
          "HOURLY_RATE": "Hourly rate",
          "MAX_PRICE_PER_BOOKING": {
            "LABEL": "Price cap",
            "PLACEHOLDER": "No price cap"
          },
          "ENABLE_FIXED_FEE": "Enable fixed fee",
          "FIXED_FEE": "Fixed fee",
          "PER_BOOKING": "per booking"
        },
        "MEETING_FOOD": {
          "HEADER": "Catering",
          "DESCRIPTION": "An optional link to a catering service for in-meeting food and drinks. It willl be displayed on the room details page and included in the confirmation email sent to the user upon booking.",
          "LABEL": "Catering URL"
        },
        "FORMATTED_INFO": "Will be displayed as: \"{{formattedValue}}\"",
        "LOCATION": {
          "HEADER": "Location",
          "DESCRIPTION": "This is an optional text description of where the room is located. It is displayed after the floor number, for example: \"2. floor, to the right of the staff kitchen\"."
        },
        "REMINDER_MESSAGE": {
          "HEADER": "Custom reminder message",
          "DESCRIPTION": "This is an optional message that will be included in the reminder SMS/e-mail sent to the user 1 hour before the booking.",
          "LABEL": "Reminder message"
        },
        "DESCRIPTION": {
          "HEADER": "Description",
          "DESCRIPTION": "This is a longer freetext description. It is displayed on the room details page and can be used to provide additional information about the room.",
          "CONTENT_CHANGED": "The original description has changed."
        },
        "OPENING_HOURS": {
          "HEADER": "Opening hours",
          "DESCRIPTION": "The opening hours are displayed on the room details page and enforced during booking, meaning the room cannot be booked outside of opening hours, except by building administrators. You can also close the room completely or block bookings during specific hours on certain weekdays.",
          "OPENS_AT": "Opens at",
          "CLOSES_AT": "Closes at",
          "WEEKDAYS": "Open on",
          "WEEKDAYS_CLOSED": "Closed on"
        },
        "EXTERNAL_OPENING_HOURS": {
          "HEADER": "Opening hours for external companies",
          "DESCRIPTION": "Applies to users in external companies, instead of the opening hours above.",
          "ADD": "Separate opening hours for external companies",
          "REMOVE": "Remove separate opening hours for external companies"
        },
        "WEEKDAYS": {
          "HEADER": "Settings per weekday",
          "DISCLAIMER": "Building administrators can still create bookings during blocked hours and on closed days.",
          "CLOSED": "Block bookings",
          "FROM": "From",
          "TO": "To",
          "REMOVE": "Remove block",
          "COPY": "Copy to all weekdays",
          "ADD": "Add blocked hours"
        },
        "VALIDATION": {
          "NAME": "This name is already in use by another room",
          "LOCATION": "Location cannot be empty in one language only",
          "OPENS_AT": "Opening time must be before closing time",
          "CLOSES_AT": "Closing time must be after opening time",
          "BLOCK_FROM": "Must be at least 30 minutes before the end time",
          "BLOCK_TO": "Must be at least 30 minutes after the start time",
          "BLOCK_STEP": "Must be on the hour or half hour",
          "WEEKDAYS": "Room must be open at least 1 day a week",
          "REMINDER_MESSAGE": "Reminder message cannot be empty in one language only"
        }
      }
    },
    "ACCESS_CONTROL": {
      "DISABLED": {
        "HEADER": "Welcome Access is <bold>disabled</bold> in {{buildingName}}",
        "BODY": "Please contact <mailto>{{supportEmail}}</mailto> if you wish to enable this product. Learn more in the <help>Welcome Access help pages</help>."
      },
      "ENABLED": {
        "HEADER": "{{buildingName}} is <bold>integrated</bold> with Welcome Access Premium",
        "BODY": "No settings are required. Learn more in the <help>Welcome Access help pages</help>."
      },
      "HEADER": "Access control",
      "DESCRIPTION": "These settings affect the access control of every company in the building.",
      "READ_ONLY_BANNER": "As a building administrator, you can view this information. Only administrators with the Access Administrator role can make changes to these settings.",
      "PICKUP_MESSAGE": {
        "LABEL": "Pickup instructions for access cards",
        "DESCRIPTION": "Here you can set the default pickup instructions that the user will receive when their access card is ready for pickup.",
        "MESSAGE_NB": "Pickup instructions (Norwegian)",
        "MESSAGE_EN": "Pickup instructions (English)"
      },
      "PLACEHOLDER_ALT": "Welcome {{product}} placeholder image",
      "PLASTIC_CARD_ORDERING": {
        "HEADER": "Plastic card ordering",
        "DESCRIPTION": "When enabled, company administrators can create an order for physical access cards for company users. The building administrator will receive the card order to complete it.",
        "TOGGLE": "Enable plastic card ordering",
        "TOGGLE_ON": "Plastic card ordering is enabled",
        "TOGGLE_OFF": "Plastic card ordering is disabled"
      }
    },
    "VISIT_MODULE": {
      "DISABLED": {
        "HEADER": "Welcome Visit is <bold>disabled</bold> in {{buildingName}}",
        "BODY": "Please contact <mailto>{{supportEmail}}</mailto> if you wish to enable this product. Learn more in the <help>Welcome Visit help pages</help>."
      }
    },
    "COMPLIANCE": {
      "DISABLED": {
        "HEADER": "Welcome Compliance is <bold>disabled</bold> in {{buildingName}}",
        "BODY": "Please contact <mailto>{{supportEmail}}</mailto> if you wish to enable this product."
      },
      "ENABLED": {
        "HEADER": "Compliance settings",
        "BODY": "These settings are applied to all compliance checks in the building."
      }
    },
    "FOOD": {
      "DISABLED": {
        "HEADER": "Welcome Food is <bold>disabled</bold> in {{buildingName}}",
        "BODY": "Please contact <mailto>{{supportEmail}}</mailto> if you wish to enable this product."
      },
      "ENABLED": {
        "HEADER": "Welcome Food is <bold>enabled</bold> in {{buildingName}}",
        "BODY": "Welcome Food is made up of two sub-modules. Please contact <mailto>{{supportEmail}}</mailto> if you wish to enable one or both products."
      }
    },
    "COMMUNICATION": {
      "DISABLED": {
        "HEADER": "Welcome Communication is <bold>disabled</bold> in {{buildingName}}",
        "BODY": "Please contact <mailto>{{supportEmail}}</mailto> if you wish to enable this product. Learn more in the <help>Welcome Communication help pages</help>."
      },
      "ENABLED": {
        "HEADER": "Communication settings",
        "BODY": "These settings are applied to all news articles in the building. Learn more in the <help>Welcome Communication help pages</help>."
      },
      "CUSTOM_AI_INSTRUCTIONS": {
        "HEADER": "Custom AI instructions",
        "DESCRIPTION": "These instructions will be taken into account by the AI model when generating the content of news articles. You may for example add details about the building or personalizations such as desired tone of voice.",
        "LABEL": "Instructions",
        "INFO": "Instructions can be written in either Norwegian or English"
      }
    },
    "ENTRANCES": {
      "HEADER": "Entrances",
      "DESCRIPTION": "These are all the building's entrances. Every company in the building is assigned to use at least one entrance.",
      "ADD": "Add entrance",
      "EDIT": "Edit entrance ({{name}})",
      "DELETE": "Delete entrance permanently",
      "DOWNLOAD_QR": "Download QR code for entrance",
      "REGENERATE_QR": "Generate new QR code for entrance",
      "NO_DATA": "No entrances to display",
      "TABLE_HEADERS": {
        "NAME": "Name",
        "ADDRESS": "Address",
        "WELCOME_URL": "URL for visitor registration"
      },
      "NAME_NB": "Name (Norwegian)",
      "NAME_EN": "Name (English)"
    },
    "ORDER_COMPANIES": {
      "HEADER": "Order of companies",
      "DESCRIPTION": "These are all of the companies which are visible on the visitor registration kiosks. Here, you can order them freely by dragging and dropping them in the desired order. The order will remain the same across all entrances.",
      "PRO_TIP": "Did you know that you can tap the visitor registration kiosk anywhere on the \"home\"-screen 10 times quickly to reveal a \"refresh\"-button? Try it to see your changes take effect immediately! Otherwise, it will update automatically within a few hours.",
      "NOTIFICATIONS": {
        "SUCCESS": "Successfully changed order of companies!",
        "ERROR": "Failed to change the order of companies. Try again later!"
      }
    },
    "NOTIFICATIONS": {
      "ON": "Turn OFF notifications",
      "OFF": "Turn ON notifications",
      "DESCRIPTION": "These users will be notified by e-mail on access card orders and cancellations. If no particular user is selected, all building administrators will be notified.",
      "SUCCESS": "Notification preference saved successfully",
      "ERROR": "An error occurred while saving the notification preference"
    },
    "OPS_TEAM": {
      "ADD": "Add user to operations team",
      "REMOVE": "Remove user from operations team",
      "DESCRIPTION": "These users are part of the daily operations team in the building. If no particular users are selected, all building administrators will be assumed to be part of operations.",
      "SUCCESS": "Operations team was updated successfully",
      "ERROR": "Failed to update operatons team. Try again later!"
    },
    "BOOKING_NOTIFICATIONS": "These users will be notified when a meeting room is booked in the building. If no users are selected, no administrator will be notified.",
    "ROLE_ASSIGNMENT_NOT_ALLOWED_FALLBACK_MESSAGE": "You cannot assign this role to the user."
  },
  "COMMUNICATION": {
    "HEADER": "Manage news",
    "SUBHEADER": "Here you can see, create and administrate news articles in {{buildingName}}.",
    "CATEGORY": "Category",
    "PUBLISHED_AT": "Published at",
    "UPDATED_AT": "Updated at",
    "ARCHIVED_AT": "Archived at",
    "AUTHOR": "Author",
    "TITLE": "Title",
    "READ_BY": "Read by",
    "STATUS": "Status",
    "NEW_ARTICLE": "New article",
    "MORE_NEWS": "See more news",
    "OPERATIONAL": "Operational",
    "NEWS": "News",
    "PUBLISH": "Publish",
    "UNPUBLISH": "Unpublish",
    "NEW_NOTIFICATION": "New email notification",
    "SEND_NOTIFICATION": "Send notification",
    "NOTIFICATION_METHODS": {
      "EMAIL": "Email",
      "SMS": "SMS",
      "EMAIL_AND_SMS": "Email and SMS"
    },
    "STATUSES": {
      "draft": "Draft",
      "planned": "Planned",
      "published": "Published",
      "archived": "Archived"
    },
    "READ_STATS": "The article has been read by <strong><colored>{{value}}</colored> / {{total}}</strong> <grey>({{percentage}}%)</grey> recipients",
    "READ_STATS_PER_COMPANY": "See read statistics per company",
    "RECIPIENTS_STATS": "The article {{tense}} published to <strong><colored>{{value}}</colored> / {{total}}</strong> <grey>({{percentage}}%)</grey> users in the building",
    "NOTIFICATION_STATS": "With these settings <strong><colored>{{value}}</colored> / {{total}}</strong> <grey>({{percentage}}%)</grey> users will be notified",
    "COMPANY_ADMINS": "Company administrators",
    "REGULAR_USERS": "Users",
    "NON_RECIPIENTS": "Excluded from publication",
    "CANNOT_BE_NOTIFIED": "Cannot be notified",
    "HIDDEN_FOR_USERS_INFO": "Welcome Communication is only turned on for building administrators. This page is therefore not accessible for other user groups at the moment.",
    "HIDDEN_FOR_USERS_NOTIFICATION_INFO": "Since Welcome Communication is currently only turned on for building administrators, other user groups will not receive notifications for this article."
  },
  "ARTICLE": {
    "REACH_LOADING": "Calculating recipients…",
    "REACH_ERROR": "Could not calculate recipients.",
    "REACH_RETRY": "Try again",
    "NO_RECIPIENTS": "No recipients can be notified with the current selection.",
    "NO_NOTIFICATIONS_YET": "No users have been notified yet.",
    "CREATE_NOTIFICATION_HERE": "Here you can notify the recipients by email!",
    "STILL_A_DRAFT": "The article is still just a draft.",
    "REMEMBER_TO_PUBLISH": "Remember to publish the article once it's ready!",
    "CONTENT": "Content",
    "CONTENT_LONG": "Article content",
    "CONTENT_CHANGED": "The original content has changed.",
    "RECIPIENTS": "Recipients",
    "RECIPIENTS_WERE_NOTIFIED": "Recipients were notified",
    "COULD_NOT_BE_NOTIFIED": "{{count}} users could not be notified because they have not consented to be notified. They can still see the article, they have just not received a notification.",
    "CANNOT_BE_NOTIFIED": "{{count}} users cannot be notified because they have not given consent for communication that is not strictly operational.",
    "NOTIFICATIONS": "Email notifications",
    "OVERVIEW": "Review and save",
    "BANNER_IMAGE": "Banner image",
    "AUTHOR": "Author",
    "PLANNED_PUBLISH": {
      "LABEL": "Publish time",
      "UNKNOWN": "Not set",
      "SCHEDULED": "Scheduled",
      "INFO": "Schedule when the article should be published. Leave empty to publish immediately when you click Publish."
    },
    "PLANNED_ARCHIVATION": {
      "LABEL": "Unpublish time",
      "INFO": "Schedule when the article should be unpublished (archived). Leave empty to keep the article visible until manually archived."
    },
    "TITLE": "Title",
    "ATTACHMENTS": "Attachments",
    "ALL_COMPANIES": "All companies in the building",
    "HAS_NOTIFICATIONS": "Since notifications have already been sent out for this article, you cannot edit the recipients settings.",
    "RECIPIENT_COMPANIES": "Recipient companies",
    "ALL_RECIPIENT_COMPANIES": "All recipient companies",
    "SINGLE_RECIPIENT_INFO": "Since the article is only published to one company you cannot change this setting.",
    "DISREGARD_CONSENT": "This article only contains essential operational information",
    "DISREGARD_CONSENT_INFO": "Operational information is defined as information that is essential for the security, functionality and basic operations of the building or its occupants access to essential facilities and services.",
    "DISREGARD_CONSENT_AFTER_CONTENT_CHANGED": "Remember to check the box again if the content still only contains essential operational information.",
    "RECIPIENT_GROUP": "Recipient group",
    "RECIPIENT_GROUPS": {
      "ALL_USERS": "All users",
      "ONLY_COMPANY_ADMINS": "Only company administrators"
    },
    "NOTIFICATION_INFO": "Notifications are optional. If you choose \"No notification\" now you may still choose to send a notification later.",
    "NOTIFICATION_METHOD": "Notify recipients",
    "NOTIFICATION_METHODS": {
      "NO_NOTIFICATION": "No notification",
      "EMAIL": "On email",
      "SMS": "On SMS",
      "EMAIL_AND_SMS": "Both email and SMS"
    },
    "NOTIFICATION_COMPANIES": "Send email notification to",
    "NOTIFICATION_GROUP": "User group",
    "NOTIFICATION_GROUPS": {
      "ALL_USERS": "All users",
      "ONLY_ADMINS": "Only admins"
    },
    "NO_NOTIFICATIONS_PLACEHOLDER": "No notifications yet...",
    "SEARCH_PLACEHOLDER": "Search by author or title",
    "ACTIONS": {
      "ARCHIVE": "Archive article",
      "EDIT": "Edit article",
      "DUPLICATE": "Duplicate article",
      "REPUBLISH": "Republish",
      "CANCEL_PUBLISH": "Cancel publication",
      "PUBLISH_NOW": "Publish now",
      "PUBLISH_CHANGES": "Publish changes",
      "DELETE_DRAFT": "Delete draft",
      "PIN": "Pin article",
      "UNPIN": "Unpin article",
      "ATTACH_FILE": "Add attachment(s)"
    },
    "IS_PINNED": "This article is pinned",
    "ARCHIVED_INFO": "This article is archived and therefore no longer visible for users in the portal.",
    "REPUBLISH_INFO": "If you republish the article \"{{articleTitle}}\", it will once again be visible to {{articleReach}} recipients. We will not send out a new notification.",
    "PUBLISH_NOW_INFO": "Publishing will instantly make the article \"{{articleTitle}}\" visible to {{articleReach}} recipients.",
    "NOTIFICATION_MESSAGES": {
      "ARCHIVATION_SUCCESS": "Successfully archived article! It is now hidden from all users.",
      "ARCHIVATION_ERROR": "Failed to archive article. Try again later!",
      "CANCEL_PUBLISH_SUCCESS": "Successfully cancelled planned publication of article! It is no longer scheduled for publication.",
      "CANCEL_PUBLISH_ERROR": "Failed to cancel planned publication of article. Try again later!",
      "PUBLISH_SUCCESS": "Successfully published article! It is now visible for all recipients.",
      "PUBLISH_ERROR": "Failed to publish article. Try again later!",
      "SAVE_DRAFT_SUCCESS": "Successfully saved draft. It is only visible to you and other building administrators.",
      "SAVE_DRAFT_ERROR": "Failed to save draft. Try again later!",
      "SAVE_CHANGES_SUCCESS": "Successfully saved changes. The updated article content is now visible to all recipients.",
      "SAVE_CHANGES_ERROR": "Failed to save changes. Try again later!",
      "PIN_SUCCESS": "Successfully pinned article! It is now visible at the top of the news feed.",
      "PIN_ERROR": "Failed to pin article. Try again later!",
      "UNPIN_SUCCESS": "Successfully unpinned article! It is no longer visible at the top of the news feed.",
      "UNPIN_ERROR": "Failed to unpin article. Try again later!",
      "PARTIAL_ATTACHMENT_SUCCESS": "{{count}} attachment(s) failed to upload. Try again later!",
      "ATTACHMENT_OPEN_FAILED": "Failed to open/download attachment. Try again later!",
      "RAW_ATTACHMENT": "The attachment has not yet been processed and can therefore not be opened or downloaded."
    },
    "PREVIEW": {
      "LANGUAGE": {
        "NO": "No",
        "EN": "En"
      },
      "MOBILE": "Mobile",
      "DESKTOP": "Desktop",
      "SUBMIT": "Publish article",
      "SAVE_DRAFT": "Save draft and close"
    },
    "GENERATE_CONTENT": {
      "TRY_AI_TOOLS": "When you see this <icon/> icon you may try our AI text- and image generation tools",
      "TRY_WRITING_WITH_AI": "Try writing the article using artificial intelligence (AI)",
      "GENERATE_WITH_AI": "Write with AI",
      "MODAL": {
        "HEADER": "Generate article content using AI",
        "DESCRIPTION": "Here, you can generate the article content using artificial intelligence (AI).",
        "DISCLAIMER": "AI can make mistakes. Remember to review the generated content before publishing.",
        "OVERRIDE_WARNING": "You have existing content, which will be overridden if you generate content.",
        "PROMPT": {
          "LABEL": "What is the article about?",
          "PLACEHOLDER": "Describe concisely what the article is about"
        },
        "SUBMIT": "Generate",
        "TEMPLATES": {
          "LABEL": "Start with a template:",
          "OPERATIONS": {
            "LABEL": "Operations notice",
            "PROMPT": "Operations notice:\nWhat is happening: \nWhen: \nHow does it affect tenants: \nWhat should they do: "
          },
          "EVENT": {
            "LABEL": "Event",
            "PROMPT": "Event:\nWhat: \nWhen: \nWhere: \nWho can attend: \nRegistration: "
          },
          "NEWS": {
            "LABEL": "News",
            "PROMPT": "News:\nWhat is new: \nWhy is this relevant for people working in the building: "
          },
          "HSE": {
            "LABEL": "Health & Safety",
            "PROMPT": "Health & Safety notice:\nWhat it concerns: \nWhat employees should do: \nWho to contact with questions: "
          }
        },
        "PROGRESS": {
          "WRITING": "Writing article...",
          "TRANSLATING": "Translating...",
          "ALMOST_DONE": "Almost done..."
        }
      },
      "NOTIFICATIONS": {
        "PARTIAL": "Failed to generate part of the content. Make sure to fill in the field manually."
      }
    }
  },
  "CONTEXT": {
    "BUILDING": "Building",
    "COMPANY": "Company context",
    "SWITCH": "Switch company",
    "SWITCH_BUILDING": "Switch building",
    "OPEN_COMPANY_WORKSPACE": "Open company workspace"
  },
  "ERROR_BOUNDARY": {
    "HEADER": "Oops! Something went wrong.",
    "BODY": "An error has occurred. Please report this error to your administrator.",
    "MESSAGE": "Error message",
    "RELOAD": "Reload page"
  },
  "BUILDING_VISITORS": {
    "TIME": "Time",
    "VISITOR": "Visitor",
    "VISITORS": "Visitors",
    "PRE_REG": "Preregistrations",
    "HOST": "Host",
    "THE_RECEPTION": "The reception",
    "HOST_COMPANY": "Host company",
    "LOCATION": "Location",
    "NO_VISITORS": "No visitors to show",
    "SEARCH_PLACEHOLDER": "Search for visitors",
    "LET_IN": "Let in",
    "HOST_REPLIED": "Host replied",
    "ACCESS_GRANTED": "Access granted at {{timestamp}}",
    "ACCESS_CODE_SENT": "Successfully sent the access code to the visitor",
    "COMMENTS_OR_MESSAGES": "Visitor has comments or messages",
    "ATTENDEE_ARRIVED": "Pre-registered attende has arrived",
    "CHECK_IN": "Check in",
    "ACTIONS": "Actions",
    "CHECKED_IN_AT": "Checked in at {{timestamp}}",
    "NO_ATTENDEES": "No pre-registered attendees to show",
    "PREREG_SEARCH_PLACEHOLDER": "Search for attendee",
    "SEND_SMS_PLACEHOLDER": "Take the elevator to the 3rd floor",
    "CHECK_IN_SUCCESS": "Successfully checked in visitor"
  },
  "401": {
    "HEADER": "You don't have access to that page",
    "BODY": "If you believe this is a mistake, please contact your administrator."
  },
  "404": {
    "HEADER": "That page doesn't exist",
    "BODY": "Please check that the URL is correct and ask your administrator if you think this is an error."
  },
  "PREREGISTRATION": {
    "HEADER": "New preregistration",
    "DESCRIPTION": "Here you register a group visitors for the future date. All attendees will receive an SMS notification with event instructions.",
    "EVENT_NAME": "Event name",
    "EVENT_DESCRIPTION": "Event instructions",
    "DATE": "Date",
    "START_DATE": "Date",
    "START_TIME": "Time",
    "ATTENDEE_LANGUAGE": "Attendee language",
    "NOTIFY_ON": {
      "HOST": "Notify the host on",
      "MYSELF": "I wish to be notified on",
      "CHOICE": "You will be notified on",
      "FIRST_AND_LAST_ARRIVAL": "First and last arrival",
      "EVERY_ARRIVAL": "Every arrival"
    },
    "ADD_ATTENDEES": "Add attendees",
    "ADD_ANOTHER": "Add attendee",
    "DELETE_ATTENDEE": "Delete attendee",
    "NO_ATTENDEES": "No attendees added yet",
    "NOTIFICATION_INFO": {
      "TODAY": "Since the event starts today, all attendees with a listed phone number will be notified by SMS immediately upon invitation.",
      "FUTURE": "All attendees with a listed phone number will be notified by SMS at 7AM on the day of the event.",
      "FUTURE_BEFORE_7AM": "All attendees with a listed phone number will be notified by SMS 30 minutes before the start of the event."
    },
    "INVITE": "Invite {{number}} attendees",
    "ADD_HOST": "Search for the host by email.",
    "NO_RESULTS_COMPANY": "Check that email is correct and that the user is part of the company",
    "NO_RESULTS_BUILDING": "Check that email is correct and that the user is a part of this building",
    "HOST": "Host",
    "HOST_EMAIL": "Host email",
    "DELETE_HOST": "Delete host",
    "EVENT_DESCRIPTION_INFO": "Here you can provide additional event details. These instructions will be included in the SMS notification to attendees.",
    "EVENT_DESCRIPTION_PLACEHOLDER": "The event is hosted on the 3. floor...",
    "PREREGISTRATION_SUCCESS": "Successfully created event and invited attendees",
    "ATTENDEES": "Attendees",
    "SEE_ATTENDEES": "See attendees",
    "ENTRANCE": "Entrance",
    "SEARCH_ATTENDEES": "Search for attendees",
    "NO_SEARCH_RESULTS": "No attendees found",
    "NO_PREREGRISTRATIONS": "{{entity}} have no upcoming group preregistrations",
    "CANCEL": {
      "HEADER": "Cancel \"{{ eventName }}\"",
      "BODY": "Are you sure you want to cancel this group preregistration? If the attendees have already received the invitation SMS they will also be notified of the cancellation. Otherwise no notifications will be sent. Cancelling at least 24 hours in advance guarantees no attendees have received the invitation SMS yet.",
      "CONFIRM": "Cancel event",
      "DISMISS": "Keep event",
      "SUCCESS": "\"{{ eventName }}\" was cancelled. Remember to also inform your attendees manually.",
      "ERROR": "Failed to cancel \"{{ eventName }}\". Try again later and notify your attendees manually."
    },
    "EDIT_PREREG": "Edit group preregistration",
    "EDIT_SUBMIT": "Update group preregistration",
    "EDIT_PREREG_SUCCESS": "Successfully updated group preregistration",
    "EDIT_PREREG_ERROR": "Failed to update group preregistration. Try again later!",
    "UNRECOGNIZED_COUNTRY_CODE": "We can't always reach foreign numbers. Consider notifying the attendee yourself.",
    "ARE_YOU_SURE": "Are you sure you want to continue without phone numbers?",
    "ARE_YOU_SURE_DESCRIPTION": "Some attendees are missing phone numbers, so we can’t notify them or enable self check-in at the building.",
    "BULK_UPLOAD_ATTENDEES": "Bulk upload attendees",
    "BULK_UPLOAD_HEADER": "Upload attendees",
    "BULK_UPLOAD_DESCRIPTION": "Here, you can import attendees to your event. This is the data we expect:",
    "ERROR_SENDING_ACCESS_CODE": "We were not able to send an access code to some of the attendees",
    "ASSUME_LENGTH_INFO": "To visualize preregistration events the system assumes a duration of 2 hours. However, this does not accurately reflect the true duration of the event."
  },
  "VISIT_DETAILS": {
    "VISIT_DETAILS": "Visit details",
    "EVENT_NAME": "Event name",
    "EVENT_DESCRIPTION": "Event details",
    "VISITOR_DETAILS": "Visitor",
    "HOST_DETAILS": "Host",
    "MESSAGE_TO_HOST": "Message to host",
    "START_TIME": "Start time",
    "SMS_FROM_HOST": "SMS from",
    "COMMENT_FROM": "Comment from",
    "ACCESS_GRANTED": "Access granted",
    "VISIT_REQUEST": "Registered visit",
    "CHECKED_IN": "Checked in by {{name}}",
    "SELF_CHECK_IN": "Self check-in",
    "PRINT_LABEL": "Print label"
  },
  "EMPLOYEE_ID": "Employee ID",
  "SIGN_IN_ERROR": {
    "HEADER": "Login link expired or invalid",
    "BODY": "Your session has expired or the link is no longer valid. Please try logging in again.",
    "ALIAS_HEADER": "Your sign-in returned a different email address",
    "ALIAS_BODY": "Your organisation's sign-in returned a different email address than the one you entered, so we could not match it to your account. This usually means your account uses an email alias. Please ask your IT administrator to register the address your organisation signs you in with.",
    "ALIAS_OTP_BUTTON": "Send a login code instead?"
  },
  "BADGE_PRINTING": {
    "TEMPLATES": {
      "HEADER": "Plastic card templates",
      "DESCRIPTION": "Here you can manage the templates used for plastic cards printing. You can add, edit and delete templates.",
      "NEW_TEMPLATE": "New template",
      "NEW_TEMPLATE_DESCRIPTION": "Upload new HTML template for plastic cards printing. Ypu can add variables to the template that will be replaced with the actual values when printing. Optionally, upload css stylesheet and background that will be used in the template.",
      "TEMPLATE": "Template",
      "TEST_TEMPLATE": "Test template variables",
      "ENTER_PLACEHOLDER": "Enter {{variable}}",
      "ASSIGN_COMPANIES_REQUIRED": "You must assign at least one company to the template"
    },
    "TEMPLATE_FORM": {
      "NAME": "Template name",
      "NAME_PLACEHOLDER": "My template",
      "ASSIGNED_TO_COMPANIES": "Assigned to companies",
      "ASSIGNED_TO_COMPANIES_PLACEHOLDER": "Select companies",
      "ALL_COMPANIES": "All companies (includes future companies added to the building)",
      "FRONT_HTML": "Front side (HTML template)",
      "BACK_HTML": "Back side (HTML template)",
      "HTML": "Add HTML template",
      "HTML_PLACEHOLDER": "Upload HTML template",
      "BACKGROUND_IMAGE_FRONT": "Background image for front side",
      "BACKGROUND_IMAGE_BACK": "Background image for back side",
      "CSS": "CSS stylesheet",
      "ADD_CSS": "Add CSS stylesheet",
      "CSS_PLACEHOLDER": "Upload CSS stylesheet",
      "ADD_IMAGE": "Add image",
      "HTML_INFO_TITLE": "Using variables in your template",
      "HTML_INFO_NAME": "Use {{userFirstName}} and {{userLastName}} or {{userFullName}} to inject the user's name.",
      "HTML_INFO_EMPLOYEE_ID": "Use {{employeeId}} to inject the user's employee ID.",
      "HTML_INFO_JOB_TITLE": "Use {{jobTitle}} to inject the user's job title (Optional - will be blank if not provided).",
      "HTML_INFO_PROFILE_PHOTO": "Use {{profilePhoto}} to inject the user's profile photo.",
      "HTML_INFO_BACKGROUND_IMAGES": "Use {{backgroundImageFront}} and {{backgroundImageBack}} to inject front and back background images.",
      "HTML_INFO_COMPANY": "Use {{companyName}} to inject the company name and {{companyLogo}} for the company logo.",
      "HTML_INFO_NOTE": "These variables are optional, but if you want to display user or company information in your template, they need to be included.",
      "PREVIEW": "Preview template",
      "SAVE": "Save template",
      "TEMPLATE_PREVIEW": "Template preview",
      "SUCCESS": "Template created successfully",
      "ERROR": "Failed to create template. Try again later!",
      "UPDATED_SUCCESSFULLY": "Template updated successfully",
      "UPDATE_FAILED": "Failed to update template. Try again later!"
    },
    "TABLE": {
      "ALL_COMPANIES": "All companies",
      "SIDES": "Sides",
      "FRONT_AND_BACK": "Front and back",
      "FRONT_ONLY": "Front only",
      "MORE_COMPANIES": "more companies",
      "DOWNLOAD": "Download template",
      "DELETE": "Delete template",
      "NO_DATA": "No templates available. Please contact Welcome Workdays to create a template.",
      "FAILED_FETCH_ASSETS": "Failed to fetch template assets. Please try again later!",
      "FAILED_DELETE_TEMPLATE": "Failed to delete template. Please try again later!",
      "FAILED_DOWNLOAD_TEMPLATE": "Failed to download template. Please try again later!",
      "CREATED_AT": "Created",
      "CREATED_BY": "Created by"
    },
    "PRINT": {
      "NO_TEMPLATES": "{{companyName}} has no templates available for plastic cards printing. Please contact Welcome Workdays to create a template first.",
      "NO_TEMPLATES_MULTI_COMPANY": "There are no templates that are available for all the companies. Please print the cards individually or assign a template to all the companies in the building.",
      "SELECT_TEMPLATE": "Select a template",
      "FRONT": "Front side",
      "BACK": "Back side",
      "PRINT_CARD_one": "Print card",
      "PRINT_CARD_other": "Print {{count}} cards",
      "MISSING_GENERIC": "{{entity}} is missing a {{variable}} which is required in this template. Please add the {{variable}} before printing the card.",
      "USER": "The user",
      "COMPANY": "The company",
      "PROFILE_PHOTO": "profile photo",
      "LOGO": "logo",
      "EMPLOYEE_ID": "employee ID",
      "PRINT_MULTIPLE": "Print card for chosen users",
      "PREVIOUS": "Previous",
      "NEXT": "Next",
      "MISSING_MULTIPLE_USERS": "{{count}} out of {{total}} users are missing information required in this template:",
      "AND": "and",
      "MISSING_USER_VARIABLES": "<to> {{fullName}} </to> is missing {{variables}}.",
      "PARTIAL_WARNING": "Not all users have the required information. Only {{validCount}} out of {{totalCount}} cards will be printed.",
      "MULTIPLE_USERS_DESCRIPTION": "Selected {{count}} users for card printing.",
      "REMOVE_FROM_PRINT_QUEUE": "Remove {{fullName}} from print queue.",
      "CARD_POSITION": "Card {{current}} of {{total}}",
      "MISSING_REQUIRED_INFO": "Missing required information"
    }
  },
  "NOTIFICATIONS": {
    "DOCUMENT_CREATED": "Successfully created {{entity}}",
    "DOCUMENT_UPDATED": "Successfully updated {{entity}}",
    "SUBDIVISION_LINKED_TO_MUNU": "Subdivision linked successfully with the restaurant system.",
    "LINK_FAILED": "Failed to link. Please try again.",
    "FILE_UPLOAD_SUCCESS": "Successfully uploaded file",
    "DOCUMENT_DELETED": "Successfully deleted {{entity}}",
    "ACCESS_GRANTED": "Successfully granted access",
    "BOOKING_SUCCESS": "Successfully booked {{entity}}",
    "CANCELLATION_SUCCESS": "{{entity}} was cancelled",
    "CREATE_FAILED": "Failed to create {{entity}}. Try again later!",
    "UPDATE_FAILED": "Failed to update {{entity}}. Try again later!",
    "MISSING_OR_INVALID_PARAMS": "Missing or invalid data. If the issue persists, contact your administrator.",
    "SERVER_ERROR": "An unknown system error occurred. Try again later!",
    "DELETE_FAILED": "Failed to delete {{entity}}. Try again later!",
    "UPLOAD_IMAGE_FAILED": "Failed to upload image(s)",
    "IMAGE_PROCESSING_FAILED": "Failed to process image(s). Try uploading a different format!",
    "MAX_FILES_EXCEEDED": "You can only upload {{count}} files",
    "INVALID_FILE_TYPE": "That file type is not supported",
    "INVALID_IMAGE": "Image upload failed due to invalid image data",
    "INVALID_IMAGE_FORMAT": "Image upload failed due to invalid image format",
    "IMAGE_TOO_BIG": "Uploaded image exceeds the maximum allowed size",
    "WITH_FILES": "{{message}}: {{files}}",
    "INVALID_FILE_PATH": "Could not get file due to invalid path. If the issue persists, contact your administrator.",
    "FILE_NOT_FOUND": "The requested file does not exist. If the issue persists, contact your administrator.",
    "FILE_TOO_BIG": "Uploaded file exceeds the maximum allowed size",
    "UPLOAD_FILE_FAILED": "Failed to upload file",
    "SMS_FAILED": "Failed to send SMS. Try again later!",
    "COMMENT_FAILED": "Failed to add comment. Try again later!",
    "ACCESS_FAILED": "Could not grant access. Try again later!",
    "BOOKING_FAILED": "Failed to book {{entity}}. Try again later!",
    "CANCELLATION_FAILED": "Failed to cancel {{entity}}. Try again later!",
    "EMAIL_ALREADY_IN_USE": "Email is already in use, please choose another email.",
    "INVALID_EMAIL_FORMAT": "Invalid email format. Please check and try again.",
    "UNAUTHORIZED_MISSING_USER_ID": "Unauthorized: UserID missing",
    "UNAUTHORIZED_MISSING_USER_OR_COMPANY_ID": "Unauthorized: User- or company ID missing",
    "UNAUTHORIZED_USER_NOT_FOUND": "Failed to authorize this user. Try logging out and back in!",
    "UNAUTHORIZED_BUILDING_NOT_FOUND": "Failed to authorize your access to this building. Try logging out and back in!",
    "FORBIDDEN_INSUFFICIENT_PERMISSIONS": "You don't have permission to perform this action. Contact your administrator if you think this is an error.",
    "INTEGRATION_FAILED": "Failed to integrate with the access control system. Try again later!",
    "INTEGRATION_SUCCESS": "Successfully integrated {{entity}} with the access control system",
    "INTEGRATION_PARTIAL_FAILURE": "{{entity}} could not be integrated with the access control system. Try again later!",
    "NEW_VERSION_AVAILABLE": {
      "MESSAGE": "A new version of the app is available. Please refresh the page to update.",
      "ACTION": "Refresh page"
    },
    "ERROR_CHANGING_PIN_CODE": "An error occurred while changing the PIN code. Please try again later.",
    "ERROR_BLOCKING_ACCESS_CARD": "An error occurred while blocking the access card. Please try again later, and immediately inform the reception and/or your company contact that the card should be blocked.",
    "CLOUD_TASK_FAILED": "An error occurred while scheduling a future event. Please report this error to your administrator.",
    "FUNCTIONALITY_NOT_SUPPORTED_AT_POSTHUSET": "This functionality is not supported at Posthuset. Please contact your administrator for assistance.",
    "ERROR_CREATING_ACCESS_CARD": "An error occurred while creating the access card. Please try again later.",
    "CARD_FORMAT_ERROR": "The card number is not in the correct format. Please change the card number and try again.",
    "CARD_ALREADY_EXISTS": "The card number already exists. Please change the card number and try again.",
    "USER_NOT_FOUND_IN_ACS": "The user was not found in the access control system. Please contact your administrator.",
    "DELETE_PARTIAL_FAILURE": "{{entity}} could not be deleted. Try again later!",
    "REQUEST_BLOCKED": "Unable to perform action because it violates business logic. Please contact your administrator.",
    "EXPORT_FAILED": "Failed to export {{entity}}. Try again later!",
    "TRANSLATION_FAILED": "Failed to translate the content. Please try again later.",
    "ERROR_SENDING_EMAIL": "An error occurred while sending the email.",
    "GENERATE_AI_CONTENT_ERROR": "An error occurred while generating the content. Please try again later.",
    "SEND_OTP_FAILED": "Failed to send verification code by SMS. Please try again later.",
    "VALIDATION_ERROR": "Some of the input data is invalid. Please check the form and try again.",
    "AUTHENTICATION_ERROR": "Authentication failed. Please try logging out and back in.",
    "DESCRIPTION_TOO_LONG": "The description is too long. Please shorten it.",
    "IMAGES_LIMIT_EXCEEDED": "Too many images are being uploaded. Please remove some and try again.",
    "RESOURCE_NOT_FOUND": "The resource could not be found. Please try again later.",
    "BUILDING_NOT_FOUND": "The specified building could not be found. Please check the building ID and try again.",
    "ROOM_NOT_FOUND": "The specified room could not be found. Please check the room ID and try again.",
    "BOOKING_NOT_FOUND": "The specified booking could not be found. Please check the booking ID and try again.",
    "FLOOR_NOT_FOUND": "The specified floor could not be found. Please check the floor number and try again.",
    "ROOM_NOT_AVAILABLE": "The room is not available for booking at the selected time. Please choose a different time or room.",
    "ROOM_BLOCKED": "The room is blocked for bookings at the selected time. Please choose a different time or room.",
    "ENTITY_ALREADY_EXISTS": "This entity already exists. Please choose a different name or identifier.",
    "MEETING_ROOM_ALREADY_EXISTS": "A meeting room with this name already exists. Please choose a different name.",
    "BUILDING_ALREADY_EXISTS": "This building already exists and cannot be integrated twice.",
    "FOOD_MAX_USERS_REACHED": "You cannot add more users in accordance with the agreement with the restaurant provider. Get in touch with the restaurant to expand the limit.",
    "ACCESS_CODE_GENERATION_FAILED": "An error occurred while generating the access code. Please try again later.",
    "ONLY_ONE_SUPPLIER_ALLOWED": "The building can only have one active supplier at a time. Please change the company type of the current supplier before adding a new one.",
    "FORGOT_CARD_CODE_GENERATION_DISABLED": "Temporary access code generation is disabled for this building.",
    "FETCH_FAILED": "Failed to fetch data. Please try again later.",
    "SSO_REMOVED": "SSO domain {{domain}} deleted.",
    "LOW_FOOD_BALANCE": {
      "CRITICAL": "You can no longer have lunch!",
      "LOW": "Your lunch balance is getting low!",
      "MESSAGE": "Remember to top up your lunch balance to continue utilizing the building restaurant.",
      "ACTION": "Top up your balance here"
    },
    "PIN_MANAGEMENT_NOT_ALLOWED": "PIN management is not enabled for this building",
    "PIN_MANAGEMENT_NOT_ALLOWED_USER_ALREADY_SIGNED_IN": "As a company admin, you can only set a PIN code for users who have never signed in",
    "USER_NOT_FOUND": "Could not find the user. Please try again later!",
    "INVALID_PIN_CODE_FORMAT": "PIN code must be exactly 4 digits",
    "STARWATCH_USER_NOT_PROVISIONED": "The user hasn't been created in the access control system yet. Please try again later.",
    "USER_DELETED_FROM_ACS": "User successfully deleted from access control system",
    "ERROR_DELETING_USER_FROM_ACS": "Failed to delete user from access control system",
    "BOOKING_UPDATED": "{{entity}} was updated successfully",
    "BOOKING_UPDATE_FAILED": "Failed to update {{entity}}. Try again later!",
    "ALREADY_EXISTS_IN_ACS": "User with this email already exists in the access control system",
    "IMAGE_UPLOAD_SUCCESS": "Image uploaded successfully",
    "ALREADY_EXISTS_IN_ACS_NOTIFICATION": "User with this email already exists in the access control system. Duplicate users are not allowed — please contact support to resolve this.",
    "INVALID_EMAIL_IN_ACS": "The access control system does not accept this email address. Check that the user's email belongs to an existent domain.",
    "ACS_CONNECTIVITY_LOST": "Connection to the access control system has been lost. This functionality is unavailable until the connection is restored.",
    "FAILED_TO_DOWNLOAD": "Failed to download file. Please try again later!",
    "WALLET_NOT_DISABLED": "The user's wallet must be deactivated before it can be refunded.",
    "REFUND_REQUIRES_SUPPORT": "This refund must be handled by Welcome support. Please contact support to proceed.",
    "REFUND_ALREADY_PENDING": "A refund is already being processed for this user. Please wait for it to complete.",
    "REFUND_PENDING": "A refund is still being processed for this user. You can reactivate them once it has settled.",
    "WALLET_DISABLED": "This user is deactivated in the lunch system. Reactivate them before changing their deal.",
    "REFUND_FAILED": "The refund could not be created with the payment provider. Please try again later.",
    "NO_REFUNDABLE_TOPUP": "There is no eligible top-up to refund against for this user.",
    "INSUFFICIENT_BALANCE": "The refund amount exceeds the user's available balance.",
    "INVALID_AMOUNT": "The amount is invalid. Please enter an amount between 0.01 and 100 000 NOK.",
    "STARWATCH_INTEGRATION_NOT_ENABLED": "Starwatch integration is not enabled for this building.",
    "STARWATCH_ACCESS_GROUP_NOT_FOUND": "The Starwatch group wasn't found. Sync with Starwatch and try again.",
    "STARWATCH_ACCESS_GROUP_REMOVED": "This group was removed in Starwatch and can't be selected.",
    "STARWATCH_ROLE_NOT_FOUND": "The access group no longer exists. Refresh the page and try again.",
    "ACCESS_ROLE_MANAGEMENT_NOT_ENABLED": "Access role management is not enabled for this building."
  },
  "FOOD_LOGIN": {
    "COMPLETING_TITLE": "Connecting to kiosk…",
    "COMPLETING_BODY": "Please wait.",
    "DONE_TITLE": "You are now logged in on the kiosk!",
    "NO_ACCESS_TITLE": "No access",
    "NO_ACCESS_BODY": "This account does not have access to the food kiosk. Please contact an administrator of the restaurant company.",
    "EXPIRED_TITLE": "QR code expired",
    "EXPIRED_BODY": "Please scan the QR code again.",
    "ERROR_TITLE": "Something went wrong",
    "ERROR_BODY": "Please scan the QR code again.",
    "REDIRECT_COUNTDOWN": "Redirecting to portal in {{seconds}} seconds",
    "GO_TO_DASHBOARD": "Go to portal now",
    "CLOSE_TAB": "You can safely close this tab."
  },
  "ACS_CONNECTIVITY": {
    "BANNER_TEXT": "Connection to the access control system is down. Changes to access groups and cards are temporarily disabled.",
    "BUTTON_TOOLTIP": "Access control system connection is down."
  },
  "SNACK_CUTOFF": {
    "COMMON": {
      "CURRENT_SETTING": "Current setting:",
      "UNSAVED_SETTING": "New setting (unsaved):",
      "TYPES": {
        "NONE": {
          "LABEL": "No limit"
        },
        "ROLLING": {
          "LABEL": "Rolling deadline",
          "DESCRIPTION": "Calculated from the time of ordering."
        },
        "FIXED": {
          "LABEL": "Fixed deadline",
          "DESCRIPTION": "A fixed time each day decides the deadline."
        }
      },
      "ROLLING": {
        "AT_LEAST": "At least",
        "BEFORE_DELIVERY": "before the requested fulfillment time",
        "EARLIEST_ORDER": "Earliest order",
        "COUNTS_WEEKENDS": "Rolling deadlines count all hours, including weekends."
      },
      "FIXED": {
        "ORDERS_PLACED_BEFORE": "Orders placed before",
        "DEADLINE": "Deadline",
        "CAN_BE_COMPLETED_IN": "can be completed in",
        "WEEKDAYS_one": "weekday",
        "WEEKDAYS_other": "weekdays"
      },
      "TIMELINE": {
        "ORDERED_BEFORE": "Ordered <strong>before {{time}}</strong>",
        "ORDERED_AFTER": "Ordered <strong>after {{time}}</strong>"
      },
      "SUMMARY": {
        "MONDAY_EXAMPLE": "For Monday delivery, order before {{weekday}} {{time}} ({{calendarDays}} days before)."
      },
      "WEEKDAYS": {
        "MONDAY": "Monday",
        "TUESDAY": "Tuesday",
        "WEDNESDAY": "Wednesday",
        "THURSDAY": "Thursday",
        "FRIDAY": "Friday"
      }
    },
    "RESTAURANT": {
      "TITLE": "Limit when orders can be placed",
      "GENERAL_SETTING_INFO": "This is a general setting for the restaurant, but it can be overridden by individual menu items.",
      "SUMMARY": {
        "NONE": "No limit. Orders can be completed right away.",
        "ROLLING": "Orders must be placed at least {{amount}} {{unit}} before the requested fulfillment time.",
        "FIXED_SAME_DAY": "Orders placed before {{time}} can be completed the same day.",
        "FIXED_NEXT_DAY": "Orders placed before {{time}} can be completed at opening time the next day.",
        "FIXED_LATER": "Orders placed before {{time}} can be completed at opening time {{days}} days later.",
        "FIXED_NEXT_WEEKDAY": "Orders placed before {{time}} can be completed at opening time the next weekday.",
        "FIXED_WEEKDAYS_LATER": "Orders placed before {{time}} can be completed at opening time {{days}} weekdays later."
      },
      "TYPES": {
        "NONE": {
          "DESCRIPTION": "Orders can be placed at any time."
        },
        "ROLLING": {
          "DESCRIPTION": "Counted from the time of ordering."
        }
      }
    },
    "ITEM": {
      "TITLE": "Limit when the item can be ordered",
      "INHERITING_INFO": "This item follows the restaurant's standard setting. Customise it to set a different limit for this item only.",
      "OVERRIDING_INFO": "This item has its own limit, which replaces the restaurant's standard setting.",
      "CUSTOMISE": "Customise",
      "RESET": "Reset to standard",
      "SUMMARY": {
        "NONE": "No limit. The item can be ordered right away.",
        "ROLLING": "Item must be ordered at least {{amount}} {{unit}} before the requested fulfillment time.",
        "FIXED_SAME_DAY": "If the item is ordered before {{time}} it can be fulfilled the same day.",
        "FIXED_NEXT_DAY": "If the item is ordered before {{time}} it can be fulfilled at opening hour the next day.",
        "FIXED_LATER": "If the item is ordered before {{time}} it can be fulfilled at opening hour {{days}} days later.",
        "FIXED_NEXT_WEEKDAY": "If the item is ordered before {{time}} it can be fulfilled at opening hour the next weekday.",
        "FIXED_WEEKDAYS_LATER": "If the item is ordered before {{time}} it can be fulfilled at opening hour {{days}} weekdays later."
      },
      "TYPES": {
        "NONE": {
          "DESCRIPTION": "The item can be ordered at any time."
        }
      }
    },
    "ITEMS": {
      "ACTION": "Set order limit for all items",
      "TITLE": "Limit when the items can be ordered",
      "INFO_one": "The limit you save replaces the current limit on the item in this category.",
      "INFO_other": "The limit you save replaces the current limit on all items in this category.",
      "INFO_SELECTED_one": "The limit you save replaces the current limit on the selected item.",
      "INFO_SELECTED_other": "The limit you save replaces the current limit on all selected items.",
      "ACTION_SELECTED": "Set order limit for selected items",
      "SELECTED": "Selected",
      "RESET": "Reset all to restaurant's standard",
      "RESET_INFO": "Removes the items' own limits so they follow the restaurant's standard setting.",
      "TOO_MANY": "You can change the order limit for at most {{max}} items at a time. Select fewer items and try again.",
      "TYPES": {
        "NONE": {
          "DESCRIPTION": "The items can be ordered at any time."
        }
      },
      "OVERRIDE_INFO": "All items share the same custom cutoff",
      "DEFAULT_INFO": "All items follow the restaurant's default cutoff",
      "SUMMARY": {
        "NONE": "No limit. The items can be ordered right away.",
        "ROLLING": "Items must be ordered at least {{amount}} {{unit}} before the requested fulfillment time.",
        "FIXED_SAME_DAY": "If the items are ordered before {{time}} they can be fulfilled the same day.",
        "FIXED_NEXT_DAY": "If the items are ordered before {{time}} they can be fulfilled at opening hour the next day.",
        "FIXED_LATER": "If the items are ordered before {{time}} they can be fulfilled at opening hour {{days}} days later.",
        "FIXED_NEXT_WEEKDAY": "If the items are ordered before {{time}} they can be fulfilled at opening hour the next weekday.",
        "FIXED_WEEKDAYS_LATER": "If the items are ordered before {{time}} they can be fulfilled at opening hour {{days}} weekdays later."
      }
    }
  }
}
